var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoolveticaRgRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sun Sep  9 11:24:29 2018\n By Aleksey,,,\n(c) 1999-2018 Typodermic Fonts Inc.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "CoolveticaRg-Regular",
    horizAdvX: 503
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Coolvetica Rg",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 6 3 3 6 2 2 0 4",
    ascent: 767,
    descent: -233,
    xHeight: 492,
    capHeight: 664,
    bbox: "-444 -233 1103 921",
    underlineThickness: 20,
    underlinePosition: -163,
    unicodeRange: "U+0017-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 452,
    d: "M129 0q-97 0 -97 84v488q0 85 97 85h193q98 0 98 -85v-488q0 -84 -98 -84h-193zM368 572q0 39 -46 39h-193q-46 0 -46 -39v-488q0 -39 46 -39h193q46 0 46 39v488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 452,
    d: "M129 0q-97 0 -97 84v488q0 85 97 85h193q98 0 98 -85v-488q0 -84 -98 -84h-193zM368 572q0 39 -46 39h-193q-46 0 -46 -39v-488q0 -39 46 -39h193q46 0 46 39v488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0017",
    horizAdvX: 241
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 241
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 245,
    d: "M52 0v131h135v-131h-135zM86 184q-20 120 -29.5 222t-9.5 187q0 20 0.5 38t4.5 33h138q2 -17 3 -35.5t1 -38.5q0 -83 -9.5 -184.5t-29.5 -221.5h-69z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 289,
    d: "M23 414zM168 414v250h89v-250h-89zM23 414v250h89v-250h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 501,
    d: "M295 390h-88l-16 -116h89zM242 0l27 189h-88l-24 -189h-85l24 189h-87l9 85h89l15 116h-87l10 85h88l26 189h83l-25 -189h89l24 189h86l-25 -189h88l-12 -85h-87l-15 -116h88l-10 -85h-89l-25 -189h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 484,
    d: "M265 83q38 2 60.5 27t22.5 57q0 35 -22.5 59t-60.5 34v-177zM224 559q-37 -2 -58 -24t-21 -51q0 -30 20.5 -54.5t58.5 -29.5v159zM224 -55v39q-56 5 -95.5 19t-65 40t-37.5 64.5t-12 91.5h120q4 -32 10.5 -53t17 -34t25.5 -19.5t37 -9.5v193q-50 13 -87 29.5t-61.5 39 t-37 52t-12.5 70.5q0 39 15 73.5t41.5 60.5t62.5 41t79 16v44h41v-44q185 -6 194 -194h-118q-5 54 -23.5 73.5t-52.5 21.5v-172q67 -22 107.5 -43t62 -44.5t28.5 -51.5t7 -65q0 -44 -14.5 -79.5t-41.5 -61.5t-65 -41t-84 -17v-39h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 669,
    d: "M19 0zM70 -20l461 704h68l-462 -704h-67zM539 31q24 0 35.5 28t11.5 96q0 69 -11.5 97.5t-35.5 28.5q-23 0 -35 -28t-12 -97t12 -97t35 -28zM537 -22q-54 0 -83.5 42.5t-29.5 136.5t29.5 135t83.5 41t84.5 -41t30.5 -134t-30.5 -136.5t-84.5 -43.5zM134 384q24 0 35.5 28 t11.5 96q0 69 -11.5 97.5t-35.5 28.5q-23 0 -35 -28t-12 -97t12 -97t35 -28zM132 331q-54 0 -83.5 42.5t-29.5 136.5t29.5 135t83.5 41t84.5 -41t30.5 -134t-30.5 -136.5t-84.5 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 505,
    d: "M355 381h125v-179q0 -51 -16.5 -92.5t-46 -71t-70.5 -45.5t-91 -16q-57 0 -101 16t-74.5 44t-46.5 66t-16 82q0 23 6 47.5t16.5 45.5t25.5 37t32 24q-77 40 -77 139q0 42 18 76t51 58.5t79 38t102 13.5v-109q-68 0 -95 -21.5t-27 -70.5q0 -42 28 -62t94 -20v-94 q-60 0 -93 -24.5t-33 -75.5q0 -21 6.5 -39.5t20 -32.5t34 -22.5t49.5 -8.5q100 0 100 118v179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 145,
    d: "M23 414v250h89v-250h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 326,
    d: "M227 -143q-78 94 -119 209t-41 235q0 115 39 224.5t121 202.5h95q-61 -102 -91.5 -209.5t-30.5 -219.5t30.5 -223.5t91.5 -218.5h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 326,
    d: "M8 -143q61 107 91.5 218.5t30.5 223.5t-30.5 219.5t-91.5 209.5h95q82 -93 121 -202.5t39 -224.5q0 -120 -41 -235t-119 -209h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 539,
    d: "M365 197l-98 129l-95 -129l-90 63l96 136l-146 46l33 101l143 -46v167h118v-167l143 46l36 -101l-148 -46l96 -136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 523,
    d: "M211 107v189h-188v94h188v188h94v-188h189v-94h-189v-189h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 187,
    d: "M23 -106q38 10 57 34t20 72h-77v135h138v-102q0 -42 -7 -74t-23 -54.5t-42.5 -37.5t-65.5 -23v50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 280,
    d: "M13 257v101h248v-101h-248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "\xAD",
    horizAdvX: 280,
    d: "M13 257v101h248v-101h-248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 187,
    d: "M23 0v135h139v-135h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 300,
    d: "M-5 0l190 664h109l-192 -664h-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 490,
    d: "M247 82q24 0 41.5 13.5t29 43t17.5 77t6 115.5q0 69 -6 117t-17.5 77.5t-29 43t-41.5 13.5t-41.5 -13t-29.5 -42.5t-18 -77t-6 -116.5t6 -117t18 -78t29.5 -43t41.5 -13zM243 -23q-54 0 -96 21t-71 64.5t-44 111t-15 161.5q0 93 15 159.5t44 109t71 62.5t96 20t96.5 -20 t72 -62t45.5 -108t16 -159q0 -185 -61.5 -272.5t-168.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 296,
    d: "M140 0v459h-136v90q43 0 72 7t47.5 21.5t28 36t12.5 50.5h106v-664h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 465,
    d: "M4 0q0 46 7.5 86t29 79t60.5 79t103 86q36 25 59.5 45t37.5 38t20 36t6 39q0 25 -7 42t-19.5 27t-29.5 14t-36 4q-45 0 -71 -25.5t-26 -92.5h-125q0 108 56.5 168.5t159.5 60.5q50 0 91.5 -12t71 -36t46 -60.5t16.5 -85.5q0 -38 -10 -69t-32.5 -61t-59.5 -61t-90 -69 q-38 -28 -64 -60.5t-28 -58.5h286v-113h-452z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 479,
    d: "M184 389q42 0 68.5 7.5t41 20t20 29t5.5 34.5q0 50 -20.5 76t-65.5 26q-38 0 -63 -28.5t-25 -80.5h-121q0 48 15.5 87t44 67t68 43.5t86.5 15.5q43 0 80.5 -13t65.5 -37t44 -57.5t16 -73.5q0 -45 -19.5 -85.5t-58.5 -63.5q48 -20 73.5 -60.5t25.5 -103.5q0 -50 -17 -90 t-48 -67.5t-74 -42.5t-95 -15q-104 0 -161 58t-57 160h125q0 -58 25 -84.5t74 -26.5q41 0 68 28.5t27 81.5q0 58 -33.5 81t-114.5 23v91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 476,
    d: "M265 480l-136 -234h136v234zM262 0v145h-258v113l242 406h146v-418h75v-101h-75v-145h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 490,
    d: "M28 261l14 403h409v-110h-293l-6 -178q26 28 60.5 37.5t71.5 9.5q40 0 75.5 -14t61 -40.5t40.5 -65.5t15 -89q0 -54 -17 -97.5t-47 -74.5t-72 -48t-93 -17q-45 0 -84.5 14.5t-69.5 40t-47.5 61t-19.5 78.5h130q4 -42 28 -65t63 -23q54 0 76.5 34t22.5 91q0 52 -22.5 81 t-68.5 29q-35 0 -57 -14.5t-36 -42.5h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 487,
    d: "M246 82q22 0 39.5 9.5t29.5 26.5t18 40t6 50q0 57 -26 90.5t-69 33.5q-44 0 -71.5 -33.5t-27.5 -88.5q0 -57 26.5 -92.5t74.5 -35.5zM326 520q-5 62 -70 62q-54 0 -80.5 -51.5t-32.5 -158.5q23 27 54.5 44.5t81.5 17.5q39 0 73.5 -15t60 -43.5t40 -69t14.5 -92.5 q0 -51 -16 -94.5t-44.5 -75t-69 -49.5t-89.5 -18q-118 0 -175.5 84t-57.5 249q0 100 15.5 171t46 116.5t77 67t108.5 21.5q81 0 131.5 -42.5t61.5 -123.5h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 478,
    d: "M95 0q6 72 23 144t46.5 142t70 136.5t93.5 126.5h-324v115h465v-100q-112 -125 -172 -269.5t-68 -294.5h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 495,
    d: "M245 84q51 0 73.5 29t22.5 81q0 46 -23 75t-73 29t-72 -28t-22 -76q0 -52 21.5 -81t72.5 -29zM245 401q41 0 61 25t20 64q0 41 -20 65.5t-61 24.5t-61 -24.5t-20 -65.5q0 -39 20 -64t61 -25zM376 363q22 -10 40.5 -27.5t31.5 -39.5t20 -48t7 -54q0 -47 -14 -87t-42.5 -69 t-71.5 -45t-101 -16q-57 0 -100.5 16.5t-72.5 45t-43.5 67t-14.5 82.5q0 58 26 101t78 68q-41 21 -58 62.5t-17 83.5q0 39 15 72.5t42 58t64 38.5t81 14q49 0 86.5 -14t62.5 -38t37.5 -56.5t12.5 -70.5q0 -44 -15.5 -84t-53.5 -60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 487,
    d: "M238 331q44 0 71.5 33.5t27.5 88.5q0 57 -26.5 92.5t-74.5 35.5q-23 0 -40 -9.5t-29 -26.5t-18 -40t-6 -50q0 -57 26 -90.5t69 -33.5zM156 143q5 -62 70 -62q54 0 80.5 51.5t32.5 158.5q-23 -27 -54.5 -44.5t-81.5 -17.5q-39 0 -73.5 15t-60 43.5t-40 69t-14.5 92.5 q0 51 16 94.5t44.5 75t69 49.5t89.5 18q118 0 175.5 -84t57.5 -249q0 -100 -15.5 -171t-46 -116.5t-77 -67t-108.5 -21.5q-81 0 -131.5 42.5t-61.5 123.5h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 171,
    d: "M14 0v135h138v-135h-138zM14 339v134h138v-134h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 175,
    d: "M10 -106q38 10 57 34t20 72h-77v135h138v-102q0 -42 -7 -74t-23 -54.5t-42.5 -37.5t-65.5 -23v50zM10 339v134h138v-134h-138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 523,
    d: "M23 296v94l471 200v-104l-365 -143l365 -143v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 523,
    d: "M23 396v94h471v-94h-471zM23 196v94h471v-94h-471z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 523,
    d: "M23 96v104l365 143l-365 143v104l471 -200v-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 491,
    d: "M179 0v131h135v-131h-135zM183 193q0 59 9 95t35 66q15 18 34 31t35 27.5t27 32.5t11 47q0 49 -27 68.5t-64 19.5q-53 0 -73 -29.5t-25 -79.5h-129q0 49 16 89t45.5 68t71 43t91.5 15q108 0 170.5 -44t62.5 -143q0 -32 -6.5 -56t-19.5 -43.5t-32 -36.5t-43 -35 q-22 -17 -35.5 -31.5t-20.5 -30.5t-9 -33.5t-2 -39.5h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 708,
    d: "M336 154q45 0 72 43t27 110q0 41 -17.5 63t-51.5 22q-44 0 -74.5 -36t-30.5 -116q0 -42 16.5 -64t58.5 -22zM646 -15q-29 -25 -98 -46.5t-184 -21.5q-86 0 -151 25.5t-109 71t-66.5 109t-22.5 138.5q0 79 24 146t69.5 115.5t111 76t148.5 27.5q66 0 125 -16t103.5 -51 t70.5 -90t26 -132q0 -65 -16 -114.5t-41 -83t-56 -50.5t-62 -17q-42 0 -64 15.5t-27 37.5q-16 -27 -43.5 -38.5t-62.5 -11.5q-39 0 -66.5 14t-45 37t-25.5 52.5t-8 61.5q0 48 13 89.5t37.5 71.5t59 47.5t77.5 17.5q35 0 61 -15.5t37 -47.5l13 53h78l-52 -247q-6 -27 -6 -36 q0 -10 7.5 -14.5t15.5 -4.5q17 0 35 11t33 32.5t24.5 54t9.5 75.5q0 62 -17.5 106t-50.5 71.5t-79.5 40.5t-104.5 13q-67 0 -118.5 -25.5t-86 -66.5t-52.5 -93.5t-18 -106.5q0 -134 73 -204t205 -70q88 0 151 14t94 37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 643,
    d: "M319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "\u0410",
    horizAdvX: 643,
    d: "M319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "\u0391",
    horizAdvX: 643,
    d: "M319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 574,
    d: "M333 113q48 0 75 27t27 68q0 44 -26.5 64t-73.5 20h-178v-179h176zM157 549v-144h175q84 0 84 72q0 38 -21.5 55t-70.5 17h-167zM23 0v664h327q98 0 149 -48.5t51 -132.5q0 -43 -23 -76.5t-58 -47.5q21 -8 39.5 -20.5t32 -32t21.5 -46t8 -62.5q0 -91 -61 -144.5 t-187 -53.5h-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "\u0412",
    horizAdvX: 574,
    d: "M333 113q48 0 75 27t27 68q0 44 -26.5 64t-73.5 20h-178v-179h176zM157 549v-144h175q84 0 84 72q0 38 -21.5 55t-70.5 17h-167zM23 0v664h327q98 0 149 -48.5t51 -132.5q0 -43 -23 -76.5t-58 -47.5q21 -8 39.5 -20.5t32 -32t21.5 -46t8 -62.5q0 -91 -61 -144.5 t-187 -53.5h-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "\u0392",
    horizAdvX: 574,
    d: "M333 113q48 0 75 27t27 68q0 44 -26.5 64t-73.5 20h-178v-179h176zM157 549v-144h175q84 0 84 72q0 38 -21.5 55t-70.5 17h-167zM23 0v664h327q98 0 149 -48.5t51 -132.5q0 -43 -23 -76.5t-58 -47.5q21 -8 39.5 -20.5t32 -32t21.5 -46t8 -62.5q0 -91 -61 -144.5 t-187 -53.5h-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 613,
    d: "M608 228q-11 -57 -35 -103t-60.5 -79t-84.5 -51t-106 -18q-65 0 -121.5 22t-97.5 66t-64.5 108.5t-23.5 150.5q0 84 21.5 151.5t61.5 114t97.5 71.5t128.5 25q62 0 112.5 -18.5t87 -51t58 -76.5t26.5 -94h-139q-14 57 -54 88.5t-90 31.5q-87 0 -128 -62.5t-41 -171.5 q0 -111 40.5 -172.5t121.5 -61.5q62 0 99.5 33.5t51.5 96.5h139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "\u0421",
    horizAdvX: 613,
    d: "M608 228q-11 -57 -35 -103t-60.5 -79t-84.5 -51t-106 -18q-65 0 -121.5 22t-97.5 66t-64.5 108.5t-23.5 150.5q0 84 21.5 151.5t61.5 114t97.5 71.5t128.5 25q62 0 112.5 -18.5t87 -51t58 -76.5t26.5 -94h-139q-14 57 -54 88.5t-90 31.5q-87 0 -128 -62.5t-41 -171.5 q0 -111 40.5 -172.5t121.5 -61.5q62 0 99.5 33.5t51.5 96.5h139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 607,
    d: "M273 113q91 0 132 56.5t41 169.5q0 56 -10 96t-32.5 65.5t-57.5 37t-85 11.5h-103v-436h115zM23 0v664h257q67 0 124 -22.5t97.5 -64.5t63.5 -102t23 -136t-20.5 -138.5t-58.5 -107t-91 -69t-117 -24.5h-278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 532,
    d: "M23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "\u0415",
    horizAdvX: 532,
    d: "M23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "\u0395",
    horizAdvX: 532,
    d: "M23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 505,
    d: "M162 280v-280h-139v664h473v-116h-334v-151h292v-117h-292z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 658,
    d: "M518 0l-3 66q-24 -42 -77 -65.5t-122 -23.5t-124.5 29.5t-95 79t-60.5 114t-21 133.5q0 73 21 137.5t62 112.5t102 75.5t142 27.5q59 0 110.5 -17t90 -47t62 -71.5t27.5 -91.5h-140q-3 23 -16 43.5t-33 35.5t-46.5 24t-54.5 9q-84 0 -134.5 -62.5t-50.5 -181.5 q0 -41 10.5 -82.5t33 -75t57.5 -54.5t83 -21q34 0 63.5 12t51.5 33t34.5 48.5t12.5 58.5h-147v111h277v-357h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 587,
    d: "M421 0v298h-259v-298h-139v664h139v-250h259v250h140v-664h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "\u041D",
    horizAdvX: 587,
    d: "M421 0v298h-259v-298h-139v664h139v-250h259v250h140v-664h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "\u0397",
    horizAdvX: 587,
    d: "M421 0v298h-259v-298h-139v664h139v-250h259v250h140v-664h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 187,
    d: "M23 0v664h139v-664h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u04CF",
    horizAdvX: 187,
    d: "M23 0v664h139v-664h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u04C0",
    horizAdvX: 187,
    d: "M23 0v664h139v-664h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u0406",
    horizAdvX: 187,
    d: "M23 0v664h139v-664h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u0399",
    horizAdvX: 187,
    d: "M23 0v664h139v-664h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 454,
    d: "M288 664h139v-485q0 -91 -55 -146.5t-163 -55.5q-97 0 -151 51.5t-54 154.5v68h126v-61q0 -51 18 -75.5t61 -24.5q48 0 63.5 23.5t15.5 78.5v472z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "\u0408",
    horizAdvX: 454,
    d: "M288 664h139v-485q0 -91 -55 -146.5t-163 -55.5q-97 0 -151 51.5t-54 154.5v68h126v-61q0 -51 18 -75.5t61 -24.5q48 0 63.5 23.5t15.5 78.5v472z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 604,
    d: "M431 0l-197 299l-74 -73v-226h-137v664h137v-270l254 270h180l-262 -262l268 -402h-169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "\u041A",
    horizAdvX: 604,
    d: "M431 0l-197 299l-74 -73v-226h-137v664h137v-270l254 270h180l-262 -262l268 -402h-169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "\u039A",
    horizAdvX: 604,
    d: "M431 0l-197 299l-74 -73v-226h-137v664h137v-270l254 270h180l-262 -262l268 -402h-169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 501,
    d: "M23 0v664h139v-543h329v-121h-468z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 695,
    d: "M537 0v455l-124 -455h-138l-123 453v-453h-129v664h204l120 -487l120 487h200v-664h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "\u041C",
    horizAdvX: 695,
    d: "M537 0v455l-124 -455h-138l-123 453v-453h-129v664h204l120 -487l120 487h200v-664h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "\u039C",
    horizAdvX: 695,
    d: "M537 0v455l-124 -455h-138l-123 453v-453h-129v664h204l120 -487l120 487h200v-664h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 591,
    d: "M436 0l-284 446v-446h-129v664h147l264 -427v427h130v-664h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "\u039D",
    horizAdvX: 591,
    d: "M436 0l-284 446v-446h-129v664h147l264 -427v427h130v-664h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 670,
    d: "M334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5q0 -172 -81.5 -259 t-235.5 -87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "\u041E",
    horizAdvX: 670,
    d: "M334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5q0 -172 -81.5 -259 t-235.5 -87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "\u039F",
    horizAdvX: 670,
    d: "M334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5q0 -172 -81.5 -259 t-235.5 -87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 534,
    d: "M294 354q60 0 86.5 27.5t26.5 71.5q0 42 -26.5 69t-86.5 27h-132v-195h132zM23 0v664h293q49 0 88 -16.5t67 -46t43 -68.5t15 -84t-15 -83.5t-43 -66t-67 -43t-88 -15.5h-154v-241h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "\u0420",
    horizAdvX: 534,
    d: "M294 354q60 0 86.5 27.5t26.5 71.5q0 42 -26.5 69t-86.5 27h-132v-195h132zM23 0v664h293q49 0 88 -16.5t67 -46t43 -68.5t15 -84t-15 -83.5t-43 -66t-67 -43t-88 -15.5h-154v-241h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "\u03A1",
    horizAdvX: 534,
    d: "M294 354q60 0 86.5 27.5t26.5 71.5q0 42 -26.5 69t-86.5 27h-132v-195h132zM23 0v664h293q49 0 88 -16.5t67 -46t43 -68.5t15 -84t-15 -83.5t-43 -66t-67 -43t-88 -15.5h-154v-241h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 671,
    d: "M664 -14q0 -48 -15 -88t-42 -69t-64 -45.5t-81 -16.5q-41 0 -76 14.5t-60 41t-39 63.5t-14 81v21q-125 17 -191.5 101.5t-66.5 236.5q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5q0 -60 -16.5 -115t-48 -99t-78 -74 t-106.5 -39q0 -57 20 -82.5t52 -25.5q29 0 48.5 24.5t19.5 73.5h122zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 578,
    d: "M158 549v-177h174q56 0 79 25t23 63q0 39 -22.5 64t-74.5 25h-179zM410 0v171q0 48 -22 68.5t-82 20.5h-148v-260h-135v664h337q46 0 83.5 -14.5t64.5 -40t41.5 -61t14.5 -76.5q0 -54 -25.5 -95.5t-73.5 -58.5q44 -14 62.5 -43t18.5 -87v-188h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 563,
    d: "M399 468q-5 51 -37 76t-95 25q-59 0 -89 -20t-30 -58q0 -32 23.5 -51t79.5 -33q57 -14 108.5 -27.5t88.5 -30.5q22 -10 41 -23t33 -32t22 -45t8 -61q0 -55 -19.5 -94.5t-55 -65.5t-84 -38.5t-106.5 -12.5q-62 0 -113 13.5t-88 41.5t-58 69.5t-22 97.5h134 q2 -51 41.5 -80.5t106.5 -29.5q62 0 95.5 24.5t33.5 69.5q0 15 -4.5 27t-16 22.5t-31.5 19t-51 15.5q-62 14 -104.5 24.5t-77.5 26.5q-54 24 -82.5 62.5t-28.5 101.5q0 45 15 82.5t45.5 64.5t76 42t106.5 15q63 0 112 -16t82.5 -45t52 -69t20.5 -88h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "\u0405",
    horizAdvX: 563,
    d: "M399 468q-5 51 -37 76t-95 25q-59 0 -89 -20t-30 -58q0 -32 23.5 -51t79.5 -33q57 -14 108.5 -27.5t88.5 -30.5q22 -10 41 -23t33 -32t22 -45t8 -61q0 -55 -19.5 -94.5t-55 -65.5t-84 -38.5t-106.5 -12.5q-62 0 -113 13.5t-88 41.5t-58 69.5t-22 97.5h134 q2 -51 41.5 -80.5t106.5 -29.5q62 0 95.5 24.5t33.5 69.5q0 15 -4.5 27t-16 22.5t-31.5 19t-51 15.5q-62 14 -104.5 24.5t-77.5 26.5q-54 24 -82.5 62.5t-28.5 101.5q0 45 15 82.5t45.5 64.5t76 42t106.5 15q63 0 112 -16t82.5 -45t52 -69t20.5 -88h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 554,
    d: "M204 0v548h-200v116h540v-116h-201v-548h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "\u0422",
    horizAdvX: 554,
    d: "M204 0v548h-200v116h540v-116h-201v-548h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "\u03A4",
    horizAdvX: 554,
    d: "M204 0v548h-200v116h540v-116h-201v-548h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 586,
    d: "M416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 593,
    d: "M228 0l-225 664h148l145 -466l144 466h144l-225 -664h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 856,
    d: "M529 0l-103 432l-105 -432h-130l-188 664h148l109 -430l92 430h146l101 -430l108 430h142l-186 -664h-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 605,
    d: "M427 0l-127 228l-134 -228h-162l215 339l-203 325h164l120 -215l121 215h161l-202 -319l216 -345h-169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "\u0425",
    horizAdvX: 605,
    d: "M427 0l-127 228l-134 -228h-162l215 339l-203 325h164l120 -215l121 215h161l-202 -319l216 -345h-169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "\u03A7",
    horizAdvX: 605,
    d: "M427 0l-127 228l-134 -228h-162l215 339l-203 325h164l120 -215l121 215h161l-202 -319l216 -345h-169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 602,
    d: "M233 0v251l-230 413h162l140 -270l129 270h160l-222 -415v-249h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "\u04AE",
    horizAdvX: 602,
    d: "M233 0v251l-230 413h162l140 -270l129 270h160l-222 -415v-249h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "\u03A5",
    horizAdvX: 602,
    d: "M233 0v251l-230 413h162l140 -270l129 270h160l-222 -415v-249h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 532,
    d: "M4 0v118l345 430h-335v116h509v-109l-347 -437h347v-118h-519z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "\u0396",
    horizAdvX: 532,
    d: "M4 0v118l345 430h-335v116h509v-109l-347 -437h347v-118h-519z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 319,
    d: "M72 -130v849h228v-89h-113v-673h113v-87h-228z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 294,
    d: "M187 0l-192 664h109l190 -664h-107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 316,
    d: "M10 -130v87h115v673h-115v89h230v-849h-230z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 459,
    d: "M301 473l-73 87l-75 -87h-138l165 191h93l167 -191h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 478,
    d: "M0 -126v58h485v-58h-485z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 352,
    d: "M50 648l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 486,
    d: "M325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "\u0430",
    horizAdvX: 486,
    d: "M325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 524,
    d: "M259 93q49 0 80 41.5t31 107.5q0 152 -112 152q-109 0 -109 -160q0 -63 31.5 -102t78.5 -39zM26 0v672h128v-244q55 77 146 77q48 0 85.5 -18.5t63.5 -52.5t39.5 -80.5t13.5 -102.5q0 -62 -16 -111t-44 -83t-67.5 -52t-85.5 -18q-92 0 -137 73l-1 -60h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 481,
    d: "M469 178q-5 -43 -24.5 -78t-49.5 -60t-68.5 -39t-83.5 -14q-50 0 -91.5 16.5t-71.5 50t-46.5 83t-16.5 115.5t16.5 114t46.5 78.5t72.5 45.5t94.5 15q48 0 87.5 -13t69 -38t46.5 -60t20 -78h-131q-5 38 -30.5 59.5t-62.5 21.5q-21 0 -39 -7t-31.5 -23.5t-21.5 -44 t-8 -67.5q0 -81 29 -120t67 -39t65 21t31 61h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "\u0441",
    horizAdvX: 481,
    d: "M469 178q-5 -43 -24.5 -78t-49.5 -60t-68.5 -39t-83.5 -14q-50 0 -91.5 16.5t-71.5 50t-46.5 83t-16.5 115.5t16.5 114t46.5 78.5t72.5 45.5t94.5 15q48 0 87.5 -13t69 -38t46.5 -60t20 -78h-131q-5 38 -30.5 59.5t-62.5 21.5q-21 0 -39 -7t-31.5 -23.5t-21.5 -44 t-8 -67.5q0 -81 29 -120t67 -39t65 21t31 61h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 523,
    d: "M259 93q47 0 78.5 39t31.5 102q0 160 -109 160q-112 0 -112 -152q0 -66 31 -107.5t80 -41.5zM367 0l-1 60q-45 -73 -137 -73q-47 0 -86 18t-67 52t-44 83t-16 111q0 56 13.5 102.5t39.5 80.5t63.5 52.5t85.5 18.5q91 0 146 -77v244h128v-672h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    d: "M350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73t58.5 -220 h-339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "\u0435",
    d: "M350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73t58.5 -220 h-339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 295,
    d: "M77 0v400h-73v92h73q0 180 209 180v-105q-25 0 -40.5 -3.5t-24.5 -12.5t-12.5 -23.5t-3.5 -35.5h84v-92h-84v-400h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 530,
    d: "M262 98q48 0 79.5 36.5t31.5 99.5q0 158 -111 158t-111 -150q0 -66 31.5 -105t79.5 -39zM369 66q-14 -33 -50.5 -51.5t-84.5 -18.5q-61 0 -102.5 21.5t-67 56.5t-37 81t-11.5 94q0 57 17 104.5t46 81t68 52t84 18.5q92 0 138 -74v61h130v-497q0 -56 -19 -98.5t-52 -71 t-78 -43.5t-96 -15t-95 14.5t-75.5 41t-49.5 64.5t-18 86h121q0 -45 29.5 -69.5t78.5 -24.5q52 0 88 28.5t36 77.5v81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    d: "M341 0v305q0 56 -19.5 76.5t-64.5 20.5q-24 0 -43 -9.5t-32 -26t-19.5 -38t-6.5 -46.5v-282h-130v672h130v-244q7 16 21.5 30.5t33.5 24.5t42 16t48 6q76 0 123.5 -41.5t47.5 -115.5v-348h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "\u04BB",
    d: "M341 0v305q0 56 -19.5 76.5t-64.5 20.5q-24 0 -43 -9.5t-32 -26t-19.5 -38t-6.5 -46.5v-282h-130v672h130v-244q7 16 21.5 30.5t33.5 24.5t42 16t48 6q76 0 123.5 -41.5t47.5 -115.5v-348h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 192,
    d: "M29 0v492h130v-492h-130zM29 551v121h130v-121h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "\u0456",
    horizAdvX: 192,
    d: "M29 0v492h130v-492h-130zM29 551v121h130v-121h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 195,
    d: "M26 492h131v-525q0 -45 -15 -81.5t-41 -63t-61.5 -41t-76.5 -14.5q-101 0 -149.5 55.5t-48.5 150.5h122q0 -42 15.5 -66.5t53.5 -24.5q39 0 54.5 24t15.5 66v520zM26 551v121h131v-121h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "\u0458",
    horizAdvX: 195,
    d: "M26 492h131v-525q0 -45 -15 -81.5t-41 -63t-61.5 -41t-76.5 -14.5q-101 0 -149.5 55.5t-48.5 150.5h122q0 -42 15.5 -66.5t53.5 -24.5q39 0 54.5 24t15.5 66v520zM26 551v121h131v-121h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 483,
    d: "M328 0l-108 221l-63 -65v-156h-131v672h131v-367l162 187h159l-165 -181l161 -311h-146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 185,
    d: "M26 0v672h130v-672h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 754,
    d: "M603 0v298q0 45 -21 73t-56 28q-36 0 -59.5 -30t-23.5 -75v-294h-130v296q0 30 -4 49t-13.5 30t-24.5 15.5t-36 4.5q-79 0 -79 -96v-299h-130v492h122v-72q25 49 60 67t84 18q25 0 44.5 -4t35 -13.5t29.5 -24.5t28 -36q20 41 53 59.5t80 18.5q37 0 68 -12.5t53 -35 t34.5 -52.5t12.5 -64v-341h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    d: "M341 0v298q0 57 -19 77t-65 20q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-341h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 539,
    d: "M268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "\u043E",
    horizAdvX: 539,
    d: "M268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "\u03BF",
    horizAdvX: 539,
    d: "M268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 523,
    d: "M258 98q112 0 112 152q0 66 -31 107.5t-80 41.5q-47 0 -78.5 -39t-31.5 -102q0 -160 109 -160zM26 -233v725h125l1 -60q45 73 137 73q46 0 85.5 -18t67.5 -52t44 -83t16 -111q0 -56 -13.5 -102.5t-39.5 -80.5t-63.5 -52.5t-85.5 -18.5q-91 0 -146 77v-297h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "\u0440",
    horizAdvX: 523,
    d: "M258 98q112 0 112 152q0 66 -31 107.5t-80 41.5q-47 0 -78.5 -39t-31.5 -102q0 -160 109 -160zM26 -233v725h125l1 -60q45 73 137 73q46 0 85.5 -18t67.5 -52t44 -83t16 -111q0 -56 -13.5 -102.5t-39.5 -80.5t-63.5 -52.5t-85.5 -18.5q-91 0 -146 77v-297h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 513,
    d: "M735 -27q0 -48 -14.5 -86t-39.5 -64.5t-59 -41t-74 -14.5t-74 15t-59 42t-39 65t-14 83v89q-55 -74 -144 -74q-48 0 -85.5 18.5t-63.5 52.5t-39.5 80.5t-13.5 102.5q0 62 16 111t44 83t67 52t86 18q92 0 137 -73l1 60h125v-521q0 -51 16.5 -70t47.5 -19q29 0 43 21t14 70 h122zM260 98q109 0 109 160q0 63 -31.5 102t-78.5 39q-49 0 -80 -41.5t-31 -107.5q0 -152 112 -152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 321,
    d: "M26 0v492h122v-59q16 25 33.5 39t36 21.5t37.5 9.5t39 2h17v-133q-18 3 -36 3q-119 0 -119 -119v-256h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 472,
    d: "M322 343q-5 36 -26 50.5t-66 14.5q-37 0 -57 -9.5t-20 -31.5t20 -33.5t60 -22.5q42 -12 80 -21.5t67 -20.5q39 -16 60 -43.5t21 -75.5q0 -77 -54.5 -120t-160.5 -43q-114 0 -174.5 48t-62.5 123h134q0 -35 27 -54t75 -19q35 0 61 11.5t26 39.5q0 26 -23.5 37t-55.5 19 q-62 15 -100 27t-64 29q-35 22 -48.5 50t-13.5 61q0 31 11 58t36 46.5t64.5 30.5t95.5 11q107 0 157.5 -41t55.5 -121h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "\u0455",
    horizAdvX: 472,
    d: "M322 343q-5 36 -26 50.5t-66 14.5q-37 0 -57 -9.5t-20 -31.5t20 -33.5t60 -22.5q42 -12 80 -21.5t67 -20.5q39 -16 60 -43.5t21 -75.5q0 -77 -54.5 -120t-160.5 -43q-114 0 -174.5 48t-62.5 123h134q0 -35 27 -54t75 -19q35 0 61 11.5t26 39.5q0 26 -23.5 37t-55.5 19 q-62 15 -100 27t-64 29q-35 22 -48.5 50t-13.5 61q0 31 11 58t36 46.5t64.5 30.5t95.5 11q107 0 157.5 -41t55.5 -121h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 453,
    d: "M305 324h121v-140q0 -39 -11.5 -74.5t-36 -63t-62 -43.5t-89.5 -16q-54 0 -92 16t-62.5 43t-35.5 63t-11 76v440h128v-133h272v-92h-272v-202q0 -47 17.5 -72.5t57.5 -25.5q39 0 57.5 25t18.5 71v128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 500,
    d: "M346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 501,
    d: "M179 0l-176 492h145l103 -325l104 325h137l-177 -492h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "\u03BD",
    horizAdvX: 501,
    d: "M179 0l-176 492h145l103 -325l104 325h137l-177 -492h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 714,
    d: "M432 0l-78 286l-78 -286h-133l-140 492h137l80 -316l68 316h132l77 -316l75 316h134l-141 -492h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 496,
    d: "M329 0l-86 148l-84 -148h-156l165 251l-160 241h157l83 -143l84 143h151l-163 -241l168 -251h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "\u0445",
    horizAdvX: 496,
    d: "M329 0l-86 148l-84 -148h-156l165 251l-160 241h157l83 -143l84 143h151l-163 -241l168 -251h-159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 502,
    d: "M339 65q-14 -33 -50.5 -51.5t-82.5 -18.5q-39 0 -72 12.5t-57 36t-37.5 56t-13.5 73.5v319h130v-300q0 -92 83 -92q45 0 72.5 26t27.5 66v300h130v-505q0 -52 -17.5 -93t-48 -69t-72 -43t-88.5 -15q-109 0 -163 55t-54 151h121q0 -44 25.5 -69t76.5 -25q18 0 34 7.5 t28.5 21t20 33.5t7.5 44v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "\u0443",
    horizAdvX: 502,
    d: "M339 65q-14 -33 -50.5 -51.5t-82.5 -18.5q-39 0 -72 12.5t-57 36t-37.5 56t-13.5 73.5v319h130v-300q0 -92 83 -92q45 0 72.5 26t27.5 66v300h130v-505q0 -52 -17.5 -93t-48 -69t-72 -43t-88.5 -15q-109 0 -163 55t-54 151h121q0 -44 25.5 -69t76.5 -25q18 0 34 7.5 t28.5 21t20 33.5t7.5 44v80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 445,
    d: "M9 0v100l251 289h-234v103h400v-105l-251 -281h258v-106h-424z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 334,
    d: "M277 -131q-54 0 -87.5 9.5t-52 29t-24.5 49.5t-6 70q0 9 1 26t1.5 36t1.5 35.5t1 23.5q0 58 -17.5 81t-64.5 23v86q47 0 64.5 23.5t17.5 81.5q0 7 -1 23.5t-1.5 34.5t-1.5 35t-1 26q0 40 6 70t24.5 49.5t52 29t87.5 9.5h37v-82h-22q-44 0 -59.5 -14t-15.5 -49 q0 -45 3 -89t3 -89q0 -21 -9 -38.5t-23.5 -31t-34 -21.5t-40.5 -11q21 -3 40.5 -11t34 -21.5t23.5 -31t9 -38.5q0 -45 -3 -89.5t-3 -89.5q0 -35 15.5 -49t59.5 -14h22v-82h-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 338,
    d: "M116 -125v861h102v-861h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 330,
    d: "M10 -131v82h22q44 0 59.5 14t15.5 49q0 45 -3 89.5t-3 89.5q0 21 9 38.5t23.5 31t34 21.5t40.5 11q-21 3 -40.5 11t-34 21.5t-23.5 31t-9 38.5q0 45 3 89t3 89q0 35 -15.5 49t-59.5 14h-22v82h37q54 0 87.5 -9.5t52 -29t24.5 -49.5t6 -70q0 -9 -1 -26t-1.5 -35 t-1.5 -34.5t-1 -23.5q0 -58 17.5 -81.5t64.5 -23.5v-86q-47 0 -64.5 -23t-17.5 -81q0 -7 1 -23.5t1.5 -35.5t1.5 -36t1 -26q0 -40 -6 -70t-24.5 -49.5t-52 -29t-87.5 -9.5h-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 555,
    d: "M525 305q-32 -35 -67 -51t-81 -16q-30 0 -57.5 9t-54 20t-52.5 20t-52 9q-42 0 -74 -19t-62 -57v101q22 26 54 46.5t78 20.5q36 0 66.5 -9t57.5 -19.5t52 -19.5t50 -9q42 0 76.5 16.5t65.5 58.5v-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonbreakingspace",
    unicode: "\xA0",
    horizAdvX: 241
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 245,
    d: "M51 0zM193.003 664v-130.992h-134.991v130.992h134.991zM159.005 480.012q19.999 -119.993 29.499 -221.987q9.49902 -101.993 9.49902 -186.988q0 -19.999 -0.5 -37.998q-0.5 -17.998 -4.5 -32.9971h-137.991q-2 16.998 -3 35.4971t-1 38.498q0 82.9951 9.5 184.488 q9.49902 101.494 29.498 221.487h68.9951z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 481,
    d: "M222 0v70q-46 3 -84 21.5t-65 51.5t-41.5 81t-14.5 111q0 124 56 185t149 68v76h47v-76q87 -6 141 -56t60 -132h-131q-5 32 -23.5 52t-46.5 25v-296q28 7 47 27.5t22 52.5h131q-5 -39 -22 -72.5t-43 -58t-60.5 -40t-74.5 -19.5v-71h-47zM222 478q-33 -7 -54.5 -39 t-21.5 -101q0 -71 22 -109.5t54 -47.5v297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 482,
    d: "M26 0v484q0 91 55 146.5t163 55.5q48 0 87 -9.5t66 -33t42 -62.5t15 -99v-77h-131v76q0 46 -15 68.5t-64 22.5q-25 0 -40.5 -5.5t-24 -16.5t-11.5 -28t-3 -40v-133h290v-82h-290v-146h290v-121h-429z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 534,
    d: "M380 164q-25 -15 -53 -23.5t-59 -8.5t-59.5 8.5t-52.5 23.5l-63 -68l-72 72l68 63q-15 24 -23.5 52.5t-8.5 59.5t8.5 59t23.5 53l-67 62l71 71l61 -66q25 16 53.5 24.5t60.5 8.5q31 0 59.5 -8.5t53.5 -24.5l61 66l71 -71l-66 -61q16 -25 24.5 -53.5t8.5 -59.5 q0 -63 -33 -113l67 -62l-71 -72zM416 343q0 31 -11.5 58t-31.5 47t-47 31.5t-58 11.5t-57.5 -11.5t-46.5 -31.5t-31.5 -47t-11.5 -58t11.5 -57.5t31.5 -46.5t46.5 -31.5t57.5 -11.5t58 11.5t47 31.5t31.5 46.5t11.5 57.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 534,
    d: "M319 80v-80h-108v80h-145v76h145v61h-145v75h145v66l-194 306h117l130 -219l131 219h116l-192 -306v-66h145v-75h-145v-61h145v-76h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 338,
    d: "M116 -125v411h102v-411h-102zM218 339h-102v397h102v-397z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 535,
    d: "M364 492q-5 44 -31.5 64.5t-80.5 20.5q-100 0 -100 -68q0 -24 20.5 -40.5t66.5 -27.5q54 -13 93.5 -24t72.5 -25q19 -8 35 -19.5t28 -28t18.5 -40.5t6.5 -57q0 -34 -12 -61.5t-33 -48.5q17 -17 27 -43.5t10 -68.5q0 -40 -17 -71.5t-45.5 -53t-67 -32.5t-81.5 -11 q-243 0 -249 187h113q1 -43 35 -68t85 -25q56 0 84.5 20.5t28.5 54.5q0 28 -16.5 46t-69.5 29q-65 14 -112 28t-77 34.5t-44 50t-14 74.5q0 33 11.5 62t34.5 51q-20 20 -29.5 45.5t-9.5 63.5q0 35 13 65t38.5 52.5t64.5 35.5t91 13q102 0 161 -50t62 -134h-111zM344 190 q35 19 35 58q0 28 -16.5 46t-70.5 29q-27 5 -52.5 12t-47.5 14q-47 -15 -47 -62q0 -24 20.5 -40.5t65.5 -27.5q34 -8 61.5 -14.5t51.5 -14.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 421,
    d: "M50 579v124h130v-124h-130zM250 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 673,
    d: "M333 -9q-66 0 -123.5 27t-101 73.5t-68.5 108.5t-25 133q0 70 25 132.5t68.5 108.5t101 73t123.5 27t124 -27t101 -73t68 -108.5t25 -132.5q0 -71 -25 -133t-68 -108.5t-101 -73.5t-124 -27zM335 44q55 0 104 22.5t85.5 61.5t58 91.5t21.5 112.5q0 59 -21.5 111.5t-58 92 t-85.5 62.5t-104 23q-56 0 -105 -23t-85 -62.5t-57 -92t-21 -111.5q0 -60 21 -112.5t57 -91.5t85 -61.5t105 -22.5zM390 369q-4 19 -17.5 29.5t-30.5 10.5q-25 0 -40 -20.5t-15 -52.5q0 -82 53 -82q18 0 32 11.5t16 32.5h72q-5 -45 -39.5 -73t-83.5 -28q-60 0 -91.5 35.5 t-31.5 95.5q0 66 32 102.5t94 36.5q52 0 85 -26.5t36 -71.5h-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 328,
    d: "M209 433q-9 -10 -25.5 -13.5t-33 -7.5t-29 -12t-12.5 -26q0 -30 34 -30q29 0 46.5 17.5t18.5 41.5zM214 300q-4 12 -5 24q-13 -14 -33.5 -22.5t-48.5 -8.5q-46 0 -68 20.5t-22 53.5q0 29 9 46.5t25.5 27.5t39.5 14.5t50 8.5t36.5 10.5t9.5 20.5q0 13 -12.5 20.5 t-33.5 7.5q-24 0 -35 -11t-14 -29h-66q1 42 27.5 68.5t91.5 26.5t90 -28t25 -79v-171h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 465,
    d: "M13 145zM245 317l143 174l63 -68l-94 -106l94 -105l-63 -67zM13 317l143 174l63 -68l-94 -106l94 -105l-63 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 589,
    d: "M440 0v374h-415v118h533v-492h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 454,
    d: "M425 494q0 -40 -15 -74.5t-41 -60.5t-61 -41t-75 -15t-74.5 15t-60.5 41t-41 60.5t-15 74.5t15 75t41 61t60.5 41t74.5 15t75 -15t61 -41t41 -61t15 -75zM394 494q0 33 -12.5 62.5t-34.5 51.5t-51.5 34.5t-62.5 12.5t-62.5 -12.5t-51.5 -34.5t-34.5 -51.5t-12.5 -62.5 t12.5 -62.5t34.5 -51.5t51.5 -34.5t62.5 -12.5t62.5 12.5t51.5 34.5t34.5 51.5t12.5 62.5zM204 560v-47h46q14 0 20.5 6.5t6.5 16.5q0 11 -6 17.5t-20 6.5h-47zM270 415v45q0 13 -5.5 18.5t-21.5 5.5h-39v-69h-36v175h89q25 0 39.5 -14.5t14.5 -36.5q0 -14 -6.5 -24.5 t-19.5 -15.5q12 -4 16.5 -11.5t4.5 -22.5v-50h-36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 478,
    d: "M50 602v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 375,
    d: "M183 355q-41 0 -69.5 12.5t-46.5 34t-26.5 50.5t-8.5 62t8.5 62t26.5 50.5t46.5 33.5t69.5 12q40 0 69 -12t47.5 -33.5t27 -50.5t8.5 -62t-8.5 -62t-27 -50.5t-47.5 -34t-69 -12.5zM183 418q45 0 64 28.5t19 68.5t-19 68t-64 28t-64 -28t-19 -68t19 -68.5t64 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 523,
    d: "M23 0zM211 107v189h-188v94h188v188h94v-188h189v-94h-189v-189h-94zM23 -26v94h471v-94h-471z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 262,
    d: "M17 343zM17 343q0 23 3.5 43t14.5 39.5t30.5 39.5t51.5 43q35 26 48 42t13 37q0 25 -13 34t-33 9q-22 0 -35 -12.5t-13 -46.5h-63q0 54 28.5 84.5t79.5 30.5t82 -24t31 -73q0 -19 -5 -34.5t-16.5 -30.5t-29.5 -30.5t-45 -34.5q-20 -14 -32.5 -30.5t-13.5 -29.5h143v-56 h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 269,
    d: "M21 331zM107 537q42 0 54.5 13.5t12.5 32.5q0 51 -43 51q-19 0 -31.5 -14.5t-12.5 -40.5h-60q0 48 29.5 77.5t77.5 29.5q43 0 73 -25t30 -66q0 -23 -9.5 -43t-29.5 -31q23 -10 36 -30t13 -52q0 -51 -32 -79.5t-85 -28.5q-52 0 -80.5 29t-28.5 80h63q0 -55 49 -55 q20 0 34 14.5t14 40.5q0 29 -16.5 40.5t-57.5 11.5v45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 352,
    d: "M81 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 579,
    d: "M408 -100v696h-162v-696h-109v564q-62 9 -86 40t-24 68q0 24 9.5 44.5t30 36t51.5 24.5t74 9h372l-48 -91v-695h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 187,
    d: "M23 265v135h139v-135h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 207,
    d: "M50 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 178,
    d: "M17 343zM85 343v229h-68v45q43 0 60 14.5t20 43.5h53v-332h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 356,
    d: "M177 353q66 0 66 82t-66 82q-65 0 -65 -82t65 -82zM177 293q-66 0 -102.5 39.5t-36.5 102.5q0 65 37.5 104t101.5 39t101 -38.5t37 -104.5q0 -64 -37 -103t-101 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 465,
    d: "M13 145zM245 212l94 105l-94 106l63 68l143 -174l-143 -172zM13 212l94 105l-94 106l63 68l143 -174l-143 -172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 615,
    d: "M19 0zM30 -20l461 704h68l-462 -704h-67zM87 343v229h-68v45q43 0 60 14.5t20 43.5h53v-332h-65zM498 230l-68 -117h68v117zM497 -10v72h-129v57l121 203h73v-209h37v-51h-37v-72h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 623,
    d: "M19 0zM26 -20l461 704h68l-462 -704h-67zM87 343v229h-68v45q43 0 60 14.5t20 43.5h53v-332h-65zM381 -10q0 23 3.5 43t14.5 39.5t30.5 39.5t51.5 43q35 26 48 42t13 37q0 25 -13 34t-33 9q-22 0 -35 -12.5t-13 -46.5h-63q0 54 28.5 84.5t79.5 30.5t82 -24t31 -73 q0 -19 -5 -34.5t-16.5 -30.5t-29.5 -30.5t-45 -34.5q-20 -14 -32.5 -30.5t-13.5 -29.5h143v-56h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 633,
    d: "M19 0zM62 -20l461 704h68l-462 -704h-67zM515 230l-68 -117h68v117zM514 -10v72h-129v57l121 203h73v-209h37v-51h-37v-72h-65zM105 537q42 0 54.5 13.5t12.5 32.5q0 51 -43 51q-19 0 -31.5 -14.5t-12.5 -40.5h-60q0 48 29.5 77.5t77.5 29.5q43 0 73 -25t30 -66 q0 -23 -9.5 -43t-29.5 -31q23 -10 36 -30t13 -52q0 -51 -32 -79.5t-85 -28.5q-52 0 -80.5 29t-28.5 80h63q0 -55 49 -55q20 0 34 14.5t14 40.5q0 29 -16.5 40.5t-57.5 11.5v45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 491,
    d: "M18 0zM312.011 664v-130.992h-134.991v130.992h134.991zM308.011 471.012q0 -58.9961 -8.99902 -94.9941t-34.998 -65.9961q-14.999 -17.999 -33.998 -30.998q-18.998 -12.999 -34.998 -27.498q-15.998 -14.499 -26.998 -32.498q-10.999 -17.999 -10.999 -46.9971 q0 -48.9971 26.998 -68.4961q26.999 -19.499 63.9961 -19.499q52.9971 0 72.9961 29.498q19.998 29.499 24.998 79.4951h128.992q0 -48.9971 -15.999 -88.9941t-45.4971 -67.9961q-29.498 -27.998 -70.9961 -42.9971q-41.4971 -14.999 -91.4941 -14.999 q-107.993 0 -170.489 43.9971t-62.4961 142.991q0 31.998 6.49902 55.9971q6.5 23.998 19.499 43.4971t31.998 36.498t42.9971 34.9971q21.999 16.999 35.498 31.499q13.499 14.499 20.499 30.498q6.99902 15.999 8.99902 33.498q2 17.498 2 39.4971h121.992z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM166 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM257 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM322 851l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM495 846q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5 q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM161 751v124h130v-124h-130zM361 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM426 822q0 -47 -24 -71.5t-80 -24.5q-104 0 -104 96q0 46 25.5 71t78.5 25q56 0 80 -25t24 -71zM374 822q0 51 -52 51q-50 0 -50 -51q0 -49 50 -49q52 0 52 49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 885,
    d: "M374 0v137h-177l-47 -137h-147l237 664h625v-116h-353v-142h325v-117h-325v-171h369v-118h-507zM374 548h-44l-97 -297h141v297z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 613,
    d: "M15 0zM608 228q-11 -57 -35 -103t-60.5 -79t-84.5 -51t-106 -18q-65 0 -121.5 22t-97.5 66t-64.5 108.5t-23.5 150.5q0 84 21.5 151.5t61.5 114t97.5 71.5t128.5 25q62 0 112.5 -18.5t87 -51t58 -76.5t26.5 -94h-139q-14 57 -54 88.5t-90 31.5q-87 0 -128 -62.5 t-41 -171.5q0 -111 40.5 -172.5t121.5 -61.5q62 0 99.5 33.5t51.5 96.5h139zM268 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM110 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\u0400",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM110 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM201 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM277 851l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM114 751v124h130v-124h-130zM314 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\u0401",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM114 751v124h130v-124h-130zM314 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 187,
    d: "M0 0zM23 0v664h139v-664h-139zM-62 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 187,
    d: "M0 0zM23 0v664h139v-664h-139zM29 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 187,
    d: "M0 0zM23 0v664h139v-664h-139zM95 851l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 187,
    d: "M0 0zM23 0v664h139v-664h-139zM-66 751v124h130v-124h-130zM134 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\u0407",
    horizAdvX: 187,
    d: "M0 0zM23 0v664h139v-664h-139zM-66 751v124h130v-124h-130zM134 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\u03AA",
    horizAdvX: 187,
    d: "M0 0zM23 0v664h139v-664h-139zM-66 751v124h130v-124h-130zM134 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 607,
    d: "M23 0v282h-23v99h23v283h257q67 0 124 -22.5t97.5 -64.5t63.5 -102t23 -136t-20.5 -138.5t-58.5 -107t-91 -69t-117 -24.5h-278zM273 113q91 0 132 56.5t41 169.5q0 56 -10 96t-32.5 65.5t-57.5 37t-85 11.5h-103v-168h107v-99h-107v-169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\u0110",
    horizAdvX: 607,
    d: "M23 0v282h-23v99h23v283h257q67 0 124 -22.5t97.5 -64.5t63.5 -102t23 -136t-20.5 -138.5t-58.5 -107t-91 -69t-117 -24.5h-278zM273 113q91 0 132 56.5t41 169.5q0 56 -10 96t-32.5 65.5t-57.5 37t-85 11.5h-103v-168h107v-99h-107v-169h115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 591,
    d: "M23 0zM436 0l-284 446v-446h-129v664h147l264 -427v427h130v-664h-128zM469 846q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM179 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM270 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM336 851l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM506 844q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM175 751v124h130v-124h-130zM375 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 523,
    d: "M391 143l-134 133l-133 -133l-66 67l133 133l-133 133l66 66l133 -133l134 134l66 -67l-133 -133l133 -134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 670,
    d: "M111 -14l24 48q-59 44 -89.5 117t-30.5 175q0 84 21 151t62 113.5t100 71t136 24.5q33 0 62.5 -5t56.5 -14l24 48l74 -27l-28 -56q63 -45 95.5 -123t32.5 -186q0 -172 -81.5 -259t-235.5 -87q-38 0 -71 5.5t-62 16.5l-20 -40zM257 109q32 -13 77 -13q37 0 70 13.5 t57.5 41t38.5 70.5t14 102q0 126 -53 187zM396 553q-14 5 -29.5 7.5t-32.5 2.5q-88 0 -135 -61t-47 -179q0 -111 44 -167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM137 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM228 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM294 851l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM132 751v124h130v-124h-130zM332 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 602,
    d: "M3 0zM233 0v251l-230 413h162l140 -270l129 270h160l-222 -415v-249h-139zM243 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 534,
    d: "M294 251q49 0 81 27.5t32 70.5q0 42 -30.5 69t-82.5 27h-132v-194h132zM162 137v-137h-139v664h139v-103h167q44 0 80.5 -17t63 -46t41.5 -68t15 -84t-15 -83.5t-42 -66.5t-64.5 -43.5t-83.5 -15.5h-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 510,
    d: "M218 96q7 -1 14 -1.5t14 -0.5q57 0 90 31.5t33 80.5q0 33 -10.5 55.5t-29 36t-45 20t-58.5 7.5v82q31 1 50.5 7.5t31 17.5t16 26t4.5 33q0 47 -26 65.5t-61 18.5q-36 0 -61.5 -20t-25.5 -64v-491h-128v498q0 40 13.5 73.5t41 57.5t68.5 37t97 13q55 0 95 -13t66.5 -36 t39 -55t12.5 -70q0 -28 -5.5 -48t-15 -34t-21.5 -24t-25 -18q32 -14 52.5 -32.5t32 -39.5t16 -45.5t4.5 -50.5q0 -53 -15.5 -94.5t-44.5 -71t-70 -45t-92 -15.5q-38 0 -57 4v105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM87 648l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM178 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM244 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM417 674q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37 q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM90 579v124h130v-124h-130zM290 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM348 650q0 -47 -24 -71.5t-80 -24.5q-104 0 -104 96q0 46 25.5 71t78.5 25q56 0 80 -25t24 -71zM296 650 q0 51 -52 51q-50 0 -50 -51q0 -49 50 -49q52 0 52 49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 813,
    d: "M455 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-56 0 -108.5 18t-89.5 65q-36 -42 -82.5 -62.5t-113.5 -20.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5q0 24 -22.5 37.5 t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 97.5 -12.5t64.5 -37.5q62 50 156 50q114 0 172.5 -73t58.5 -220h-339zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34 t9.5 41.5zM660 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 481,
    d: "M17 0zM469 178q-5 -43 -24.5 -78t-49.5 -60t-68.5 -39t-83.5 -14q-50 0 -91.5 16.5t-71.5 50t-46.5 83t-16.5 115.5t16.5 114t46.5 78.5t72.5 45.5t94.5 15q48 0 87.5 -13t69 -38t46.5 -60t20 -78h-131q-5 38 -30.5 59.5t-62.5 21.5q-21 0 -39 -7t-31.5 -23.5t-21.5 -44 t-8 -67.5q0 -81 29 -120t67 -39t65 21t31 61h131zM197 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM95 648l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\u0450",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM95 648l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM186 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM253 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM91 579v124h130v-124h-130zM291 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\u0451",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM91 579v124h130v-124h-130zM291 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 272,
    d: "M0 0zM-20 648l47 82l207 -121l-31 -55zM69 0v492h130v-492h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 272,
    d: "M40 0zM71 554l-31 55l207 121l47 -82zM69 0v492h130v-492h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 272,
    d: "M0 0zM69 0v492h130v-492h-130zM137 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 272,
    d: "M0 0zM-24 579v124h130v-124h-130zM176 579v124h130v-124h-130zM69 0v492h130v-492h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\u0457",
    horizAdvX: 272,
    d: "M0 0zM-24 579v124h130v-124h-130zM176 579v124h130v-124h-130zM69 0v492h130v-492h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 519,
    d: "M402 615q45 -55 67.5 -138.5t22.5 -192.5q0 -86 -20.5 -143t-53 -91t-73.5 -48.5t-81 -14.5q-67 0 -114 19.5t-77 54t-44 80.5t-14 100q0 53 14.5 97.5t42 76.5t67.5 50t92 18q18 0 36 -1.5t35 -6.5t32 -16.5t29 -30.5q-4 36 -17.5 70.5t-33.5 64.5l-83 -48l-18 28l81 47 q-22 26 -46.5 47t-48.5 35h139q21 -13 42 -32l68 39l18 -28zM258 95q49 0 80 34t31 95q0 71 -27.5 109.5t-82.5 38.5q-56 0 -83.5 -37.5t-27.5 -102.5q0 -66 30 -101.5t80 -35.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    d: "M26 0zM341 0v298q0 57 -19 77t-65 20q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-341h-131zM435 674q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37 q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M114 648l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M205 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M270 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M443 674q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M109 579v124h130v-124h-130zM309 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 523,
    d: "M23 296v94h471v-94h-471zM189 490v135h139v-135h-139zM189 63v135h139v-135h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 539,
    d: "M106 -31l23 52q-55 32 -84.5 90.5t-29.5 134.5q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q20 0 39.5 -2.5t36.5 -7.5l23 50l63 -26l-23 -50q53 -32 82 -89t29 -134q0 -59 -17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5q-21 0 -41 2.5t-38 7.5l-24 -54zM236 99 q15 -3 32 -3q119 0 119 150q0 74 -31 113zM297 392l-14 2t-15 1q-119 0 -119 -149q0 -77 31 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM94 648l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM185 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM251 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM97 579v124h130v-124h-130zM297 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 502,
    d: "M26 0zM339 65q-14 -33 -50.5 -51.5t-82.5 -18.5q-39 0 -72 12.5t-57 36t-37.5 56t-13.5 73.5v319h130v-300q0 -92 83 -92q45 0 72.5 26t27.5 66v300h130v-505q0 -52 -17.5 -93t-48 -69t-72 -43t-88.5 -15q-109 0 -163 55t-54 151h121q0 -44 25.5 -69t76.5 -25 q18 0 34 7.5t28.5 21t20 33.5t7.5 44v80zM186 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 523,
    d: "M258 93q49 0 80 41.5t31 107.5q0 152 -112 152q-109 0 -109 -160q0 -31 8 -57t23 -44.5t35 -29t44 -10.5zM26 -233v905h128v-241q20 39 51.5 56.5t83.5 17.5q54 0 94 -21.5t67 -58t40 -84t13 -99.5q0 -56 -13.5 -103t-39.5 -80.5t-64 -52.5t-86 -19q-45 0 -84.5 17.5 t-61.5 57.5v-295h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 502,
    d: "M26 0zM339 65q-14 -33 -50.5 -51.5t-82.5 -18.5q-39 0 -72 12.5t-57 36t-37.5 56t-13.5 73.5v319h130v-300q0 -92 83 -92q45 0 72.5 26t27.5 66v300h130v-505q0 -52 -17.5 -93t-48 -69t-72 -43t-88.5 -15q-109 0 -163 55t-54 151h121q0 -44 25.5 -69t76.5 -25 q18 0 34 7.5t28.5 21t20 33.5t7.5 44v80zM90 579v124h130v-124h-130zM290 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM132 774v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM54 602v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM485 918q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM406 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82 q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 643,
    d: "M635 -207q-14 -11 -39 -18.5t-66 -7.5q-54 0 -82 23t-28 62q0 49 47 86.5t125 61.5h-108l-42 137h-245l-47 -137h-147l237 664h161l234 -664q-38 -17 -60.5 -29.5t-34 -23t-15 -20t-3.5 -19.5q0 -17 17.5 -25t46.5 -8q14 0 27 2.5t22 5.5v-90zM319 515h-1l-85 -264h169z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 486,
    d: "M455 -207q-14 -11 -39 -18.5t-66 -7.5q-54 0 -82 23t-28 62q0 49 47 86.5t125 61.5h-78q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20 t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311q-38 -17 -60.5 -29.5t-34 -23t-15 -20t-3.5 -19.5q0 -17 17.5 -25t46.5 -8q14 0 27 2.5t22 5.5v-90zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49 q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 613,
    d: "M15 0zM608 228q-11 -57 -35 -103t-60.5 -79t-84.5 -51t-106 -18q-65 0 -121.5 22t-97.5 66t-64.5 108.5t-23.5 150.5q0 84 21.5 151.5t61.5 114t97.5 71.5t128.5 25q62 0 112.5 -18.5t87 -51t58 -76.5t26.5 -94h-139q-14 57 -54 88.5t-90 31.5q-87 0 -128 -62.5 t-41 -171.5q0 -111 40.5 -172.5t121.5 -61.5q62 0 99.5 33.5t51.5 96.5h139zM241 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 481,
    d: "M17 0zM469 178q-5 -43 -24.5 -78t-49.5 -60t-68.5 -39t-83.5 -14q-50 0 -91.5 16.5t-71.5 50t-46.5 83t-16.5 115.5t16.5 114t46.5 78.5t72.5 45.5t94.5 15q48 0 87.5 -13t69 -38t46.5 -60t20 -78h-131q-5 38 -30.5 59.5t-62.5 21.5q-21 0 -39 -7t-31.5 -23.5t-21.5 -44 t-8 -67.5q0 -81 29 -120t67 -39t65 21t31 61h131zM175 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 613,
    d: "M15 0zM608 228q-11 -57 -35 -103t-60.5 -79t-84.5 -51t-106 -18q-65 0 -121.5 22t-97.5 66t-64.5 108.5t-23.5 150.5q0 84 21.5 151.5t61.5 114t97.5 71.5t128.5 25q62 0 112.5 -18.5t87 -51t58 -76.5t26.5 -94h-139q-14 57 -54 88.5t-90 31.5q-87 0 -128 -62.5 t-41 -171.5q0 -111 40.5 -172.5t121.5 -61.5q62 0 99.5 33.5t51.5 96.5h139zM261 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 481,
    d: "M17 0zM469 178q-5 -43 -24.5 -78t-49.5 -60t-68.5 -39t-83.5 -14q-50 0 -91.5 16.5t-71.5 50t-46.5 83t-16.5 115.5t16.5 114t46.5 78.5t72.5 45.5t94.5 15q48 0 87.5 -13t69 -38t46.5 -60t20 -78h-131q-5 38 -30.5 59.5t-62.5 21.5q-21 0 -39 -7t-31.5 -23.5t-21.5 -44 t-8 -67.5q0 -81 29 -120t67 -39t65 21t31 61h131zM187 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 613,
    d: "M15 0zM608 228q-11 -57 -35 -103t-60.5 -79t-84.5 -51t-106 -18q-65 0 -121.5 22t-97.5 66t-64.5 108.5t-23.5 150.5q0 84 21.5 151.5t61.5 114t97.5 71.5t128.5 25q62 0 112.5 -18.5t87 -51t58 -76.5t26.5 -94h-139q-14 57 -54 88.5t-90 31.5q-87 0 -128 -62.5 t-41 -171.5q0 -111 40.5 -172.5t121.5 -61.5q62 0 99.5 33.5t51.5 96.5h139zM265 733l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 481,
    d: "M17 0zM469 178q-5 -43 -24.5 -78t-49.5 -60t-68.5 -39t-83.5 -14q-50 0 -91.5 16.5t-71.5 50t-46.5 83t-16.5 115.5t16.5 114t46.5 78.5t72.5 45.5t94.5 15q48 0 87.5 -13t69 -38t46.5 -60t20 -78h-131q-5 38 -30.5 59.5t-62.5 21.5q-21 0 -39 -7t-31.5 -23.5t-21.5 -44 t-8 -67.5q0 -81 29 -120t67 -39t65 21t31 61h131zM191 561l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 607,
    d: "M23 0zM273 113q91 0 132 56.5t41 169.5q0 56 -10 96t-32.5 65.5t-57.5 37t-85 11.5h-103v-436h115zM23 0v664h257q67 0 124 -22.5t97.5 -64.5t63.5 -102t23 -136t-20.5 -138.5t-58.5 -107t-91 -69t-117 -24.5h-278zM214 733l-128 134l46 51l135 -118l135 118l46 -51 l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 654,
    d: "M16 0zM259 93q47 0 78.5 39t31.5 102q0 160 -109 160q-112 0 -112 -152q0 -66 31 -107.5t80 -41.5zM367 0l-1 60q-45 -73 -137 -73q-47 0 -86 18t-67 52t-44 83t-16 111q0 56 13.5 102.5t39.5 80.5t63.5 52.5t85.5 18.5q91 0 146 -77v244h128v-672h-125zM519 450 q38 10 57 34t20 72h-77v135h138v-102q0 -42 -7 -74t-23 -54.5t-42.5 -37.5t-65.5 -23v50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 523,
    d: "M372 0l-2 81q-10 -26 -25.5 -44t-34.5 -29t-39 -16t-39 -5q-47 0 -86 18t-67 52t-44 83t-16 111q0 56 13.5 102.5t39.5 80.5t63.5 52.5t85.5 18.5q21 0 43 -4t42 -15t36.5 -29.5t25.5 -46.5v125h-162v84h162v53h125v-53h29v-84h-29v-535h-121zM258 90q51 0 83 37t32 117 q0 73 -30 112.5t-85 39.5q-51 0 -81 -35.5t-30 -116.5t30 -117.5t81 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM76 774v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM62 602v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM438 918q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM414 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM213 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM191 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 532,
    d: "M527 -207q-14 -11 -39 -18.5t-66 -7.5q-54 0 -82 23t-28 62q0 49 47 86.5t125 61.5h-461v664h488v-116h-353v-142h325v-117h-325v-171h369v-118q-38 -17 -60.5 -29.5t-34 -23t-15 -20t-3.5 -19.5q0 -17 17.5 -25t46.5 -8q14 0 27 2.5t22 5.5v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    d: "M343 -207q-14 -11 -39 -18.5t-66 -7.5q-54 0 -82 23t-28 62q0 43 35.5 77t98.5 58h-1q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73t58.5 -220h-339q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-17 -55 -51.5 -91.5t-82.5 -53.5 q-38 -17 -60.5 -29.5t-34 -23t-15 -20t-3.5 -19.5q0 -17 17.5 -25t46.5 -8q14 0 27 2.5t22 5.5v-90zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM214 733l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM200 561l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 658,
    d: "M15 0zM518 0l-3 66q-24 -42 -77 -65.5t-122 -23.5t-124.5 29.5t-95 79t-60.5 114t-21 133.5q0 73 21 137.5t62 112.5t102 75.5t142 27.5q59 0 110.5 -17t90 -47t62 -71.5t27.5 -91.5h-140q-3 23 -16 43.5t-33 35.5t-46.5 24t-54.5 9q-84 0 -134.5 -62.5t-50.5 -181.5 q0 -41 10.5 -82.5t33 -75t57.5 -54.5t83 -21q34 0 63.5 12t51.5 33t34.5 48.5t12.5 58.5h-147v111h277v-357h-115zM500 918q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 530,
    d: "M16 0zM262 98q48 0 79.5 36.5t31.5 99.5q0 158 -111 158t-111 -150q0 -66 31.5 -105t79.5 -39zM369 66q-14 -33 -50.5 -51.5t-84.5 -18.5q-61 0 -102.5 21.5t-67 56.5t-37 81t-11.5 94q0 57 17 104.5t46 81t68 52t84 18.5q92 0 138 -74v61h130v-497q0 -56 -19 -98.5 t-52 -71t-78 -43.5t-96 -15t-95 14.5t-75.5 41t-49.5 64.5t-18 86h121q0 -45 29.5 -69.5t78.5 -24.5q52 0 88 28.5t36 77.5v81zM426 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5 t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 658,
    d: "M15 0zM518 0l-3 66q-24 -42 -77 -65.5t-122 -23.5t-124.5 29.5t-95 79t-60.5 114t-21 133.5q0 73 21 137.5t62 112.5t102 75.5t142 27.5q59 0 110.5 -17t90 -47t62 -71.5t27.5 -91.5h-140q-3 23 -16 43.5t-33 35.5t-46.5 24t-54.5 9q-84 0 -134.5 -62.5t-50.5 -181.5 q0 -41 10.5 -82.5t33 -75t57.5 -54.5t83 -21q34 0 63.5 12t51.5 33t34.5 48.5t12.5 58.5h-147v111h277v-357h-115zM282 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 530,
    d: "M16 0zM262 98q48 0 79.5 36.5t31.5 99.5q0 158 -111 158t-111 -150q0 -66 31.5 -105t79.5 -39zM369 66q-14 -33 -50.5 -51.5t-84.5 -18.5q-61 0 -102.5 21.5t-67 56.5t-37 81t-11.5 94q0 57 17 104.5t46 81t68 52t84 18.5q92 0 138 -74v61h130v-497q0 -56 -19 -98.5 t-52 -71t-78 -43.5t-96 -15t-95 14.5t-75.5 41t-49.5 64.5t-18 86h121q0 -45 29.5 -69.5t78.5 -24.5q52 0 88 28.5t36 77.5v81zM195 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 658,
    d: "M15 0zM518 0l-3 66q-24 -42 -77 -65.5t-122 -23.5t-124.5 29.5t-95 79t-60.5 114t-21 133.5q0 73 21 137.5t62 112.5t102 75.5t142 27.5q59 0 110.5 -17t90 -47t62 -71.5t27.5 -91.5h-140q-3 23 -16 43.5t-33 35.5t-46.5 24t-54.5 9q-84 0 -134.5 -62.5t-50.5 -181.5 q0 -41 10.5 -82.5t33 -75t57.5 -54.5t83 -21q34 0 63.5 12t51.5 33t34.5 48.5t12.5 58.5h-147v111h277v-357h-115zM275 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 530,
    d: "M16 0zM262 98q48 0 79.5 36.5t31.5 99.5q0 158 -111 158t-111 -150q0 -66 31.5 -105t79.5 -39zM369 66q-14 -33 -50.5 -51.5t-84.5 -18.5q-61 0 -102.5 21.5t-67 56.5t-37 81t-11.5 94q0 57 17 104.5t46 81t68 52t84 18.5q92 0 138 -74v61h130v-497q0 -56 -19 -98.5 t-52 -71t-78 -43.5t-96 -15t-95 14.5t-75.5 41t-49.5 64.5t-18 86h121q0 -45 29.5 -69.5t78.5 -24.5q52 0 88 28.5t36 77.5v81zM318.003 698.988q-61.9961 -5 -63.9961 -64.9961h63.9961v-81.9951h-114.993v53.9971q0 26.998 5.5 50.4971q5.5 23.498 18.499 41.4971 t35.498 29.498q22.498 11.5 55.4961 14.499v-42.9971z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 587,
    d: "M421 0v298h-259v-298h-139v664h139v-80h259v80h140v-664h-140zM421 414v79h-259v-79h259z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    d: "M156 538v-110q7 16 21.5 30.5t33.5 24.5t42 16t48 6q76 0 123.5 -41.5t47.5 -115.5v-348h-131v305q0 56 -19.5 76.5t-64.5 20.5q-24 0 -43 -9.5t-32 -26t-19.5 -38t-6.5 -46.5v-282h-130v538h-26v91h26v43h130v-43h165v-91h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u045B",
    d: "M156 538v-110q7 16 21.5 30.5t33.5 24.5t42 16t48 6q76 0 123.5 -41.5t47.5 -115.5v-348h-131v305q0 56 -19.5 76.5t-64.5 20.5q-24 0 -43 -9.5t-32 -26t-19.5 -38t-6.5 -46.5v-282h-130v538h-26v91h26v43h130v-43h165v-91h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 187,
    d: "M0 0zM23 0v664h139v-664h-139zM267 846q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 272,
    d: "M0 0zM310 674q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5zM69 0v492h130v-492h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 187,
    d: "M0 0zM23 0v664h139v-664h-139zM-95 774v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 272,
    d: "M0 0zM-53 602v91h381v-91h-381zM69 0v492h130v-492h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 187,
    d: "M0 0zM23 0v664h139v-664h-139zM257 918q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 272,
    d: "M0 0zM299 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82zM69 0v492h130v-492h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 187,
    d: "M162 -207q-14 -11 -39 -18.5t-66 -7.5q-54 0 -82 23t-28 62q0 49 47 86.5t125 61.5h-96v664h139v-664q-38 -17 -60.5 -29.5t-34 -23t-15 -20t-3.5 -19.5q0 -17 17.5 -25t46.5 -8q14 0 27 2.5t22 5.5v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 192,
    d: "M159 -207q-14 -11 -39 -18.5t-66 -7.5q-54 0 -82 23t-28 62q0 49 47 86.5t125 61.5h-87v492h130v-492q-38 -17 -60.5 -29.5t-34 -23t-15 -20t-3.5 -19.5q0 -17 17.5 -25t46.5 -8q14 0 27 2.5t22 5.5v-90zM29 551v121h130v-121h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 187,
    d: "M23 0zM23 0v664h139v-664h-139zM34 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 192,
    d: "M29 0v492h130v-492h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 641,
    d: "M23 0zM23 0v664h139v-664h-139zM475 664h139v-485q0 -91 -55 -146.5t-163 -55.5q-97 0 -151 51.5t-54 154.5v68h126v-61q0 -51 18 -75.5t61 -24.5q48 0 63.5 23.5t15.5 78.5v472z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 389,
    d: "M0 0zM29 0v492h130v-492h-130zM29 551v121h130v-121h-130zM220 492h131v-525q0 -45 -15 -81.5t-41 -63t-61.5 -41t-76.5 -14.5q-101 0 -149.5 55.5t-48.5 150.5h122q0 -42 15.5 -66.5t53.5 -24.5q39 0 54.5 24t15.5 66v520zM220 551v121h131v-121h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 604,
    d: "M23 0zM431 0l-197 299l-74 -73v-226h-137v664h137v-270l254 270h180l-262 -262l268 -402h-169zM257 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 483,
    d: "M26 0zM328 0l-108 221l-63 -65v-156h-131v672h131v-367l162 187h159l-165 -181l161 -311h-146zM188 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 501,
    d: "M5 0zM23 0v664h139v-543h329v-121h-468zM36 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 185,
    d: "M0 0zM26 0v672h130v-672h-130zM28 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 501,
    d: "M23 0zM23 0v664h139v-543h329v-121h-468zM211 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 185,
    d: "M26 0zM26 0v672h130v-672h-130zM39 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 501,
    d: "M23 0zM23 0v664h139v-543h329v-121h-468zM198 450q38 10 57 34t20 72h-77v135h138v-102q0 -42 -7 -74t-23 -54.5t-42.5 -37.5t-65.5 -23v50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 320,
    d: "M26 0zM26 0v672h130v-672h-130zM182 448q38 10 57 34t20 72h-77v135h138v-102q0 -42 -7 -74t-23 -54.5t-42.5 -37.5t-65.5 -23v50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 501,
    d: "M23 0v664h139v-287l141 63v-89l-141 -63v-167h329v-121h-468z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 261,
    d: "M62 0v266l-62 -27v88l62 27v318h130v-261l63 29v-89l-63 -28v-323h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 591,
    d: "M23 0zM436 0l-284 446v-446h-129v664h147l264 -427v427h130v-664h-128zM230 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    d: "M26 0zM341 0v298q0 57 -19 77t-65 20q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-341h-131zM186 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 591,
    d: "M23 0zM436 0l-284 446v-446h-129v664h147l264 -427v427h130v-664h-128zM249 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    d: "M26 0zM341 0v298q0 57 -19 77t-65 20q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-341h-131zM201 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 591,
    d: "M23 0zM436 0l-284 446v-446h-129v664h147l264 -427v427h130v-664h-128zM251 733l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    d: "M26 0zM341 0v298q0 57 -19 77t-65 20q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-341h-131zM218 561l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 591,
    d: "M434 3l-282 443v-446h-129v664h147l264 -427v427h130v-697q0 -45 -15 -81.5t-41 -63t-61.5 -41t-76.5 -14.5q-7 0 -12.5 0.5t-11.5 0.5v116q10 -2 17 -2q39 0 55 24t16 66v31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    d: "M341 309q-2 50 -21 68t-63 18q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-374q0 -45 -15 -81.5t-41 -63t-61.5 -41t-76.5 -14.5q-6 0 -11.5 0.5t-10.5 0.5v115q3 0 6.5 -0.5t8.5 -0.5q39 0 54.5 24 t15.5 66v337z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM146 774v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M80 602v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM498 918q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M433 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM224 774l136 147l44 -37l-143 -143zM381 741l-37 33l142 144l45 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M151 602l136 147l44 -37l-143 -143zM308 569l-37 33l142 144l45 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 964,
    d: "M516 0v24q-35 -23 -79 -35t-95 -12q-79 0 -140 25.5t-102.5 73.5t-63 117t-21.5 156q0 74 23 136t65 106.5t101 69.5t131 25q52 0 97.5 -14.5t83.5 -40.5v33h488v-116h-353v-142h325v-117h-325v-171h370v-118h-505zM345 96q37 0 68.5 16.5t53.5 46.5t34.5 71t12.5 90 q0 243 -184 243q-41 0 -74 -16.5t-56 -46.5t-35.5 -71t-12.5 -89q0 -51 14 -95.5t39.5 -77.5t61 -52t78.5 -19z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 867,
    d: "M507 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-120 0 -181 63q-66 -63 -174 -63q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q55 0 99 -16.5t76 -47.5q31 31 74 47.5t98 16.5 q114 0 172.5 -73t58.5 -220h-339zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM712 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 578,
    d: "M23 0zM158 549v-177h174q56 0 79 25t23 63q0 39 -22.5 64t-74.5 25h-179zM410 0v171q0 48 -22 68.5t-82 20.5h-148v-260h-135v664h337q46 0 83.5 -14.5t64.5 -40t41.5 -61t14.5 -76.5q0 -54 -25.5 -95.5t-73.5 -58.5q44 -14 62.5 -43t18.5 -87v-188h-136zM224 726l-31 55 l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 321,
    d: "M26 0zM26 0v492h122v-59q16 25 33.5 39t36 21.5t37.5 9.5t39 2h17v-133q-18 3 -36 3q-119 0 -119 -119v-256h-130zM106 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 578,
    d: "M23 0zM158 549v-177h174q56 0 79 25t23 63q0 39 -22.5 64t-74.5 25h-179zM410 0v171q0 48 -22 68.5t-82 20.5h-148v-260h-135v664h337q46 0 83.5 -14.5t64.5 -40t41.5 -61t14.5 -76.5q0 -54 -25.5 -95.5t-73.5 -58.5q44 -14 62.5 -43t18.5 -87v-188h-136zM235 -190 q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 321,
    d: "M26 0zM26 0v492h122v-59q16 25 33.5 39t36 21.5t37.5 9.5t39 2h17v-133q-18 3 -36 3q-119 0 -119 -119v-256h-130zM40 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 578,
    d: "M23 0zM158 549v-177h174q56 0 79 25t23 63q0 39 -22.5 64t-74.5 25h-179zM410 0v171q0 48 -22 68.5t-82 20.5h-148v-260h-135v664h337q46 0 83.5 -14.5t64.5 -40t41.5 -61t14.5 -76.5q0 -54 -25.5 -95.5t-73.5 -58.5q44 -14 62.5 -43t18.5 -87v-188h-136zM219 733 l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 321,
    d: "M0 0zM26 0v492h122v-59q16 25 33.5 39t36 21.5t37.5 9.5t39 2h17v-133q-18 3 -36 3q-119 0 -119 -119v-256h-130zM109 561l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 563,
    d: "M6 0zM399 468q-5 51 -37 76t-95 25q-59 0 -89 -20t-30 -58q0 -32 23.5 -51t79.5 -33q57 -14 108.5 -27.5t88.5 -30.5q22 -10 41 -23t33 -32t22 -45t8 -61q0 -55 -19.5 -94.5t-55 -65.5t-84 -38.5t-106.5 -12.5q-62 0 -113 13.5t-88 41.5t-58 69.5t-22 97.5h134 q2 -51 41.5 -80.5t106.5 -29.5q62 0 95.5 24.5t33.5 69.5q0 15 -4.5 27t-16 22.5t-31.5 19t-51 15.5q-62 14 -104.5 24.5t-77.5 26.5q-54 24 -82.5 62.5t-28.5 101.5q0 45 15 82.5t45.5 64.5t76 42t106.5 15q63 0 112 -16t82.5 -45t52 -69t20.5 -88h-132zM216 726l-31 55 l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 472,
    d: "M9 0zM322 343q-5 36 -26 50.5t-66 14.5q-37 0 -57 -9.5t-20 -31.5t20 -33.5t60 -22.5q42 -12 80 -21.5t67 -20.5q39 -16 60 -43.5t21 -75.5q0 -77 -54.5 -120t-160.5 -43q-114 0 -174.5 48t-62.5 123h134q0 -35 27 -54t75 -19q35 0 61 11.5t26 39.5q0 26 -23.5 37 t-55.5 19q-62 15 -100 27t-64 29q-35 22 -48.5 50t-13.5 61q0 31 11 58t36 46.5t64.5 30.5t95.5 11q107 0 157.5 -41t55.5 -121h-125zM171 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 563,
    d: "M6 0zM399 468q-5 51 -37 76t-95 25q-59 0 -89 -20t-30 -58q0 -32 23.5 -51t79.5 -33q57 -14 108.5 -27.5t88.5 -30.5q22 -10 41 -23t33 -32t22 -45t8 -61q0 -55 -19.5 -94.5t-55 -65.5t-84 -38.5t-106.5 -12.5q-62 0 -113 13.5t-88 41.5t-58 69.5t-22 97.5h134 q2 -51 41.5 -80.5t106.5 -29.5q62 0 95.5 24.5t33.5 69.5q0 15 -4.5 27t-16 22.5t-31.5 19t-51 15.5q-62 14 -104.5 24.5t-77.5 26.5q-54 24 -82.5 62.5t-28.5 101.5q0 45 15 82.5t45.5 64.5t76 42t106.5 15q63 0 112 -16t82.5 -45t52 -69t20.5 -88h-132zM228 -190 q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u0218",
    horizAdvX: 563,
    d: "M6 0zM399 468q-5 51 -37 76t-95 25q-59 0 -89 -20t-30 -58q0 -32 23.5 -51t79.5 -33q57 -14 108.5 -27.5t88.5 -30.5q22 -10 41 -23t33 -32t22 -45t8 -61q0 -55 -19.5 -94.5t-55 -65.5t-84 -38.5t-106.5 -12.5q-62 0 -113 13.5t-88 41.5t-58 69.5t-22 97.5h134 q2 -51 41.5 -80.5t106.5 -29.5q62 0 95.5 24.5t33.5 69.5q0 15 -4.5 27t-16 22.5t-31.5 19t-51 15.5q-62 14 -104.5 24.5t-77.5 26.5q-54 24 -82.5 62.5t-28.5 101.5q0 45 15 82.5t45.5 64.5t76 42t106.5 15q63 0 112 -16t82.5 -45t52 -69t20.5 -88h-132zM228 -190 q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 472,
    d: "M9 0zM322 343q-5 36 -26 50.5t-66 14.5q-37 0 -57 -9.5t-20 -31.5t20 -33.5t60 -22.5q42 -12 80 -21.5t67 -20.5q39 -16 60 -43.5t21 -75.5q0 -77 -54.5 -120t-160.5 -43q-114 0 -174.5 48t-62.5 123h134q0 -35 27 -54t75 -19q35 0 61 11.5t26 39.5q0 26 -23.5 37 t-55.5 19q-62 15 -100 27t-64 29q-35 22 -48.5 50t-13.5 61q0 31 11 58t36 46.5t64.5 30.5t95.5 11q107 0 157.5 -41t55.5 -121h-125zM193 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u0219",
    horizAdvX: 472,
    d: "M9 0zM322 343q-5 36 -26 50.5t-66 14.5q-37 0 -57 -9.5t-20 -31.5t20 -33.5t60 -22.5q42 -12 80 -21.5t67 -20.5q39 -16 60 -43.5t21 -75.5q0 -77 -54.5 -120t-160.5 -43q-114 0 -174.5 48t-62.5 123h134q0 -35 27 -54t75 -19q35 0 61 11.5t26 39.5q0 26 -23.5 37 t-55.5 19q-62 15 -100 27t-64 29q-35 22 -48.5 50t-13.5 61q0 31 11 58t36 46.5t64.5 30.5t95.5 11q107 0 157.5 -41t55.5 -121h-125zM193 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 563,
    d: "M6 0zM399 468q-5 51 -37 76t-95 25q-59 0 -89 -20t-30 -58q0 -32 23.5 -51t79.5 -33q57 -14 108.5 -27.5t88.5 -30.5q22 -10 41 -23t33 -32t22 -45t8 -61q0 -55 -19.5 -94.5t-55 -65.5t-84 -38.5t-106.5 -12.5q-62 0 -113 13.5t-88 41.5t-58 69.5t-22 97.5h134 q2 -51 41.5 -80.5t106.5 -29.5q62 0 95.5 24.5t33.5 69.5q0 15 -4.5 27t-16 22.5t-31.5 19t-51 15.5q-62 14 -104.5 24.5t-77.5 26.5q-54 24 -82.5 62.5t-28.5 101.5q0 45 15 82.5t45.5 64.5t76 42t106.5 15q63 0 112 -16t82.5 -45t52 -69t20.5 -88h-132zM223 733l-128 134 l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 472,
    d: "M9 0zM322 343q-5 36 -26 50.5t-66 14.5q-37 0 -57 -9.5t-20 -31.5t20 -33.5t60 -22.5q42 -12 80 -21.5t67 -20.5q39 -16 60 -43.5t21 -75.5q0 -77 -54.5 -120t-160.5 -43q-114 0 -174.5 48t-62.5 123h134q0 -35 27 -54t75 -19q35 0 61 11.5t26 39.5q0 26 -23.5 37 t-55.5 19q-62 15 -100 27t-64 29q-35 22 -48.5 50t-13.5 61q0 31 11 58t36 46.5t64.5 30.5t95.5 11q107 0 157.5 -41t55.5 -121h-125zM185 561l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u0162",
    horizAdvX: 554,
    d: "M4 0zM204 0v548h-200v116h540v-116h-201v-548h-139zM223 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u021A",
    horizAdvX: 554,
    d: "M4 0zM204 0v548h-200v116h540v-116h-201v-548h-139zM223 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u0163",
    horizAdvX: 453,
    d: "M26 0zM305 324h121v-140q0 -39 -11.5 -74.5t-36 -63t-62 -43.5t-89.5 -16q-54 0 -92 16t-62.5 43t-35.5 63t-11 76v440h128v-133h272v-92h-272v-202q0 -47 17.5 -72.5t57.5 -25.5q39 0 57.5 25t18.5 71v128zM173 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5 t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u021B",
    horizAdvX: 453,
    d: "M26 0zM305 324h121v-140q0 -39 -11.5 -74.5t-36 -63t-62 -43.5t-89.5 -16q-54 0 -92 16t-62.5 43t-35.5 63t-11 76v440h128v-133h272v-92h-272v-202q0 -47 17.5 -72.5t57.5 -25.5q39 0 57.5 25t18.5 71v128zM173 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5 t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 554,
    d: "M4 0zM204 0v548h-200v116h540v-116h-201v-548h-139zM225 733l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 580,
    d: "M26 0zM305 324h121v-140q0 -39 -11.5 -74.5t-36 -63t-62 -43.5t-89.5 -16q-54 0 -92 16t-62.5 43t-35.5 63t-11 76v440h128v-133h272v-92h-272v-202q0 -47 17.5 -72.5t57.5 -25.5q39 0 57.5 25t18.5 71v128zM443 450q38 10 57 34t20 72h-77v135h138v-102q0 -42 -7 -74 t-23 -54.5t-42.5 -37.5t-65.5 -23v50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 554,
    d: "M204 0v248h-94v101h94v199h-200v116h540v-116h-201v-199h95v-101h-95v-248h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 453,
    d: "M154 261v-63q0 -47 17.5 -72.5t57.5 -25.5q39 0 57.5 25t18.5 71v18h121v-30q0 -39 -11.5 -74.5t-36 -63t-62 -43.5t-89.5 -16q-54 0 -92 16t-62.5 43t-35.5 63t-11 76v440h128v-133h272v-92h-272v-52h265v-87h-265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM467 846q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5 t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM432 674q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37 q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM104 774v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM61 602v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM456 918q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5 t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM413 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82 q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM398 822q0 -47 -24 -71.5t-80 -24.5q-104 0 -104 96q0 46 25.5 71t78.5 25q56 0 80 -25t24 -71zM346 822q0 51 -52 51 q-50 0 -50 -51q0 -49 50 -49q52 0 52 49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM355 650q0 -47 -24 -71.5t-80 -24.5q-104 0 -104 96q0 46 25.5 71t78.5 25q56 0 80 -25t24 -71zM303 650 q0 51 -52 51q-50 0 -50 -51q0 -49 50 -49q52 0 52 49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM174 774l136 147l44 -37l-143 -143zM331 741l-37 33l142 144l45 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM131 602l136 147l44 -37l-143 -143zM288 569l-37 33l142 144l45 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 586,
    d: "M422 -207q-14 -11 -39 -18.5t-66 -7.5q-54 0 -82 23t-28 62t30 71t83 56q-8 -1 -17 -1.5t-18 -0.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443h142v-443q0 -86 -35.5 -141t-103.5 -81q-37 -17 -59 -29.5t-33 -22.5t-14.5 -19.5 t-3.5 -19.5q0 -17 17.5 -25t46.5 -8q14 0 27 2.5t22 5.5v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 500,
    d: "M469 -207q-14 -11 -39 -18.5t-66 -7.5q-54 0 -82 23t-28 62q0 49 47 86.5t125 61.5h-80v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492q-38 -17 -60.5 -29.5t-34 -23t-15 -20 t-3.5 -19.5q0 -17 17.5 -25t46.5 -8q14 0 27 2.5t22 5.5v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 856,
    d: "M3 0zM529 0l-103 432l-105 -432h-130l-188 664h148l109 -430l92 430h146l101 -430l108 430h142l-186 -664h-134zM429 851l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 714,
    d: "M3 0zM432 0l-78 286l-78 -286h-133l-140 492h137l80 -316l68 316h132l77 -316l75 316h134l-141 -492h-133zM358 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 602,
    d: "M3 0zM233 0v251l-230 413h162l140 -270l129 270h160l-222 -415v-249h-139zM310 851l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 502,
    d: "M26 0zM339 65q-14 -33 -50.5 -51.5t-82.5 -18.5q-39 0 -72 12.5t-57 36t-37.5 56t-13.5 73.5v319h130v-300q0 -92 83 -92q45 0 72.5 26t27.5 66v300h130v-505q0 -52 -17.5 -93t-48 -69t-72 -43t-88.5 -15q-109 0 -163 55t-54 151h121q0 -44 25.5 -69t76.5 -25 q18 0 34 7.5t28.5 21t20 33.5t7.5 44v80zM252 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 602,
    d: "M3 0zM233 0v251l-230 413h162l140 -270l129 270h160l-222 -415v-249h-139zM140 751v124h130v-124h-130zM340 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u03AB",
    horizAdvX: 602,
    d: "M3 0zM233 0v251l-230 413h162l140 -270l129 270h160l-222 -415v-249h-139zM140 751v124h130v-124h-130zM340 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 532,
    d: "M4 0zM4 0v118l345 430h-335v116h509v-109l-347 -437h347v-118h-519zM201 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 445,
    d: "M9 0zM9 0v100l251 289h-234v103h400v-105l-251 -281h258v-106h-424zM158 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 532,
    d: "M4 0zM4 0v118l345 430h-335v116h509v-109l-347 -437h347v-118h-519zM207 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 445,
    d: "M9 0zM9 0v100l251 289h-234v103h400v-105l-251 -281h258v-106h-424zM163 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 532,
    d: "M4 0zM4 0v118l345 430h-335v116h509v-109l-347 -437h347v-118h-519zM215 733l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 445,
    d: "M9 0zM9 0v100l251 289h-234v103h400v-105l-251 -281h258v-106h-424zM171 561l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018E",
    unicode: "\u018E",
    horizAdvX: 532,
    d: "M3 0v115h371v175h-327v115h327v146h-355v113h486v-664h-502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u018F",
    horizAdvX: 670,
    d: "M338 -23q-86 0 -146 27.5t-97 77t-53.5 117.5t-16.5 149v14.5t1 15.5h492q-8 94 -53.5 141t-125.5 47q-63 0 -102.5 -29.5t-59.5 -87.5h-141q26 113 101 175t199 62q76 0 135 -24.5t99.5 -71t61 -114t20.5 -152.5q0 -173 -82 -260t-232 -87zM336 93q38 0 70 11t56 34 t38.5 58t17.5 84h-365q10 -98 59 -142.5t124 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u04D8",
    horizAdvX: 670,
    d: "M338 -23q-86 0 -146 27.5t-97 77t-53.5 117.5t-16.5 149v14.5t1 15.5h492q-8 94 -53.5 141t-125.5 47q-63 0 -102.5 -29.5t-59.5 -87.5h-141q26 113 101 175t199 62q76 0 135 -24.5t99.5 -71t61 -114t20.5 -152.5q0 -173 -82 -260t-232 -87zM336 93q38 0 70 11t56 34 t38.5 58t17.5 84h-365q10 -98 59 -142.5t124 -44.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 538,
    d: "M22 -173v112h72q26 0 42.5 19t22.5 61l50 345h-70v101h84l4 24q7 51 28 86t51 56.5t68 31t79 9.5h57v-112h-73q-26 0 -42.5 -19t-22.5 -61l-2 -15h87v-101h-102l-51 -354q-8 -51 -28.5 -86t-50.5 -56.5t-68 -31t-79 -9.5h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0194",
    unicode: "\u0194",
    horizAdvX: 593,
    d: "M296 -233q-76 0 -113 30t-37 107q0 14 2.5 31.5t11.5 47.5t26.5 76t47.5 118l-228 487h145l145 -342l145 342h144l-228 -486q31 -72 48.5 -118.5t26.5 -76t11 -47t2 -31.5q0 -77 -36.5 -107.5t-112.5 -30.5zM296 46q-15 -31 -24.5 -54.5t-15.5 -41.5t-8.5 -32.5 t-2.5 -26.5q0 -28 12 -42t39 -14t38.5 14t11.5 42q0 12 -2.5 26t-8 32.5t-15 42t-24.5 54.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni019D",
    unicode: "\u019D",
    horizAdvX: 591,
    d: "M440 0l-288 452v-485q0 -45 -15 -81.5t-41 -63t-61.5 -41t-77.5 -14.5q-20 0 -38 3v119q12 -9 34 -9q38 0 55.5 25t17.5 67v692h144l269 -433v433h127v-664h-126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohorn",
    unicode: "\u01A0",
    horizAdvX: 769,
    d: "M752 702q10 -11 15.5 -32.5t5.5 -45.5q0 -57 -25.5 -82t-66.5 -25q-35 0 -74 15q44 -85 44 -209q0 -172 -81.5 -259t-235.5 -87t-236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q126 0 206 -68q24 -20 50 -27.5t53 -7.5q29 0 38.5 19.5t9.5 43.5q0 17 -2.5 32 t-6.5 24h70zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohorn",
    unicode: "\u01A1",
    horizAdvX: 651,
    d: "M634 543q10 -11 15.5 -32.5t5.5 -45.5q0 -20 -4 -39t-13.5 -34t-25 -24.5t-37.5 -9.5q-49 0 -83 14q26 -55 26 -126q0 -59 -17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5 q91 0 154 -46q30 -22 54.5 -28.5t48.5 -6.5q29 0 38.5 19.5t9.5 43.5q0 17 -2.5 32t-6.5 24h70zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhorn",
    unicode: "\u01AF",
    horizAdvX: 748,
    d: "M416 664h142v-73q14 -5 27.5 -6.5t22.5 -1.5q27 0 40 14t13 49q0 17 -2.5 32t-6.5 24h70q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26.5 -81.5t-67.5 -25.5q-44 0 -91 26v-321q0 -121 -71 -182.5t-200 -61.5q-123 0 -193.5 58t-70.5 178v451h141v-438q0 -62 30.5 -98 t95.5 -36q59 0 92.5 31.5t33.5 97.5v443z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhorn",
    unicode: "\u01B0",
    horizAdvX: 638,
    d: "M346 0v69q-26 -43 -65 -62.5t-85 -19.5q-39 0 -70 13t-53.5 37t-34.5 57t-12 74v324h130v-304q0 -92 82 -92q51 0 76.5 31t25.5 81v284h129v-64q11 -2 21.5 -3t16.5 -1q32 0 42 18t10 44q0 17 -2.5 32.5t-6.5 24.5h70q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26 -81t-67 -25 q-37 0 -79 18v-376h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01DD",
    unicode: "\u01DD",
    d: "M153 198q1 -27 9.5 -47.5t22.5 -34t32 -20t37 -6.5q39 0 67.5 28.5t32.5 79.5h-201zM358 280q-3 56 -32.5 89t-77.5 33q-32 0 -56.5 -14.5t-31.5 -40.5h-134q23 76 80 117t136 41q246 0 246 -268q0 -57 -16 -103t-46.5 -79t-74.5 -50.5t-101 -17.5q-114 0 -172.5 73 t-58.5 220h339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01DD",
    unicode: "\u04D9",
    d: "M153 198q1 -27 9.5 -47.5t22.5 -34t32 -20t37 -6.5q39 0 67.5 28.5t32.5 79.5h-201zM358 280q-3 56 -32.5 89t-77.5 33q-32 0 -56.5 -14.5t-31.5 -40.5h-134q23 76 80 117t136 41q246 0 246 -268q0 -57 -16 -103t-46.5 -79t-74.5 -50.5t-101 -17.5q-114 0 -172.5 73 t-58.5 220h339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E6",
    unicode: "\u01E6",
    horizAdvX: 658,
    d: "M15 0zM518 0l-3 66q-24 -42 -77 -65.5t-122 -23.5t-124.5 29.5t-95 79t-60.5 114t-21 133.5q0 73 21 137.5t62 112.5t102 75.5t142 27.5q59 0 110.5 -17t90 -47t62 -71.5t27.5 -91.5h-140q-3 23 -16 43.5t-33 35.5t-46.5 24t-54.5 9q-84 0 -134.5 -62.5t-50.5 -181.5 q0 -41 10.5 -82.5t33 -75t57.5 -54.5t83 -21q34 0 63.5 12t51.5 33t34.5 48.5t12.5 58.5h-147v111h277v-357h-115zM277 733l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E7",
    unicode: "\u01E7",
    horizAdvX: 530,
    d: "M16 0zM262 98q48 0 79.5 36.5t31.5 99.5q0 158 -111 158t-111 -150q0 -66 31.5 -105t79.5 -39zM369 66q-14 -33 -50.5 -51.5t-84.5 -18.5q-61 0 -102.5 21.5t-67 56.5t-37 81t-11.5 94q0 57 17 104.5t46 81t68 52t84 18.5q92 0 138 -74v61h130v-497q0 -56 -19 -98.5 t-52 -71t-78 -43.5t-96 -15t-95 14.5t-75.5 41t-49.5 64.5t-18 86h121q0 -45 29.5 -69.5t78.5 -24.5q52 0 88 28.5t36 77.5v81zM206 561l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F4",
    unicode: "\u01F4",
    horizAdvX: 658,
    d: "M15 0zM518 0l-3 66q-24 -42 -77 -65.5t-122 -23.5t-124.5 29.5t-95 79t-60.5 114t-21 133.5q0 73 21 137.5t62 112.5t102 75.5t142 27.5q59 0 110.5 -17t90 -47t62 -71.5t27.5 -91.5h-140q-3 23 -16 43.5t-33 35.5t-46.5 24t-54.5 9q-84 0 -134.5 -62.5t-50.5 -181.5 q0 -41 10.5 -82.5t33 -75t57.5 -54.5t83 -21q34 0 63.5 12t51.5 33t34.5 48.5t12.5 58.5h-147v111h277v-357h-115zM264 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F5",
    unicode: "\u01F5",
    horizAdvX: 530,
    d: "M16 0zM262 98q48 0 79.5 36.5t31.5 99.5q0 158 -111 158t-111 -150q0 -66 31.5 -105t79.5 -39zM369 66q-14 -33 -50.5 -51.5t-84.5 -18.5q-61 0 -102.5 21.5t-67 56.5t-37 81t-11.5 94q0 57 17 104.5t46 81t68 52t84 18.5q92 0 138 -74v61h130v-497q0 -56 -19 -98.5 t-52 -71t-78 -43.5t-96 -15t-95 14.5t-75.5 41t-49.5 64.5t-18 86h121q0 -45 29.5 -69.5t78.5 -24.5q52 0 88 28.5t36 77.5v81zM192 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F8",
    unicode: "\u01F8",
    horizAdvX: 591,
    d: "M23 0zM436 0l-284 446v-446h-129v664h147l264 -427v427h130v-664h-128zM139 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F9",
    unicode: "\u01F9",
    d: "M26 0zM341 0v298q0 57 -19 77t-65 20q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-341h-131zM95 648l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 195,
    d: "M36 492h131v-525q0 -45 -15 -81.5t-41 -63t-61.5 -41t-76.5 -14.5q-101 0 -149.5 55.5t-48.5 150.5h122q0 -42 15.5 -66.5t53.5 -24.5q39 0 54.5 24t15.5 66v520z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0241",
    unicode: "\u0241",
    horizAdvX: 491,
    d: "M177 0v197q0 54 16 100t66 81q12 8 27 17.5t28.5 22.5t22.5 31t9 45q0 24 -8.5 41t-22 27.5t-32 15t-37.5 4.5q-28 0 -47 -8t-31.5 -23t-18.5 -35.5t-7 -44.5h-123q0 99 55.5 157t176.5 58q107 0 165.5 -48t58.5 -143q0 -31 -6.5 -53t-18.5 -39t-29 -32t-39 -31 q-21 -16 -34.5 -29.5t-21 -29.5t-10.5 -36t-3 -48v-197h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0242",
    unicode: "\u0242",
    horizAdvX: 491,
    d: "M182 0v78q0 60 20 95t59 63q22 15 37 27t25 22.5t14.5 21.5t4.5 25q0 36 -24 51.5t-64 15.5q-30 0 -50 -7t-32.5 -18.5t-17.5 -26t-5 -29.5h-128q0 86 55 136.5t174 50.5q106 0 163.5 -42t57.5 -127q0 -26 -6 -44.5t-17.5 -33t-28.5 -27.5t-40 -29q-20 -14 -33.5 -25 t-21.5 -24t-11.5 -30.5t-3.5 -44.5v-78h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni024C",
    unicode: "\u024C",
    horizAdvX: 700,
    d: "M532 0v171q0 48 -22 68.5t-82 20.5h-148v-260h-135v260h-145v112h145v292h337q46 0 83.5 -14.5t64.5 -40t41.5 -61t14.5 -76.5q0 -54 -25.5 -95.5t-73.5 -58.5q44 -14 62.5 -43t18.5 -87v-188h-136zM280 549v-177h174q56 0 79 25t23 63q0 39 -22.5 64t-74.5 25h-179z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni024D",
    unicode: "\u024D",
    horizAdvX: 390,
    d: "M96 0v173h-96v91h96v228h122v-59q16 25 33.5 39t36 21.5t37.5 9.5t39 2h17v-133q-18 3 -36 3q-116 0 -119 -111h155v-91h-155v-173h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0263",
    unicode: "\u0263",
    horizAdvX: 501,
    d: "M250 -233q-34 0 -62 6t-47.5 20t-30 38t-10.5 60q0 10 2 23t11 37.5t27 67t50 112.5l-184 361h138l105 -232l106 232h139l-186 -362q32 -70 50.5 -112t27.5 -67t11 -37.5t2 -22.5q0 -36 -10.5 -60t-30 -38t-47 -20t-61.5 -6zM249 14q-24 -49 -33 -76.5t-9 -47.5 q0 -22 9.5 -33.5t32.5 -11.5t33.5 11.5t10.5 28.5q0 12 -4.5 30.5t-11 37.5t-14 35.5t-13.5 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0272",
    unicode: "\u0272",
    d: "M156 -33q0 -45 -15 -81.5t-40.5 -63t-61 -41t-75.5 -14.5q-9 0 -16.5 0.5t-14.5 1.5v116q5 -2 10.5 -3.5t14.5 -1.5q25 0 39 11t20.5 30t7.5 45t1 57v469h124v-72q46 85 155 85q75 0 121 -41.5t46 -122.5v-341h-131v298q0 56 -18 76.5t-62 20.5q-54 0 -79.5 -27.5 t-25.5 -85.5v-315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 460,
    d: "M231 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 459,
    d: "M178 561l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 478,
    d: "M50 602zM50 602v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 422,
    d: "M374 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 220,
    d: "M50 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 306,
    d: "M258 650q0 -47 -24 -71.5t-80 -24.5q-104 0 -104 96q0 46 25.5 71t78.5 25q56 0 80 -25t24 -71zM206 650q0 51 -52 51q-50 0 -50 -51q0 -49 50 -49q52 0 52 49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 313,
    d: "M265 -207q-14 -11 -39 -18.5t-66 -7.5q-54 0 -82 23t-28 62q0 49 47 86.5t125 61.5h43q-38 -17 -60.5 -29.5t-34 -23t-15 -20t-3.5 -19.5q0 -17 17.5 -25t46.5 -8q14 0 27 2.5t22 5.5v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 443,
    d: "M395 674q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 397,
    d: "M50 602l136 147l44 -37l-143 -143zM207 569l-37 33l142 144l45 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    horizAdvX: 0,
    d: "M-152 554zM-406 648l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    horizAdvX: 0,
    d: "M-92 554zM-315 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    horizAdvX: 0,
    d: "M-68 561zM-249 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    horizAdvX: 370,
    d: "M315 732q-9 -36 -31.5 -48.5t-46.5 -12.5q-12 0 -26 3t-27.5 7t-25.5 7t-21 3q-16 0 -28 -32l-49 20q9 34 28 48.5t42 14.5q18 0 32 -3.5t26.5 -8t24 -8t23.5 -3.5q11 0 18 5.5t10 21.5zM288 554l-102 70l-101 -70l-35 30l96 80h80l96 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    horizAdvX: 0,
    d: "M-59 602zM-440 602v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    horizAdvX: 0,
    d: "M-88 580zM-88 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    horizAdvX: 0,
    d: "M-181 579zM-311 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    horizAdvX: 0,
    d: "M-81 579zM-411 579v124h130v-124h-130zM-211 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hookabovecomb",
    unicode: "\u0309",
    horizAdvX: 243,
    d: "M85 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    horizAdvX: 0,
    d: "M-146 554zM-146 650q0 -47 -24 -71.5t-80 -24.5q-104 0 -104 96q0 46 25.5 71t78.5 25q56 0 80 -25t24 -71zM-198 650q0 51 -52 51q-50 0 -50 -51q0 -49 50 -49q52 0 52 49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    horizAdvX: 0,
    d: "M-68 569zM-375 602l136 147l44 -37l-143 -143zM-218 569l-37 33l142 144l45 -37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    horizAdvX: 0,
    d: "M-68 561zM-302 561l-128 134l46 51l135 -118l135 118l46 -51l-128 -134h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0313",
    unicode: "\u0313",
    horizAdvX: 0,
    d: "M-198 551zM-197.997 698.988q-61.9961 -5 -63.9961 -64.9961h63.9961v-81.9951h-114.993v53.9971q0 26.998 5.5 50.4971q5.5 23.498 18.499 41.4971t35.498 29.498q22.498 11.5 55.4961 14.499v-42.9971z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni031B",
    unicode: "\u031B",
    horizAdvX: 151,
    d: "M-31 430q13 -5 26 -6.5t22 -1.5q34 0 44 19t10 42q0 20 -3.5 35.5t-6.5 24.5h68q11 -11 16.5 -32.5t5.5 -46.5q0 -56 -27 -81.5t-68 -25.5q-42 0 -87 24v49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelowcomb",
    unicode: "\u0323",
    horizAdvX: 220,
    d: "M50 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M-189 -43zM-304 -190q62 5 64 65h-64v82h115v-54q0 -27 -5.5 -50.5t-18.5 -41.5t-35.5 -29.5t-55.5 -14.5v43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    horizAdvX: 0,
    d: "M-143 0zM-143 -207q-14 -11 -39 -18.5t-66 -7.5q-54 0 -82 23t-28 62q0 49 47 86.5t125 61.5h43q-38 -17 -60.5 -29.5t-34 -23t-15 -20t-3.5 -19.5q0 -17 17.5 -25t46.5 -8q14 0 27 2.5t22 5.5v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni032D",
    unicode: "\u032D",
    horizAdvX: 0,
    d: "M-69 -42zM-250 -109l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tonos",
    unicode: "\u0384",
    horizAdvX: 150,
    d: "M23 414q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresistonos",
    unicode: "\u0385",
    horizAdvX: 0,
    d: "M-30 544zM-292 544q1 63 1.5 125t2.5 125h117l-40 -250h-81zM-160 579v124h130v-124h-130zM-444 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Alphatonos",
    unicode: "\u0386",
    horizAdvX: 672,
    d: "M23 0zM348 515h-1l-85 -264h169zM513 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM23 414q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "anoteleia",
    unicode: "\u0387",
    horizAdvX: 187,
    d: "M23 357zM23 357v135h139v-135h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Epsilontonos",
    unicode: "\u0388",
    horizAdvX: 681,
    d: "M23 0zM173 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM23 414q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etatonos",
    unicode: "\u0389",
    horizAdvX: 737,
    d: "M23 0zM571 0v298h-259v-298h-139v664h139v-250h259v250h140v-664h-140zM23 414q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iotatonos",
    unicode: "\u038A",
    horizAdvX: 337,
    d: "M23 0zM173 0v664h139v-664h-139zM23 414q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omicrontonos",
    unicode: "\u038C",
    horizAdvX: 776,
    d: "M23 0zM440 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM440 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM23 414q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Upsilontonos",
    unicode: "\u038E",
    horizAdvX: 750,
    d: "M23 0zM381 0v251l-230 413h162l140 -270l129 270h160l-222 -415v-249h-139zM23 414q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omegatonos",
    unicode: "\u038F",
    horizAdvX: 767,
    d: "M23 0zM499 0v100q48 46 74.5 116t26.5 177q0 94 -41 138t-120 44t-119.5 -44t-40.5 -138q0 -53 8 -97t21.5 -80t31.5 -65t39 -51v-100h-239v110h99q-23 17 -43 45t-35 65t-24 81t-9 93q0 68 18.5 122t57 92t97 58t138.5 20q160 0 235.5 -78t75.5 -214q0 -49 -9 -93 t-24 -81t-35.5 -65t-42.5 -45h99v-110h-239zM23 414q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresistonos",
    unicode: "\u0390",
    horizAdvX: 397,
    d: "M0 0zM124 492h124v-333q0 -29 14 -43t40 -14h29v-102h-64q-143 0 -143 143v349zM141 544q1 63 1.5 125t2.5 125h117l-40 -250h-81zM274 579v124h130v-124h-130zM-10 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0393",
    horizAdvX: 501,
    d: "M489 664v-113h-331v-551h-136v664h467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 501,
    d: "M489 664v-113h-331v-551h-136v664h467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u0394",
    horizAdvX: 643,
    d: "M3 0l237 664h161l234 -664h-632zM187 114h260l-128 401h-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Theta",
    unicode: "\u0398",
    horizAdvX: 670,
    d: "M332 94q42 0 77.5 13t61.5 41t41 72.5t15 107.5q0 115 -49 176.5t-142 61.5t-143 -61.5t-50 -179.5q0 -120 51 -175.5t138 -55.5zM338 -23q-156 0 -238 90t-82 259q0 84 21 151t61.5 113.5t99.5 71t136 24.5q76 0 135 -24.5t99.5 -71.5t61 -114.5t20.5 -152.5 q0 -172 -81 -259t-233 -87zM200 391h271v-101h-271v101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lambda",
    unicode: "\u039B",
    horizAdvX: 593,
    d: "M364 664l225 -664h-148l-145 466l-144 -466h-144l225 664h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Xi",
    unicode: "\u039E",
    horizAdvX: 532,
    d: "M47 290v115h438v-115h-438zM19 551v113h494v-113h-494zM3 0v115h525v-115h-525z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u03A0",
    horizAdvX: 587,
    d: "M426 0v551h-264v-551h-136v664h537v-664h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 587,
    d: "M426 0v551h-264v-551h-136v664h537v-664h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sigma",
    unicode: "\u03A3",
    horizAdvX: 532,
    d: "M6 558v106h506v-113h-342l178 -214l-179 -222h357v-115h-519v115l182 220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u03A6",
    horizAdvX: 712,
    d: "M291 0v94q-136 11 -207 71t-71 166q0 107 71.5 170t206.5 75v88h131v-88q134 -13 205 -75.5t71 -169.5t-71 -167t-205 -71v-93h-131zM142 332q0 -71 41.5 -106.5t107.5 -46.5v309q-69 -11 -109 -49t-40 -107zM569 331q0 69 -39.5 107t-107.5 50v-309q32 5 59 16.5 t46.5 29.5t30.5 44.5t11 61.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 712,
    d: "M291 0v94q-136 11 -207 71t-71 166q0 107 71.5 170t206.5 75v88h131v-88q134 -13 205 -75.5t71 -169.5t-71 -167t-205 -71v-93h-131zM142 332q0 -71 41.5 -106.5t107.5 -46.5v309q-69 -11 -109 -49t-40 -107zM569 331q0 69 -39.5 107t-107.5 50v-309q32 5 59 16.5 t46.5 29.5t30.5 44.5t11 61.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Psi",
    unicode: "\u03A8",
    horizAdvX: 658,
    d: "M264 0v165q-69 5 -116 21.5t-75.5 44.5t-40.5 68t-12 91v274h134v-261q0 -54 25 -86t85 -43v390h129v-390q60 11 84.5 43.5t24.5 86.5v260h136v-272q0 -51 -13 -91t-42 -68.5t-76 -45.5t-114 -22v-165h-129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u03A9",
    horizAdvX: 651,
    d: "M383 0v100q48 46 74.5 116t26.5 177q0 94 -41 138t-120 44t-119.5 -44t-40.5 -138q0 -53 8 -97t21.5 -80t31.5 -65t39 -51v-100h-239v110h99q-23 17 -43 45t-35 65t-24 81t-9 93q0 68 18.5 122t57 92t97 58t138.5 20q160 0 235.5 -78t75.5 -214q0 -49 -9 -93t-24 -81 t-35.5 -65t-42.5 -45h99v-110h-239z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alphatonos",
    unicode: "\u03AC",
    horizAdvX: 583,
    d: "M19 0zM379 81q-11 -20 -25 -37t-32.5 -29.5t-43 -20t-55.5 -7.5q-49 0 -87 18.5t-64 52t-39.5 80t-13.5 102.5q0 62 16 111.5t44 83.5t66 52t82 18q46 0 84.5 -22t58.5 -73v82h123v-335q0 -55 53 -55h30v-102h-64q-108 0 -133 81zM257 95q57 0 86.5 39t29.5 113 q0 80 -32.5 117t-82.5 37q-51 0 -81 -36.5t-30 -117.5q0 -82 30 -117t80 -35zM234 544q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilontonos",
    unicode: "\u03AD",
    horizAdvX: 469,
    d: "M10 0zM228 217q-47 0 -69 -15t-22 -51q0 -41 26.5 -57t67.5 -16q54 0 76.5 22t24.5 64h128q-3 -35 -16.5 -67t-41.5 -56.5t-70 -39t-102 -14.5q-51 0 -91.5 11t-69 31t-44 49t-15.5 65q0 53 31 83t73 38q-41 11 -64.5 38t-23.5 69q0 59 50.5 96.5t153.5 37.5 q59 0 100.5 -13t68.5 -35.5t40.5 -53t16.5 -64.5h-128q0 41 -21.5 60t-72.5 19q-86 0 -86 -57q0 -32 23.5 -46t59.5 -14h42v-84h-45zM193 544q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etatonos",
    unicode: "\u03AE",
    d: "M26 0zM341 -233v531q0 57 -19 77t-65 20q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-574h-131zM213 544q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotatonos",
    unicode: "\u03AF",
    horizAdvX: 243,
    d: "M29 0zM29 492h124v-333q0 -29 14 -43t40 -14h29v-102h-64q-143 0 -143 143v349zM43 544q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresistonos",
    unicode: "\u03B0",
    horizAdvX: 497,
    d: "M29 0zM198 544q1 63 1.5 125t2.5 125h117l-40 -250h-81zM249 -13q-108 0 -164 39.5t-56 136.5v329h127v-309q0 -49 21.5 -70.5t72.5 -21.5q52 0 73.5 21.5t21.5 70.5v309h124v-329q0 -97 -56.5 -136.5t-163.5 -39.5zM330 579v124h130v-124h-130zM46 579v124h130v-124 h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alpha",
    unicode: "\u03B1",
    horizAdvX: 583,
    d: "M379 81q-11 -20 -25 -37t-32.5 -29.5t-43 -20t-55.5 -7.5q-49 0 -87 18.5t-64 52t-39.5 80t-13.5 102.5q0 62 16 111.5t44 83.5t66 52t82 18q46 0 84.5 -22t58.5 -73v82h123v-335q0 -55 53 -55h30v-102h-64q-108 0 -133 81zM257 95q57 0 86.5 39t29.5 113q0 80 -32.5 117 t-82.5 37q-51 0 -81 -36.5t-30 -117.5q0 -82 30 -117t80 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "beta",
    unicode: "\u03B2",
    horizAdvX: 510,
    d: "M281 -12q-38 0 -70 8t-57 22v-251h-125v731q0 40 11.5 73t37 57t67 37.5t102.5 13.5q60 0 100.5 -12.5t66 -35t36.5 -53t11 -65.5q0 -32 -7.5 -54t-19.5 -37.5t-27.5 -25t-30.5 -15.5q66 -20 94.5 -68t28.5 -112q0 -50 -16 -89t-44.5 -67t-68.5 -42.5t-89 -14.5zM154 124 q20 -14 46 -23t58 -9q62 0 89 32t27 83q0 33 -10 55.5t-28 37t-43 21t-55 6.5h-9v80h8q28 0 47 6.5t29.5 18t15 26.5t4.5 32q0 48 -25 68t-63 20q-40 0 -65.5 -20.5t-25.5 -65.5v-368z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u03B3",
    horizAdvX: 501,
    d: "M188 -233v228l-182 497h142l105 -329l107 329h134l-182 -497v-228h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u04AF",
    horizAdvX: 501,
    d: "M188 -233v228l-182 497h142l105 -329l107 329h134l-182 -497v-228h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "delta",
    unicode: "\u03B4",
    horizAdvX: 539,
    d: "M18 240q0 78 31 126.5t80 75.5q-26 17 -42.5 42t-16.5 64q0 26 9.5 49.5t33.5 41.5t65 29t104 11q43 0 85 -4.5t66 -11.5v-96q-26 11 -64.5 16.5t-80.5 5.5q-56 0 -81.5 -9.5t-25.5 -32.5t19.5 -34t40.5 -16q32 -8 55 -14.5t42 -12.5t35 -12.5t33 -15.5q51 -27 82 -72 t31 -126q0 -59 -17.5 -106t-49.5 -81t-78 -52t-104 -18q-59 0 -106 19t-79.5 52.5t-49.5 80t-17 101.5zM348 341q-23 18 -54.5 31t-65.5 25q-39 -18 -61.5 -55t-22.5 -99q0 -75 34 -112.5t92 -37.5q60 0 90.5 37t30.5 106q0 35 -9.5 60t-33.5 45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilon",
    unicode: "\u03B5",
    horizAdvX: 469,
    d: "M228 217q-47 0 -69 -15t-22 -51q0 -41 26.5 -57t67.5 -16q54 0 76.5 22t24.5 64h128q-3 -35 -16.5 -67t-41.5 -56.5t-70 -39t-102 -14.5q-51 0 -91.5 11t-69 31t-44 49t-15.5 65q0 53 31 83t73 38q-41 11 -64.5 38t-23.5 69q0 59 50.5 96.5t153.5 37.5q59 0 100.5 -13 t68.5 -35.5t40.5 -53t16.5 -64.5h-128q0 41 -21.5 60t-72.5 19q-86 0 -86 -57q0 -32 23.5 -46t59.5 -14h42v-84h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeta",
    unicode: "\u03B6",
    horizAdvX: 481,
    d: "M249 399q-34 -30 -54 -53.5t-31 -44t-14.5 -39t-3.5 -37.5q0 -68 30.5 -94.5t86.5 -26.5h25q66 0 96.5 -27t30.5 -89v-221h-127v187q0 25 -9 35.5t-36 10.5h-30q-46 0 -82 15.5t-60.5 43t-37.5 65t-13 81.5q0 72 35.5 133t108.5 124l127 110h-233v100h385v-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eta",
    unicode: "\u03B7",
    d: "M341 -233v531q0 57 -19 77t-65 20q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-574h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "theta",
    unicode: "\u03B8",
    horizAdvX: 548,
    d: "M275 -15q-68 0 -116 21t-78 64t-44 109t-14 155t13.5 155t43.5 109t78 64t117 21q68 0 115.5 -21t77 -64t43 -108.5t13.5 -154.5t-13.5 -155t-43 -109.5t-77 -64.5t-115.5 -21zM275 92q61 0 90 43.5t34 147.5h-247q2 -52 10 -88.5t22.5 -59t36.5 -33t54 -10.5zM275 575 q-32 0 -54 -9.5t-36.5 -32t-22.5 -58.5t-10 -88h247q-5 103 -34 145.5t-90 42.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iota",
    unicode: "\u03B9",
    horizAdvX: 243,
    d: "M29 492h124v-333q0 -29 14 -43t40 -14h29v-102h-64q-143 0 -143 143v349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u03BA",
    horizAdvX: 483,
    d: "M328 0l-108 221l-63 -65v-156h-131v492h131v-187l162 187h159l-165 -181l161 -311h-146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 483,
    d: "M328 0l-108 221l-63 -65v-156h-131v492h131v-187l162 187h159l-165 -181l161 -311h-146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lambda",
    unicode: "\u03BB",
    horizAdvX: 534,
    d: "M121 672q41 0 70 -7t50 -21t34.5 -36t24.5 -52l142 -399q11 -30 26 -42.5t46 -12.5h12v-102h-70q-55 0 -87 28t-52 88l-66 202l-111 -318h-134l194 475l-13 40q-5 16 -11.5 26.5t-15.5 17t-21.5 9t-31.5 2.5h-27v102h41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\u03BC",
    horizAdvX: 500,
    d: "M346 0v69q-50 -82 -153 -82q-10 0 -19.5 1t-17.5 3v-224h-130v725h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "xi",
    unicode: "\u03BE",
    horizAdvX: 481,
    d: "M282 336h-44q-50 0 -71.5 -26.5t-21.5 -80.5q0 -36 8.5 -60.5t24 -39t36.5 -20.5t46 -6h28q66 0 96.5 -26t30.5 -88v-222h-127v187q0 26 -9.5 36t-35.5 10h-31q-88 0 -140 57.5t-52 157.5q0 40 8.5 69.5t23 50t33 32.5t39.5 17q-42 17 -63.5 48.5t-21.5 83.5q0 75 49 118 t156 43q58 0 99.5 -13t68 -35.5t40 -53t16.5 -64.5h-127q0 79 -91 79q-47 0 -68.5 -20t-21.5 -63q0 -38 18 -62.5t63 -24.5h41v-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 576,
    d: "M356 391h-150v-391h-126v391h-73v101h561v-101h-87v-232q0 -57 53 -57h30v-102h-64q-144 0 -144 143v248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rho",
    unicode: "\u03C1",
    horizAdvX: 523,
    d: "M29 247q0 69 19 117.5t51 80t75.5 46t93.5 14.5q113 0 174 -69t61 -193q0 -57 -13.5 -104t-39 -81t-63 -52.5t-85.5 -18.5q-22 0 -44.5 4.5t-42 15t-36 28.5t-26.5 44v-312h-124v480zM149 248q0 -74 30 -113.5t86 -39.5q50 0 79.5 35.5t29.5 116.5t-29.5 117.5 t-80.5 36.5q-53 0 -84 -38.5t-31 -114.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma1",
    unicode: "\u03C2",
    horizAdvX: 481,
    d: "M212 0q-42 0 -77.5 15t-61 46t-39.5 77.5t-14 109.5q0 67 16.5 116t46.5 80t71.5 46t91.5 15q49 0 89.5 -13t70 -38t46 -60t19.5 -78h-128q-5 39 -30.5 61t-66.5 22q-22 0 -40.5 -7.5t-32 -25t-21 -46.5t-7.5 -72q0 -77 28 -111t96 -34h15q69 0 100 -26.5t31 -87.5v-222 h-127v187q0 26 -9.5 36t-35.5 10h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma",
    unicode: "\u03C3",
    horizAdvX: 580,
    d: "M437 402q37 -26 55.5 -70t18.5 -99q0 -54 -17 -99t-48.5 -77.5t-77 -51t-102.5 -18.5q-58 0 -104 18.5t-78 52t-49 80.5t-17 103q0 57 17.5 103.5t50 79t79 50.5t105.5 18h302v-90h-135zM270 91q121 0 121 149q0 150 -119 150q-60 0 -91.5 -37.5t-31.5 -112.5 q0 -149 121 -149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tau",
    unicode: "\u03C4",
    horizAdvX: 479,
    d: "M298 402v-242q0 -58 53 -58h30v-102h-64q-144 0 -144 143v259h-166v90h464v-90h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilon",
    unicode: "\u03C5",
    horizAdvX: 497,
    d: "M249 -13q-108 0 -164 39.5t-56 136.5v329h127v-309q0 -49 21.5 -70.5t72.5 -21.5q52 0 73.5 21.5t21.5 70.5v309h124v-329q0 -97 -56.5 -136.5t-163.5 -39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u03C6",
    horizAdvX: 719,
    d: "M297 -233v224q-144 11 -212.5 79.5t-68.5 175.5t69 175.5t212 79.5v171h124v-171q142 -11 211.5 -79.5t69.5 -175.5q0 -108 -69 -176t-212 -79v-224h-124zM144 247q0 -68 35.5 -107.5t117.5 -47.5v306q-81 -8 -117 -45.5t-36 -105.5zM575 247q0 68 -36.5 105.5 t-117.5 45.5v-306q81 8 117.5 47.5t36.5 107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 719,
    d: "M297 -233v224q-144 11 -212.5 79.5t-68.5 175.5t69 175.5t212 79.5v171h124v-171q142 -11 211.5 -79.5t69.5 -175.5q0 -108 -69 -176t-212 -79v-224h-124zM144 247q0 -68 35.5 -107.5t117.5 -47.5v306q-81 -8 -117 -45.5t-36 -105.5zM575 247q0 68 -36.5 105.5 t-117.5 45.5v-306q81 8 117.5 47.5t36.5 107.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "chi",
    unicode: "\u03C7",
    horizAdvX: 496,
    d: "M346 -233l-101 252l-99 -252h-140l166 370l-161 355h143l96 -244l98 244h137l-164 -355l169 -370h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "psi",
    unicode: "\u03C8",
    horizAdvX: 658,
    d: "M267 672h123v-584q63 2 88.5 23t25.5 67v314h124v-324q0 -44 -12 -77.5t-40 -56t-73.5 -34t-112.5 -11.5v-222h-123v222q-67 0 -112.5 11.5t-73.5 34t-40 56t-12 77.5v324h124v-314q0 -46 30 -68t84 -22v584z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omega",
    unicode: "\u03C9",
    horizAdvX: 704,
    d: "M398 254q0 -85 18.5 -123t58.5 -38t60 38t20 125q0 40 -4 71.5t-11.5 59t-18 53t-23.5 52.5h128q27 -40 43 -98.5t16 -134.5q0 -127 -47.5 -199.5t-142.5 -72.5q-58 0 -92 26t-52 68q-20 -46 -54.5 -70t-88.5 -24q-96 0 -143 71.5t-47 199.5q0 78 16 136t43 98h128 q-13 -27 -23.5 -52.5t-18 -53t-11.5 -59.5t-4 -72q0 -86 19.5 -124t60.5 -38q40 0 58.5 37.5t18.5 123.5v90h93v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresis",
    unicode: "\u03CA",
    horizAdvX: 301,
    d: "M0 0zM72 492h124v-333q0 -29 14 -43t40 -14h29v-102h-64q-143 0 -143 143v349zM172 579v124h130v-124h-130zM-7 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresis",
    unicode: "\u03CB",
    horizAdvX: 497,
    d: "M29 0zM249 -13q-108 0 -164 39.5t-56 136.5v329h127v-309q0 -49 21.5 -70.5t72.5 -21.5q52 0 73.5 21.5t21.5 70.5v309h124v-329q0 -97 -56.5 -136.5t-163.5 -39.5zM88 579v124h130v-124h-130zM288 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omicrontonos",
    unicode: "\u03CC",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M226 544q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilontonos",
    unicode: "\u03CD",
    horizAdvX: 497,
    d: "M29 0zM205 544q1 63 1.5 125t2.5 125h117l-40 -250h-81zM249 -13q-108 0 -164 39.5t-56 136.5v329h127v-309q0 -49 21.5 -70.5t72.5 -21.5q52 0 73.5 21.5t21.5 70.5v309h124v-329q0 -97 -56.5 -136.5t-163.5 -39.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omegatonos",
    unicode: "\u03CE",
    horizAdvX: 704,
    d: "M18 0zM398 254q0 -85 18.5 -123t58.5 -38t60 38t20 125q0 40 -4 71.5t-11.5 59t-18 53t-23.5 52.5h128q27 -40 43 -98.5t16 -134.5q0 -127 -47.5 -199.5t-142.5 -72.5q-58 0 -92 26t-52 68q-20 -46 -54.5 -70t-88.5 -24q-96 0 -143 71.5t-47 199.5q0 78 16 136t43 98h128 q-13 -27 -23.5 -52.5t-18 -53t-11.5 -59.5t-4 -72q0 -86 19.5 -124t60.5 -38q40 0 58.5 37.5t18.5 123.5v90h93v-90zM308 544q1 63 1.5 125t2.5 125h117l-40 -250h-81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 754,
    d: "M595 160q0 48 -5 78.5t-18 48t-35.5 24.5t-57.5 7q-38 0 -72.5 -6.5t-61.5 -19.5v-282h-136v541h-201v113h555v-113h-218v-151q35 14 81.5 22.5t97.5 8.5q47 0 85.5 -9t65.5 -33t42 -66t15 -107v-203q0 -121 -70.5 -183.5t-197.5 -62.5q-105 0 -169 45t-78 145h128 q7 -42 41.5 -60.5t78.5 -18.5q61 0 95.5 33.5t34.5 101.5v147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 501,
    d: "M22 0zM195 726l-31 55l207 121l47 -82zM489 664v-113h-331v-551h-136v664h467z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 613,
    d: "M608 228q-11 -57 -35 -103t-60.5 -79t-84.5 -51t-106 -18q-65 0 -121.5 22t-97.5 66t-64.5 108.5t-23.5 150.5q0 84 21.5 151.5t61.5 114t97.5 71.5t128.5 25q62 0 112.5 -18.5t87 -51t58 -76.5t26.5 -94h-139q-14 57 -54 88.5t-90 31.5q-72 0 -112 -42.5t-52 -119.5h219 v-114h-223q8 -92 47.5 -142t113.5 -50q62 0 99.5 33.5t51.5 96.5h139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 974,
    d: "M737 419q53 0 96.5 -12.5t74 -38t47 -64.5t16.5 -93q0 -102 -57.5 -156.5t-157.5 -54.5h-290v551h-180l-9 -157q-7 -127 -22 -204.5t-43.5 -119.5t-72 -56t-107.5 -14h-24v118h16q33 0 56 9t38.5 38.5t25 86.5t14.5 153l14 259h430v-245h135zM602 311v-199h144 q48 0 76.5 27.5t28.5 72.5q0 44 -27.5 71.5t-77.5 27.5h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 853,
    d: "M634 419q100 0 157.5 -54t57.5 -155t-57.5 -155.5t-157.5 -54.5h-265v310h-208v-310h-135v664h135v-241h208v241h136v-245h129zM505 311v-199h120q48 0 76.5 27.5t28.5 72.5q0 44 -28 71.5t-77 27.5h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 754,
    d: "M8 664h555v-113h-218v-151q35 14 81.5 22.5t97.5 8.5q47 0 85.5 -9t65.5 -33t42 -66t15 -107v-216h-137v213q0 32 -8.5 52.5t-23.5 32t-36.5 16t-48.5 4.5q-36 0 -71 -6.5t-62 -19.5v-292h-136v551h-201v113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 604,
    d: "M23 0zM431 0l-197 299l-74 -73v-226h-137v664h137v-270l254 270h180l-262 -262l268 -402h-169zM237 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 587,
    d: "M26 0zM137 820l47 82l207 -121l-31 -55zM26 0v664h132v-433l260 433h145v-664h-131v452l-276 -452h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 575,
    d: "M26 0zM450 918q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82zM548 219q0 -121 -69.5 -181.5t-197.5 -60.5q-117 0 -181.5 55t-65.5 182h123q1 -66 35 -96.5t92 -30.5 q60 0 94.5 31.5t34.5 100.5v115q-23 -42 -71 -64t-109 -22q-47 0 -85 14t-65 44t-42 76t-15 110v172h137v-171q0 -69 34.5 -100t85.5 -31q59 0 94.5 35t35.5 95v172h135v-445v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 577,
    d: "M244 -169v169h-218v664h136v-546h264v546h137v-664h-220v-169h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 534,
    d: "M315 419q100 0 157.5 -54t57.5 -155t-57.5 -155.5t-157.5 -54.5h-289v664h387v-119h-252v-126h154zM161 311v-199h145q48 0 76.5 27.5t28.5 72.5q0 44 -27.5 71.5t-77.5 27.5h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 713,
    d: "M11 -169v287h43q28 0 49 10t36 41t24 87t14 149l14 259h430v-546h81v-287h-100v169h-491v-169h-100zM305 551l-7 -146q-5 -106 -19 -176t-35 -111h241v433h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 888,
    d: "M715 0l-206 273v-273h-130v273l-206 -273h-166l279 338l-266 326h161l198 -246v246h130v-246l198 246h161l-267 -326l279 -338h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0417",
    unicode: "\u0417",
    horizAdvX: 564,
    d: "M225 291v115h62q57 0 88 24.5t31 64.5q0 38 -29.5 58t-93.5 20q-70 0 -102 -26t-32 -85h-131q0 48 14.5 89t46 71t82 47t123.5 17q65 0 113.5 -13.5t80 -37.5t47 -57.5t15.5 -73.5q0 -56 -28 -94.5t-82 -52.5q57 -11 94 -53t37 -114q0 -99 -73.5 -156t-205.5 -57 q-74 0 -126 18t-85.5 50t-49 75.5t-15.5 94.5h134q4 -60 37 -91.5t109 -31.5q66 0 102 25.5t36 80.5q0 54 -34.5 73.5t-97.5 19.5h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 587,
    d: "M26 0v664h132v-433l260 433h145v-664h-131v452l-276 -452h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 587,
    d: "M26 0zM456 918q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82zM26 0v664h132v-433l260 433h145v-664h-131v452l-276 -452h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 628,
    d: "M466 0v551h-179l-8 -146q-7 -131 -23 -211t-44.5 -123t-72 -57t-106.5 -14h-25v118h16q34 0 57 9t38.5 39t24 87t14.5 152l15 259h430v-664h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 575,
    d: "M548 219q0 -121 -69.5 -181.5t-197.5 -60.5q-117 0 -181.5 55t-65.5 182h123q1 -66 35 -96.5t92 -30.5q60 0 94.5 31.5t34.5 100.5v115q-23 -42 -71 -64t-109 -22q-47 0 -85 14t-65 44t-42 76t-15 110v172h137v-171q0 -69 34.5 -100t85.5 -31q59 0 94.5 35t35.5 95v172 h135v-445v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 654,
    d: "M544 -169v169h-518v664h136v-546h264v546h137v-546h80v-287h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 570,
    d: "M409 0v264q-35 -15 -81.5 -23.5t-97.5 -8.5q-47 0 -85.5 9.5t-65.5 33.5t-42 65.5t-15 106.5v217h137v-214q0 -63 30.5 -84t85.5 -21q36 0 71.5 6.5t62.5 20.5v292h135v-664h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 820,
    d: "M26 0v664h136v-546h180v546h136v-546h180v546h135v-664h-767z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 885,
    d: "M775 -169v169h-749v664h136v-546h180v546h136v-546h180v546h135v-546h82v-287h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 718,
    d: "M480 419q54 0 97 -12.5t73.5 -38t47 -64.5t16.5 -93q0 -103 -57.5 -157t-157.5 -54h-289v551h-202v113h337v-245h135zM345 311v-199h145q48 0 76.5 27.5t28.5 72.5q0 44 -27.5 71.5t-77.5 27.5h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 721,
    d: "M26 0zM557 0v664h139v-664h-139zM161 311v-199h145q48 0 76.5 27.5t28.5 72.5q0 44 -27.5 71.5t-77.5 27.5h-145zM315 419q100 0 157.5 -54t57.5 -155t-57.5 -155.5t-157.5 -54.5h-289v664h135v-245h154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 534,
    d: "M161 311v-199h145q48 0 76.5 27.5t28.5 72.5q0 44 -27.5 71.5t-77.5 27.5h-145zM315 419q100 0 157.5 -54t57.5 -155t-57.5 -155.5t-157.5 -54.5h-289v664h135v-245h154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 613,
    d: "M144 228q14 -63 51.5 -96.5t99.5 -33.5q74 0 113.5 50t47.5 142h-223v114h219q-12 77 -52 119.5t-112 42.5q-50 0 -90 -31.5t-54 -88.5h-139q5 50 26.5 94t58 76.5t87 51t112.5 18.5q71 0 128.5 -25t97.5 -71.5t61.5 -114t21.5 -151.5q0 -86 -23.5 -150.5t-65 -108.5 t-97.5 -66t-121 -22q-58 0 -106 18t-84.5 51t-61 79t-34.5 103h139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 858,
    d: "M23 0v664h139v-271h44q16 139 96.5 216t218.5 77q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5q0 -172 -81.5 -259t-235.5 -87q-144 0 -225.5 79t-92.5 228h-41v-284h-139zM521 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179 t47.5 -172.5t134.5 -54.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 578,
    d: "M318 260l-153 -260h-158l169 265q-76 13 -118 63t-42 134q0 98 57.5 150t157.5 52h320v-664h-135v260h-98zM416 365v186h-172q-49 0 -76.5 -24.5t-27.5 -67.5t27.5 -68.5t76.5 -25.5h172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 539,
    d: "M269 -13q-119 0 -185 72.5t-66 200.5v83q0 90 13 152.5t40.5 101t72 56t107.5 17.5h56q17 0 30.5 2.5t24 10t18 21.5t10.5 37h77q-4 -38 -17 -70.5t-34 -55.5t-50.5 -36t-65.5 -13h-64q-55 0 -80.5 -42.5t-25.5 -110.5q15 21 34.5 35.5t41.5 23t45.5 12t45.5 3.5 q52 0 93.5 -17t70 -49t43.5 -77t15 -100q0 -60 -17.5 -107.5t-50 -81t-78.5 -51t-104 -17.5zM267 93q124 0 124 153q0 151 -123 151q-124 0 -124 -152t123 -152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 504,
    d: "M29 0v492h293q44 0 74 -9.5t49 -25.5t27 -38t8 -46q0 -44 -22.5 -70.5t-57.5 -36.5q18 -4 35 -13.5t30.5 -24.5t21.5 -36.5t8 -50.5q0 -31 -11 -57t-34 -44.5t-60.5 -29t-89.5 -10.5h-271zM281 92q85 0 85 67q0 66 -77 66h-136v-133h128zM284 293q32 0 50 13.5t18 41.5 q0 56 -71 56h-128v-111h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 350,
    d: "M30 0v492h313v-104h-186v-388h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 588,
    d: "M11 -149v253h21q25 0 42.5 7t30 29t19.5 61.5t11 105.5l11 185h355v-388h76v-253h-94v149h-378v-149h-94zM239 388l-5 -88q-2 -25 -5 -53.5t-8 -55t-11.5 -49.5t-14.5 -38h179v284h-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 685,
    d: "M402 304l121 188h148l-178 -241l185 -251h-153l-123 184v-184h-120v184l-123 -184h-153l185 251l-178 241h148l121 -188v188h120v-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 469,
    d: "M196 217v84h42q36 0 59.5 14t23.5 46q0 57 -86 57q-51 0 -72.5 -19t-21.5 -60h-128q3 34 16.5 64.5t40.5 53t68.5 35.5t100.5 13q103 0 153.5 -37.5t50.5 -96.5q0 -42 -23.5 -69t-64.5 -38q42 -8 73 -38t31 -83q0 -36 -15.5 -65t-44 -49t-69 -31t-91.5 -11 q-60 0 -102 14.5t-70 39t-41.5 56.5t-16.5 67h128q2 -42 24.5 -64t76.5 -22q41 0 67.5 16t26.5 57q0 36 -22 51t-69 15h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 510,
    d: "M29 0v492h128v-320l188 320h135v-492h-127v334l-199 -334h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 510,
    d: "M29 0zM418 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82zM29 0v492h128v-320l188 320h135v-492h-127v334l-199 -334h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 530,
    d: "M374 0v388h-135l-5 -88q-6 -96 -18.5 -155t-36 -91.5t-60 -43t-88.5 -10.5h-20v104h13q27 0 46 6.5t32 27.5t21 61t12 108l11 185h355v-492h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 626,
    d: "M481 0v341l-106 -341h-125l-105 339v-339h-116v492h181l105 -350l105 350h177v-492h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 510,
    d: "M29 0v492h127v-188h198v188h127v-492h-127v201h-198v-201h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 510,
    d: "M29 0v492h452v-492h-127v388h-198v-388h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 479,
    d: "M176 0v388h-169v104h464v-104h-168v-388h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 568,
    d: "M29 492h127v-389h197v389h127v-389h77v-252h-94v149h-434v492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 502,
    d: "M345 0v194q-29 -11 -68 -18t-82 -7q-40 0 -72 7.5t-54.5 26.5t-35 52.5t-12.5 85.5v151h127v-149q0 -47 23.5 -62.5t66.5 -15.5q30 0 58 5t49 15v207h127v-492h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 747,
    d: "M29 0v492h127v-388h156v388h123v-388h156v388h127v-492h-689z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 805,
    d: "M700 -149v149h-671v492h127v-388h156v388h123v-388h156v388h127v-388h76v-253h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 677,
    d: "M319 335h145q46 0 82.5 -9.5t62.5 -29.5t40 -51.5t14 -75.5q0 -89 -53 -129t-142 -40h-276v388h-185v104h312v-157zM319 242v-145h156q35 0 55.5 18.5t20.5 53.5q0 36 -20.5 54.5t-55.5 18.5h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 705,
    d: "M29 0zM156 492v-157h164q85 0 132.5 -42.5t47.5 -123.5q0 -82 -47.5 -125.5t-132.5 -43.5h-291v492h127zM156 242v-145h156q36 0 56 18.5t20 53.5q0 36 -20 54.5t-56 18.5h-156zM542 0v492h130v-492h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 513,
    d: "M156 492v-157h164q85 0 132.5 -42.5t47.5 -123.5q0 -82 -47.5 -125.5t-132.5 -43.5h-291v492h127zM156 242v-145h156q36 0 56 18.5t20 53.5q0 36 -20 54.5t-56 18.5h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 488,
    d: "M192 215v74h149q-3 27 -10 48t-19 36t-30.5 23t-45.5 8q-42 0 -66.5 -18.5t-29.5 -53.5h-129q7 49 30.5 82t55 53.5t68.5 29t73 8.5q48 0 90 -14.5t73 -45.5t49 -80t18 -117q0 -128 -62.5 -194.5t-168.5 -66.5q-39 0 -76.5 9.5t-68.5 30.5t-53 54t-29 79h128 q0 -16 8.5 -29.5t22 -23t31.5 -15t37 -5.5t37 6.5t32.5 21.5t24 39.5t11.5 60.5h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 731,
    d: "M29 0v492h130v-195h52q14 96 79 152t169 56q58 0 104.5 -18.5t79 -52t50 -81.5t17.5 -106q0 -59 -17.5 -107t-50 -82t-79 -52.5t-104.5 -18.5q-53 0 -95.5 15t-74.5 43t-52 67t-27 87h-51v-199h-130zM460 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 493,
    d: "M337 0v166h-90l-107 -166h-134l123 176q-54 14 -83 51t-29 100q0 81 47.5 123t131.5 42h268v-492h-127zM337 262v133h-132q-36 0 -56.5 -17t-20.5 -49q0 -33 20.5 -50t56.5 -17h132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    d: "M472 -33q0 -45 -14.5 -81.5t-40.5 -63t-61 -41t-76 -14.5q-9 0 -16.5 0.5t-14.5 1.5v116q5 -2 10 -3.5t15 -1.5q41 0 54 26t13 67v332q0 54 -19 75.5t-58 21.5q-28 0 -48.5 -9.5t-33.5 -25.5t-19.5 -38t-6.5 -47v-282h-130v538h-26v91h26v43h130v-43h165v-91h-165v-110 q15 34 55 55.5t93 21.5q36 0 66.5 -11t53 -31t35.5 -49t13 -66v-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 350,
    d: "M30 0zM120 554l-31 55l207 121l47 -82zM30 0v492h313v-104h-186v-388h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 488,
    d: "M146 215q2 -36 11.5 -60.5t23.5 -39.5t32 -21.5t38 -6.5q19 0 37 5.5t31.5 15t22 23t8.5 29.5h128q-7 -46 -29 -79t-53 -54t-68.5 -30.5t-76.5 -9.5q-106 0 -168.5 66.5t-62.5 194.5q0 68 18 117t49 80t73 45.5t90 14.5q36 0 73 -8.5t68.5 -29t54.5 -53.5t31 -82h-129 q-5 35 -29.5 53.5t-66.5 18.5q-27 0 -46 -8t-31 -23t-18.5 -36t-9.5 -48h149v-74h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 858,
    d: "M373 0v388h-135l-4 -72q-6 -102 -17.5 -164.5t-34.5 -96t-59.5 -44.5t-91.5 -11h-21v103h14q25 0 44 8t32.5 31.5t21.5 66t13 111.5l11 172h354v-157h150q44 0 80 -9.5t61.5 -30t39 -52t13.5 -74.5q0 -82 -47.5 -125.5t-131.5 -43.5h-292zM500 242v-145h156 q36 0 56.5 18.5t20.5 53.5q0 36 -20.5 54.5t-56.5 18.5h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 771,
    d: "M29 0v492h127v-157h165v157h127v-157h117q89 0 141 -39.5t52 -127.5q0 -87 -51.5 -127.5t-141.5 -40.5h-244v242h-165v-242h-127zM448 242v-145h122q35 0 55.5 18.5t20.5 53.5q0 36 -20.5 54.5t-55.5 18.5h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 483,
    d: "M26 0zM176 554l-31 55l207 121l47 -82zM328 0l-108 221l-63 -65v-156h-131v492h131v-187l162 187h159l-165 -181l161 -311h-146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 510,
    d: "M29 0zM99 648l47 82l207 -121l-31 -55zM29 0v492h128v-320l188 320h135v-492h-127v334l-199 -334h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    horizAdvX: 502,
    d: "M26 0zM339 65q-14 -33 -50.5 -51.5t-82.5 -18.5q-39 0 -72 12.5t-57 36t-37.5 56t-13.5 73.5v319h130v-300q0 -92 83 -92q45 0 72.5 26t27.5 66v300h130v-505q0 -52 -17.5 -93t-48 -69t-72 -43t-88.5 -15q-109 0 -163 55t-54 151h121q0 -44 25.5 -69t76.5 -25 q18 0 34 7.5t28.5 21t20 33.5t7.5 44v80zM414 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 510,
    d: "M29 492h127v-389h197v389h127v-492h-179v-149h-94v149h-178v492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 501,
    d: "M389 664v169h100v-282h-331v-551h-136v664h367z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 350,
    d: "M156 388v-388h-127v492h219v149h94v-253h-186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0492",
    unicode: "\u0492",
    horizAdvX: 556,
    d: "M213 278v-278h-135v278h-75v84h75v302h466v-113h-331v-189h168v-84h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0493",
    unicode: "\u0493",
    horizAdvX: 395,
    d: "M75 0v175h-75v84h75v233h313v-104h-186v-129h176v-84h-176v-175h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0496",
    unicode: "\u0496",
    horizAdvX: 951,
    d: "M841 -169v169h-126l-206 273v-273h-130v273l-206 -273h-166l279 338l-266 326h161l198 -246v246h130v-246l198 246h161l-267 -326l181 -220h158v-287h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0497",
    unicode: "\u0497",
    horizAdvX: 747,
    d: "M402 304l121 188h148l-178 -241l108 -147h135v-253h-94v149h-117l-123 184v-184h-120v184l-123 -184h-153l185 251l-178 241h148l121 -188v188h120v-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0498",
    unicode: "\u0498",
    horizAdvX: 564,
    d: "M225 291v115h62q57 0 88 24.5t31 64.5q0 38 -29.5 58t-93.5 20q-70 0 -102 -26t-32 -85h-131q0 48 14.5 89t46 71t82 47t123.5 17q65 0 113.5 -13.5t80 -37.5t47 -57.5t15.5 -73.5q0 -56 -28 -94.5t-82 -52.5q57 -11 94 -53t37 -114q0 -99 -73 -155.5t-204 -57.5 q51 -23 80.5 -55t29.5 -70q0 -39 -27.5 -62t-81.5 -23q-41 0 -65.5 7.5t-39.5 18.5v84q11 -4 24 -7t29 -3q10 0 15 5q23 2 37.5 10t14.5 22q0 10 -2.5 18.5t-11 17.5t-23.5 19t-39 22q-58 7 -99 27.5t-67.5 51t-39 70.5t-12.5 85h134q4 -60 37 -91.5t109 -31.5 q66 0 102 25.5t36 80.5q0 54 -34.5 73.5t-97.5 19.5h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0499",
    unicode: "\u0499",
    horizAdvX: 469,
    d: "M196 217v84h42q36 0 59.5 14t23.5 46q0 57 -86 57q-51 0 -72.5 -19t-21.5 -60h-128q3 34 16.5 64.5t40.5 53t68.5 35.5t100.5 13q103 0 153.5 -37.5t50.5 -96.5q0 -42 -23.5 -69t-64.5 -38q42 -8 73 -38t31 -83q0 -36 -15.5 -65t-44 -49t-69 -31t-91.5 -11q63 -24 99 -58 t36 -77q0 -39 -27.5 -62t-81.5 -23q-41 0 -65.5 7.5t-38.5 18.5v84q22 -10 53 -10q30 0 48 9t18 27q0 11 -3.5 20.5t-14 20t-30 22t-51.5 26.5q-44 6 -75.5 22.5t-52 39.5t-31.5 51t-13 59h128q2 -42 24.5 -64t76.5 -22q41 0 67.5 16t26.5 57q0 36 -22 51t-69 15h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049A",
    unicode: "\u049A",
    horizAdvX: 672,
    d: "M562 -169v169h-131l-197 299l-74 -73v-226h-137v664h137v-270l254 270h180l-262 -262l189 -284h140v-287h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049B",
    unicode: "\u049B",
    horizAdvX: 543,
    d: "M439 -149v149h-111l-108 221l-63 -65v-156h-131v492h131v-187l162 187h159l-165 -181l107 -207h113v-253h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A0",
    unicode: "\u04A0",
    horizAdvX: 788,
    d: "M620 0l-199 301l-78 -76v-225h-133v551h-202v113h335v-274l260 274h175l-262 -262l269 -402h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A1",
    unicode: "\u04A1",
    horizAdvX: 646,
    d: "M496 0l-110 223l-66 -67v-156h-128v388h-185v104h313v-190l167 190h156l-167 -181l163 -311h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A2",
    unicode: "\u04A2",
    horizAdvX: 654,
    d: "M544 -169v169h-118v300h-264v-300h-136v664h136v-251h264v251h137v-546h80v-287h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A3",
    unicode: "\u04A3",
    horizAdvX: 568,
    d: "M463 -149v149h-109v201h-198v-201h-127v492h127v-188h198v188h127v-388h76v-253h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AA",
    unicode: "\u04AA",
    horizAdvX: 613,
    d: "M608 228q-11 -57 -35 -103t-61 -79t-86 -51t-108 -18q51 -23 81 -54.5t30 -72.5q0 -38 -28 -60.5t-86 -22.5q-33 0 -59 7.5t-40 18.5v84q10 -5 23.5 -7.5t31.5 -2.5q64 0 64 40q0 18 -16.5 35.5t-67.5 41.5q-53 11 -96 38t-74.5 70t-48.5 101.5t-17 133.5 q0 83 21.5 149.5t61.5 113t97.5 71.5t128.5 25q62 0 112.5 -18.5t87 -51t58 -76.5t26.5 -94h-139q-14 54 -52 87t-98 33q-81 0 -122 -62.5t-41 -173.5q0 -109 40.5 -170.5t122.5 -61.5q60 0 98 33.5t52 96.5h139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AB",
    unicode: "\u04AB",
    horizAdvX: 481,
    d: "M469 178q-5 -42 -23.5 -76t-47 -59t-65.5 -39.5t-80 -16.5q63 -24 99.5 -58t36.5 -79q0 -38 -28.5 -60.5t-86.5 -22.5q-33 0 -59 7.5t-40 18.5v84q11 -5 24 -7.5t31 -2.5q64 0 64 40q0 9 -4 18.5t-15 19t-30 21t-49 25.5q-81 14 -130 79t-49 182q0 66 16.5 114t46.5 78.5 t72.5 45.5t94.5 15q48 0 87.5 -13t69 -38t46.5 -60t20 -78h-131q-5 38 -30.5 59.5t-62.5 21.5q-21 0 -39 -7t-31.5 -23.5t-21.5 -44t-8 -67.5q0 -81 29 -120t67 -39t65 21t31 61h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B2",
    unicode: "\u04B2",
    horizAdvX: 669,
    d: "M559 -169v169h-132l-127 228l-134 -228h-162l215 339l-203 325h164l120 -215l121 215h161l-202 -319l142 -227h136v-287h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B3",
    unicode: "\u04B3",
    horizAdvX: 556,
    d: "M452 -149v149h-123l-86 148l-84 -148h-156l165 251l-160 241h157l83 -143l84 143h151l-163 -241l98 -147h128v-253h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B6",
    unicode: "\u04B6",
    horizAdvX: 636,
    d: "M526 -169v169h-117v264q-35 -15 -81.5 -23.5t-97.5 -8.5q-47 0 -85.5 9.5t-65.5 33.5t-42 65.5t-15 106.5v217h137v-214q0 -63 30.5 -84t85.5 -21q36 0 71.5 6.5t62.5 20.5v292h135v-546h81v-287h-99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B7",
    unicode: "\u04B7",
    horizAdvX: 560,
    d: "M455 -149v149h-110v194q-29 -11 -68 -18t-82 -7q-40 0 -72 7.5t-54.5 26.5t-35 52.5t-12.5 85.5v151h127v-149q0 -47 23.5 -62.5t66.5 -15.5q30 0 58 5t49 15v207h127v-388h77v-253h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BA",
    unicode: "\u04BA",
    horizAdvX: 570,
    d: "M161 664v-264q35 15 81.5 23.5t97.5 8.5q47 0 85.5 -9.5t65.5 -33.5t42 -65.5t15 -106.5v-217h-137v214q0 63 -30.5 84t-85.5 21q-36 0 -71.5 -6.5t-62.5 -20.5v-292h-135v664h135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C3",
    unicode: "\u04C3",
    horizAdvX: 604,
    d: "M583 -49q0 -39 -12 -72.5t-36 -58.5t-59 -39t-81 -14q-91 0 -140.5 55t-49.5 151h119q1 -42 16 -67.5t55 -25.5q32 0 49.5 17.5t17.5 50.5q0 29 -15 58.5t-48 74.5l-163 220l-77 -76v-225h-133v664h133v-275l259 275h176l-131 -131l-131 -131l180 -264q36 -54 53.5 -97.5 t17.5 -89.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C4",
    unicode: "\u04C4",
    horizAdvX: 483,
    d: "M425 95q19 -36 29.5 -75t10.5 -77q0 -43 -13.5 -75.5t-37.5 -55t-57.5 -34t-72.5 -11.5q-87 0 -133.5 51t-48.5 140h109q2 -38 16 -60t47 -22q31 0 47 20t16 52q0 20 -7 43t-25 61l-82 171l-66 -67v-156h-128v492h128v-190l168 190h155l-167 -181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C7",
    unicode: "\u04C7",
    horizAdvX: 587,
    d: "M426 300h-264v-300h-136v664h136v-251h264v251h137v-697q0 -45 -15 -81.5t-42.5 -63t-66 -41t-84.5 -14.5q-91 0 -141.5 54.5t-50.5 151.5h119q1 -45 16.5 -69t55.5 -24t56 24.5t16 67.5v328z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C8",
    unicode: "\u04C8",
    horizAdvX: 510,
    d: "M29 0v492h127v-188h197v188h127v-531q0 -43 -14 -79t-39.5 -61.5t-61.5 -39.5t-81 -14q-88 0 -135.5 53.5t-47.5 145.5h119q1 -40 14.5 -63t51.5 -23t52.5 22.5t14.5 63.5v234h-197v-200h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E8",
    unicode: "\u04E8",
    horizAdvX: 670,
    d: "M334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5q0 -172 -81.5 -259t-235.5 -87zM334 96q34 0 64 11t53.5 33.5t39 57t20.5 81.5h-357q9 -95 55.5 -139t124.5 -44zM334 563 q-74 0 -118.5 -42.5t-58.5 -126.5h351q-26 169 -174 169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E9",
    unicode: "\u04E9",
    horizAdvX: 539,
    d: "M268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5zM268 96q100 0 116 106h-232q15 -106 116 -106zM268 395q-98 0 -116 -102 h231q-17 102 -115 102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EE",
    unicode: "\u04EE",
    horizAdvX: 575,
    d: "M26 0zM98 774v91h381v-91h-381zM548 219q0 -121 -69.5 -181.5t-197.5 -60.5q-117 0 -181.5 55t-65.5 182h123q1 -66 35 -96.5t92 -30.5q60 0 94.5 31.5t34.5 100.5v115q-23 -42 -71 -64t-109 -22q-47 0 -85 14t-65 44t-42 76t-15 110v172h137v-171q0 -69 34.5 -100 t85.5 -31q59 0 94.5 35t35.5 95v172h135v-445v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EF",
    unicode: "\u04EF",
    horizAdvX: 502,
    d: "M26 0zM339 65q-14 -33 -50.5 -51.5t-82.5 -18.5q-39 0 -72 12.5t-57 36t-37.5 56t-13.5 73.5v319h130v-300q0 -92 83 -92q45 0 72.5 26t27.5 66v300h130v-505q0 -52 -17.5 -93t-48 -69t-72 -43t-88.5 -15q-109 0 -163 55t-54 151h121q0 -44 25.5 -69t76.5 -25 q18 0 34 7.5t28.5 21t20 33.5t7.5 44v80zM62 602v91h381v-91h-381z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0512",
    unicode: "\u0512",
    horizAdvX: 628,
    d: "M466 551h-179l-8 -146q-7 -131 -23 -211t-44.5 -123t-72 -57t-106.5 -14h-25v118h16q34 0 57 9t38.5 39t24 87t14.5 152l15 259h430v-697q0 -45 -16 -81.5t-44 -63t-67 -41t-85 -14.5q-91 0 -139.5 55t-48.5 151h119q1 -43 16 -68t56 -25q40 0 56 24.5t16 67.5v579z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0513",
    unicode: "\u0513",
    horizAdvX: 530,
    d: "M374 388h-135l-5 -88q-6 -96 -18.5 -155t-36 -91.5t-60 -43t-88.5 -10.5h-20v104h13q27 0 46 6.5t32 27.5t21 61t12 108l11 185h355v-532q0 -43 -14 -78.5t-39.5 -61t-61.5 -39.5t-81 -14q-89 0 -136 53t-47 146h119q0 -41 14 -63.5t51 -22.5q38 0 53 23t15 63v422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni058F",
    unicode: "\u058F",
    horizAdvX: 488,
    d: "M429 126v-126h-136v126h-188v84h188v72h-188v84h188v114q0 47 -19.5 71.5t-62.5 24.5q-42 0 -61.5 -24t-19.5 -72v-67h-123v68q0 108 54.5 157t151.5 49q106 0 161 -53t55 -149v-119h54v-84h-54v-72h54v-84h-54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E0C",
    unicode: "\u1E0C",
    horizAdvX: 607,
    d: "M23 0zM273 113q91 0 132 56.5t41 169.5q0 56 -10 96t-32.5 65.5t-57.5 37t-85 11.5h-103v-436h115zM23 0v664h257q67 0 124 -22.5t97.5 -64.5t63.5 -102t23 -136t-20.5 -138.5t-58.5 -107t-91 -69t-117 -24.5h-278zM221 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E0D",
    unicode: "\u1E0D",
    horizAdvX: 523,
    d: "M16 0zM259 93q47 0 78.5 39t31.5 102q0 160 -109 160q-112 0 -112 -152q0 -66 31 -107.5t80 -41.5zM367 0l-1 60q-45 -73 -137 -73q-47 0 -86 18t-67 52t-44 83t-16 111q0 56 13.5 102.5t39.5 80.5t63.5 52.5t85.5 18.5q91 0 146 -77v244h128v-672h-125zM191 -206v124 h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E12",
    unicode: "\u1E12",
    horizAdvX: 607,
    d: "M23 0zM273 113q91 0 132 56.5t41 169.5q0 56 -10 96t-32.5 65.5t-57.5 37t-85 11.5h-103v-436h115zM23 0v664h257q67 0 124 -22.5t97.5 -64.5t63.5 -102t23 -136t-20.5 -138.5t-58.5 -107t-91 -69t-117 -24.5h-278zM282 -109l-135 -118l-46 51l128 134h106l128 -134 l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E13",
    unicode: "\u1E13",
    horizAdvX: 523,
    d: "M16 0zM259 93q47 0 78.5 39t31.5 102q0 160 -109 160q-112 0 -112 -152q0 -66 31 -107.5t80 -41.5zM367 0l-1 60q-45 -73 -137 -73q-47 0 -86 18t-67 52t-44 83t-16 111q0 56 13.5 102.5t39.5 80.5t63.5 52.5t85.5 18.5q91 0 146 -77v244h128v-672h-125zM253 -109 l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E24",
    unicode: "\u1E24",
    horizAdvX: 587,
    d: "M23 0zM421 0v298h-259v-298h-139v664h139v-250h259v250h140v-664h-140zM233 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E25",
    unicode: "\u1E25",
    d: "M26 0zM341 0v305q0 56 -19.5 76.5t-64.5 20.5q-24 0 -43 -9.5t-32 -26t-19.5 -38t-6.5 -46.5v-282h-130v672h130v-244q7 16 21.5 30.5t33.5 24.5t42 16t48 6q76 0 123.5 -41.5t47.5 -115.5v-348h-131zM191 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E3C",
    unicode: "\u1E3C",
    horizAdvX: 501,
    d: "M23 0zM23 0v664h139v-543h329v-121h-468zM262 -109l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E3D",
    unicode: "\u1E3D",
    horizAdvX: 237,
    d: "M0 0zM52 0v672h130v-672h-130zM120 -109l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E44",
    unicode: "\u1E44",
    horizAdvX: 591,
    d: "M23 0zM436 0l-284 446v-446h-129v664h147l264 -427v427h130v-664h-128zM235 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E45",
    unicode: "\u1E45",
    d: "M26 0zM341 0v298q0 57 -19 77t-65 20q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-341h-131zM192 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E4A",
    unicode: "\u1E4A",
    horizAdvX: 591,
    d: "M23 0zM436 0l-284 446v-446h-129v664h147l264 -427v427h130v-664h-128zM297 -109l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E4B",
    unicode: "\u1E4B",
    d: "M26 0zM341 0v298q0 57 -19 77t-65 20q-101 0 -101 -113v-282h-130v492h124v-72q23 42 61 63.5t98 21.5q35 0 65 -10.5t51.5 -31.5t34 -51.5t12.5 -70.5v-341h-131zM253 -109l-135 -118l-46 51l128 134h106l128 -134l-46 -51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E5A",
    unicode: "\u1E5A",
    horizAdvX: 578,
    d: "M23 0zM158 549v-177h174q56 0 79 25t23 63q0 39 -22.5 64t-74.5 25h-179zM410 0v171q0 48 -22 68.5t-82 20.5h-148v-260h-135v664h337q46 0 83.5 -14.5t64.5 -40t41.5 -61t14.5 -76.5q0 -54 -25.5 -95.5t-73.5 -58.5q44 -14 62.5 -43t18.5 -87v-188h-136zM229 -206v124 h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E5B",
    unicode: "\u1E5B",
    horizAdvX: 321,
    d: "M26 0zM26 0v492h122v-59q16 25 33.5 39t36 21.5t37.5 9.5t39 2h17v-133q-18 3 -36 3q-119 0 -119 -119v-256h-130zM33 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E62",
    unicode: "\u1E62",
    horizAdvX: 563,
    d: "M6 0zM399 468q-5 51 -37 76t-95 25q-59 0 -89 -20t-30 -58q0 -32 23.5 -51t79.5 -33q57 -14 108.5 -27.5t88.5 -30.5q22 -10 41 -23t33 -32t22 -45t8 -61q0 -55 -19.5 -94.5t-55 -65.5t-84 -38.5t-106.5 -12.5q-62 0 -113 13.5t-88 41.5t-58 69.5t-22 97.5h134 q2 -51 41.5 -80.5t106.5 -29.5q62 0 95.5 24.5t33.5 69.5q0 15 -4.5 27t-16 22.5t-31.5 19t-51 15.5q-62 14 -104.5 24.5t-77.5 26.5q-54 24 -82.5 62.5t-28.5 101.5q0 45 15 82.5t45.5 64.5t76 42t106.5 15q63 0 112 -16t82.5 -45t52 -69t20.5 -88h-132zM221 -206v124h130 v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E63",
    unicode: "\u1E63",
    horizAdvX: 472,
    d: "M9 0zM322 343q-5 36 -26 50.5t-66 14.5q-37 0 -57 -9.5t-20 -31.5t20 -33.5t60 -22.5q42 -12 80 -21.5t67 -20.5q39 -16 60 -43.5t21 -75.5q0 -77 -54.5 -120t-160.5 -43q-114 0 -174.5 48t-62.5 123h134q0 -35 27 -54t75 -19q35 0 61 11.5t26 39.5q0 26 -23.5 37 t-55.5 19q-62 15 -100 27t-64 29q-35 22 -48.5 50t-13.5 61q0 31 11 58t36 46.5t64.5 30.5t95.5 11q107 0 157.5 -41t55.5 -121h-125zM176 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E6C",
    unicode: "\u1E6C",
    horizAdvX: 554,
    d: "M4 0zM204 0v548h-200v116h540v-116h-201v-548h-139zM217 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E6D",
    unicode: "\u1E6D",
    horizAdvX: 453,
    d: "M26 0zM305 324h121v-140q0 -39 -11.5 -74.5t-36 -63t-62 -43.5t-89.5 -16q-54 0 -92 16t-62.5 43t-35.5 63t-11 76v440h128v-133h272v-92h-272v-202q0 -47 17.5 -72.5t57.5 -25.5q39 0 57.5 25t18.5 71v128zM166 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 856,
    d: "M3 0zM529 0l-103 432l-105 -432h-130l-188 664h148l109 -430l92 430h146l101 -430l108 430h142l-186 -664h-134zM272 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 714,
    d: "M3 0zM432 0l-78 286l-78 -286h-133l-140 492h137l80 -316l68 316h132l77 -316l75 316h134l-141 -492h-133zM201 648l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 856,
    d: "M3 0zM529 0l-103 432l-105 -432h-130l-188 664h148l109 -430l92 430h146l101 -430l108 430h142l-186 -664h-134zM363 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 714,
    d: "M3 0zM432 0l-78 286l-78 -286h-133l-140 492h137l80 -316l68 316h132l77 -316l75 316h134l-141 -492h-133zM292 554l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 856,
    d: "M3 0zM529 0l-103 432l-105 -432h-130l-188 664h148l109 -430l92 430h146l101 -430l108 430h142l-186 -664h-134zM267 751v124h130v-124h-130zM467 751v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 714,
    d: "M3 0zM432 0l-78 286l-78 -286h-133l-140 492h137l80 -316l68 316h132l77 -316l75 316h134l-141 -492h-133zM196 579v124h130v-124h-130zM396 579v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E92",
    unicode: "\u1E92",
    horizAdvX: 532,
    d: "M4 0zM4 0v118l345 430h-335v116h509v-109l-347 -437h347v-118h-519zM206 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E93",
    unicode: "\u1E93",
    horizAdvX: 445,
    d: "M9 0zM9 0v100l251 289h-234v103h400v-105l-251 -281h258v-106h-424zM162 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 603,
    d: "M543 664v-106l-129 -134q90 -13 137 -68t47 -142q0 -53 -17.5 -95.5t-49 -71.5t-75.5 -44.5t-97 -15.5q-34 0 -66 5.5t-52 13.5v106q18 -8 43.5 -13t49.5 -5q60 0 96 31t36 89q0 30 -10 52.5t-27 37.5t-40 22.5t-48 7.5q-38 0 -72 -17v95l134 148h-106q-42 0 -68 -11.5 t-40 -34.5t-19 -57t-5 -78v-379h-139v430q0 114 69.5 174t201.5 60h246z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA0",
    unicode: "\u1EA0",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM261 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA1",
    unicode: "\u1EA1",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM182 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA2",
    unicode: "\u1EA2",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM294 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22 t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA3",
    unicode: "\u1EA3",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM221 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6 q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA4",
    unicode: "\u1EA4",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM321 844l-116 -101l-39 44l110 115h91l110 -115l-40 -44zM505 756l-25 46l171 100l39 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA5",
    unicode: "\u1EA5",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM247 672l-116 -101l-39 44l110 115h91l110 -115l-40 -44zM431 584l-25 46l171 100l39 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA6",
    unicode: "\u1EA6",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM332 844l-116 -101l-40 44l110 115h91l110 -115l-39 -44zM467 834l39 68l171 -100l-25 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA7",
    unicode: "\u1EA7",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM246 672l-116 -101l-40 44l110 115h91l110 -115l-39 -44zM381 662l39 68l171 -100l-25 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA8",
    unicode: "\u1EA8",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM504 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22 t-20.5 -20t-9 -28.5h-50zM328 844l-116 -101l-40 44l110 115h91l110 -115l-39 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA9",
    unicode: "\u1EA9",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM421 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6 q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50zM245 672l-116 -101l-40 44l110 115h91l110 -115l-39 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAA",
    unicode: "\u1EAA",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM451 904q-9 -36 -31.5 -48.5t-46.5 -12.5q-12 0 -26 3t-27.5 7t-25.5 7t-21 3q-16 0 -28 -32l-49 20q9 34 28 48.5t42 14.5q18 0 32 -3.5t26.5 -8t24 -8t23.5 -3.5 q11 0 18 5.5t10 21.5zM424 726l-102 70l-101 -70l-35 30l96 80h80l96 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAB",
    unicode: "\u1EAB",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM378 732q-9 -36 -31.5 -48.5t-46.5 -12.5q-12 0 -26 3t-27.5 7t-25.5 7t-21 3q-16 0 -28 -32l-49 20 q9 34 28 48.5t42 14.5q18 0 32 -3.5t26.5 -8t24 -8t23.5 -3.5q11 0 18 5.5t10 21.5zM351 554l-102 70l-101 -70l-35 30l96 80h80l96 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAC",
    unicode: "\u1EAC",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM322 851l-135 -118l-46 51l128 134h106l128 -134l-46 -51zM261 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAD",
    unicode: "\u1EAD",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM244 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51zM173 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAE",
    unicode: "\u1EAE",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM433 840q0 -29 -9.5 -50t-25 -35.5t-36 -21.5t-41.5 -7t-41 7t-35.5 21.5t-25 35.5t-9.5 50h57q0 -29 14.5 -44.5t39.5 -15.5q26 0 40 15.5t15 44.5h57zM293 816l-18 33 l119 69l27 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAF",
    unicode: "\u1EAF",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM355 668q0 -29 -9.5 -50t-25 -35.5t-36 -21.5t-41.5 -7t-41 7t-35.5 21.5t-25 35.5t-9.5 50h57q0 -29 14.5 -44.5 t39.5 -15.5q26 0 40 15.5t15 44.5h57zM215 644l-18 33l119 69l27 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB0",
    unicode: "\u1EB0",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM433 840q0 -29 -9.5 -50t-25 -35.5t-35.5 -21.5t-41 -7t-41.5 7t-36 21.5t-25 35.5t-9.5 50h57q1 -29 15 -44.5t40 -15.5q25 0 39.5 15.5t14.5 44.5h57zM222 871l27 47 l119 -69l-18 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB1",
    unicode: "\u1EB1",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM359 668q0 -29 -9.5 -50t-25 -35.5t-35.5 -21.5t-41 -7t-41.5 7t-36 21.5t-25 35.5t-9.5 50h57q1 -29 15 -44.5 t40 -15.5q25 0 39.5 15.5t14.5 44.5h57zM148 699l27 47l119 -69l-18 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB2",
    unicode: "\u1EB2",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM433 840q0 -29 -9.5 -50t-25 -35.5t-35.5 -21.5t-41 -7t-41.5 7t-36 21.5t-25 35.5t-9.5 50h57q1 -29 15 -44.5t40 -15.5q25 0 39.5 15.5t14.5 44.5h57zM296 795q0 13 4 23 t15 17q8 5 12.5 9t4.5 13q0 13 -18 13q-13 0 -31 -11l-13 40q11 10 26 14.5t26 4.5q26 0 40.5 -12.5t14.5 -32.5q0 -16 -7 -25t-15 -16.5t-15 -15.5t-7 -21h-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB3",
    unicode: "\u1EB3",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM357 668q0 -29 -9.5 -50t-25 -35.5t-35.5 -21.5t-41 -7t-41.5 7t-36 21.5t-25 35.5t-9.5 50h57q1 -29 15 -44.5 t40 -15.5q25 0 39.5 15.5t14.5 44.5h57zM220 623q0 13 4 23t15 17q8 5 12.5 9t4.5 13q0 13 -18 13q-13 0 -31 -11l-13 40q11 10 26 14.5t26 4.5q26 0 40.5 -12.5t14.5 -32.5q0 -16 -7 -25t-15 -16.5t-15 -15.5t-7 -21h-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB4",
    unicode: "\u1EB4",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM413 908q-6 -28 -21 -41t-32 -13q-10 0 -18.5 3.5t-16.5 7.5t-16.5 7.5t-17.5 3.5q-5 0 -8.5 -4.5t-8.5 -18.5l-37 18q8 25 21 35t30 10q10 0 18.5 -3.5t17 -8t17 -8 t18.5 -3.5q12 0 15 25zM433 840q0 -29 -9.5 -50t-25 -35.5t-35.5 -21.5t-41 -7t-41.5 7t-36 21.5t-25 35.5t-9.5 50h57q1 -29 15 -44.5t40 -15.5q25 0 39.5 15.5t14.5 44.5h57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB5",
    unicode: "\u1EB5",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM335 736q-6 -28 -21 -41t-32 -13q-10 0 -18.5 3.5t-16.5 7.5t-16.5 7.5t-17.5 3.5q-5 0 -8.5 -4.5t-8.5 -18.5 l-37 18q8 25 21 35t30 10q10 0 18.5 -3.5t17 -8t17 -8t18.5 -3.5q12 0 15 25zM355 668q0 -29 -9.5 -50t-25 -35.5t-35.5 -21.5t-41 -7t-41.5 7t-36 21.5t-25 35.5t-9.5 50h57q1 -29 15 -44.5t40 -15.5q25 0 39.5 15.5t14.5 44.5h57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB6",
    unicode: "\u1EB6",
    horizAdvX: 643,
    d: "M3 0zM319 515h-1l-85 -264h169zM484 0l-42 137h-245l-47 -137h-147l237 664h161l234 -664h-151zM485 918q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82zM261 -206v124 h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB7",
    unicode: "\u1EB7",
    horizAdvX: 486,
    d: "M13 0zM325 241q-10 -10 -29 -16t-55 -13q-56 -11 -77 -28t-21 -49q0 -55 63 -55q25 0 46.5 8.5t37 23t25 34t9.5 41.5zM334 0q-6 19 -8 44q-23 -26 -61 -41.5t-88 -15.5q-85 0 -124.5 37.5t-39.5 97.5q0 53 17 84.5t47 49.5t71.5 26.5t90.5 15.5t66 18.5t17 37.5 q0 24 -22.5 37.5t-60.5 13.5q-45 0 -64.5 -20t-24.5 -53h-121q1 38 12.5 70t37 55t66.5 35.5t100 12.5q58 0 98.5 -13t65 -37.5t35.5 -61t11 -82.5v-311h-121zM406 746q0 -42 -13.5 -73t-36 -51.5t-52 -31t-60.5 -10.5t-60.5 10.5t-52 31t-36 51.5t-13.5 73h82 q2 -42 22.5 -64.5t57.5 -22.5t57.5 22.5t22.5 64.5h82zM173 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB8",
    unicode: "\u1EB8",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM211 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB9",
    unicode: "\u1EB9",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM193 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBA",
    unicode: "\u1EBA",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM246 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBB",
    unicode: "\u1EBB",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM224 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBC",
    unicode: "\u1EBC",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM445 846q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBD",
    unicode: "\u1EBD",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM425 674q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBE",
    unicode: "\u1EBE",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM278 844l-116 -101l-39 44l110 115h91l110 -115l-40 -44zM462 756l-25 46l171 100l39 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBF",
    unicode: "\u1EBF",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM256 672l-116 -101l-39 44l110 115h91l110 -115l-40 -44zM440 584l-25 46l171 100l39 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC0",
    unicode: "\u1EC0",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM280 844l-116 -101l-40 44l110 115h91l110 -115l-39 -44zM415 834l39 68l171 -100l-25 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC1",
    unicode: "\u1EC1",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM257 672l-116 -101l-40 44l110 115h91l110 -115l-39 -44zM392 662l39 68l171 -100l-25 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC2",
    unicode: "\u1EC2",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM454 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z M278 844l-116 -101l-40 44l110 115h91l110 -115l-39 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC3",
    unicode: "\u1EC3",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM429 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50zM253 672l-116 -101l-40 44l110 115h91l110 -115l-39 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC4",
    unicode: "\u1EC4",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM403 904q-9 -36 -31.5 -48.5t-46.5 -12.5q-12 0 -26 3t-27.5 7t-25.5 7t-21 3q-16 0 -28 -32l-49 20q9 34 28 48.5t42 14.5q18 0 32 -3.5t26.5 -8t24 -8t23.5 -3.5q11 0 18 5.5t10 21.5zM376 726 l-102 70l-101 -70l-35 30l96 80h80l96 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC5",
    unicode: "\u1EC5",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM381 732q-9 -36 -31.5 -48.5t-46.5 -12.5q-12 0 -26 3t-27.5 7t-25.5 7t-21 3q-16 0 -28 -32l-49 20q9 34 28 48.5t42 14.5q18 0 32 -3.5t26.5 -8t24 -8t23.5 -3.5q11 0 18 5.5t10 21.5zM354 554l-102 70l-101 -70l-35 30l96 80h80l96 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC6",
    unicode: "\u1EC6",
    horizAdvX: 532,
    d: "M23 0zM23 0v664h488v-116h-353v-142h325v-117h-325v-171h369v-118h-504zM269 851l-135 -118l-46 51l128 134h106l128 -134l-46 -51zM206 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC7",
    unicode: "\u1EC7",
    d: "M15 0zM350 294q-1 27 -9.5 47.5t-22.5 34t-32 20t-37 6.5q-39 0 -67.5 -28.5t-32.5 -79.5h201zM145 212q3 -56 32.5 -89t77.5 -33q32 0 56.5 14.5t31.5 40.5h134q-23 -76 -80 -117t-136 -41q-246 0 -246 268q0 57 16 103t46.5 79t74.5 50.5t101 17.5q114 0 172.5 -73 t58.5 -220h-339zM253 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51zM191 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC8",
    unicode: "\u1EC8",
    horizAdvX: 187,
    d: "M23 0zM23 0v664h139v-664h-139zM62 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC9",
    unicode: "\u1EC9",
    horizAdvX: 192,
    d: "M29 0zM29 0v492h130v-492h-130zM66 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECA",
    unicode: "\u1ECA",
    horizAdvX: 187,
    d: "M23 0zM23 0v664h139v-664h-139zM34 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECB",
    unicode: "\u1ECB",
    horizAdvX: 192,
    d: "M29 0zM29 0v492h130v-492h-130zM29 551v121h130v-121h-130zM36 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECC",
    unicode: "\u1ECC",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM275 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECD",
    unicode: "\u1ECD",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M209 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECE",
    unicode: "\u1ECE",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM306 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECF",
    unicode: "\u1ECF",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M240 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED0",
    unicode: "\u1ED0",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM340 844l-116 -101l-39 44l110 115h91l110 -115l-40 -44zM524 756l-25 46l171 100l39 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED1",
    unicode: "\u1ED1",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M274 672l-116 -101l-39 44l110 115h91l110 -115l-40 -44zM458 584l-25 46l171 100l39 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED2",
    unicode: "\u1ED2",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM342 844l-116 -101l-40 44l110 115h91l110 -115l-39 -44zM477 834l39 68l171 -100l-25 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED3",
    unicode: "\u1ED3",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M278 672l-116 -101l-40 44l110 115h91l110 -115l-39 -44zM413 662l39 68l171 -100l-25 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED4",
    unicode: "\u1ED4",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM513 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50zM337 844l-116 -101l-40 44l110 115h91 l110 -115l-39 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED5",
    unicode: "\u1ED5",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M448 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50zM272 672l-116 -101l-40 44l110 115h91l110 -115l-39 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED6",
    unicode: "\u1ED6",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM465 904q-9 -36 -31.5 -48.5t-46.5 -12.5q-12 0 -26 3t-27.5 7t-25.5 7t-21 3q-16 0 -28 -32l-49 20q9 34 28 48.5t42 14.5q18 0 32 -3.5t26.5 -8t24 -8t23.5 -3.5q11 0 18 5.5t10 21.5zM438 726l-102 70l-101 -70l-35 30l96 80h80l96 -80z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED7",
    unicode: "\u1ED7",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M399 732q-9 -36 -31.5 -48.5t-46.5 -12.5q-12 0 -26 3t-27.5 7t-25.5 7t-21 3q-16 0 -28 -32l-49 20q9 34 28 48.5t42 14.5q18 0 32 -3.5t26.5 -8t24 -8t23.5 -3.5q11 0 18 5.5t10 21.5zM372 554l-102 70l-101 -70l-35 30l96 80h80l96 -80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED8",
    unicode: "\u1ED8",
    horizAdvX: 670,
    d: "M15 0zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM334 -23q-154 0 -236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q76 0 135.5 -24.5t99.5 -71.5t61 -114.5t21 -152.5 q0 -172 -81.5 -259t-235.5 -87zM336 851l-135 -118l-46 51l128 134h106l128 -134l-46 -51zM275 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED9",
    unicode: "\u1ED9",
    horizAdvX: 539,
    d: "M15 0zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM268 -13q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q58 0 104 -18.5t78.5 -52t50 -81.5t17.5 -107t-17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5z M270 679l-135 -118l-46 51l128 134h106l128 -134l-46 -51zM209 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDA",
    unicode: "\u1EDA",
    horizAdvX: 769,
    d: "M15 0zM752 702q10 -11 15.5 -32.5t5.5 -45.5q0 -57 -25.5 -82t-66.5 -25q-35 0 -74 15q44 -85 44 -209q0 -172 -81.5 -259t-235.5 -87t-236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q126 0 206 -68q24 -20 50 -27.5t53 -7.5q29 0 38.5 19.5t9.5 43.5 q0 17 -2.5 32t-6.5 24h70zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM271 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDB",
    unicode: "\u1EDB",
    horizAdvX: 651,
    d: "M15 0zM203 554l-31 55l207 121l47 -82zM634 543q10 -11 15.5 -32.5t5.5 -45.5q0 -20 -4 -39t-13.5 -34t-25 -24.5t-37.5 -9.5q-49 0 -83 14q26 -55 26 -126q0 -59 -17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106 t50.5 82t79.5 52.5t105.5 18.5q91 0 154 -46q30 -22 54.5 -28.5t48.5 -6.5q29 0 38.5 19.5t9.5 43.5q0 17 -2.5 32t-6.5 24h70zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDC",
    unicode: "\u1EDC",
    horizAdvX: 769,
    d: "M15 0zM752 702q10 -11 15.5 -32.5t5.5 -45.5q0 -57 -25.5 -82t-66.5 -25q-35 0 -74 15q44 -85 44 -209q0 -172 -81.5 -259t-235.5 -87t-236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q126 0 206 -68q24 -20 50 -27.5t53 -7.5q29 0 38.5 19.5t9.5 43.5 q0 17 -2.5 32t-6.5 24h70zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM180 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDD",
    unicode: "\u1EDD",
    horizAdvX: 651,
    d: "M15 0zM114 648l47 82l207 -121l-31 -55zM634 543q10 -11 15.5 -32.5t5.5 -45.5q0 -20 -4 -39t-13.5 -34t-25 -24.5t-37.5 -9.5q-49 0 -83 14q26 -55 26 -126q0 -59 -17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5q-60 0 -107 19t-79.5 53t-49.5 82t-17 105 q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5q91 0 154 -46q30 -22 54.5 -28.5t48.5 -6.5q29 0 38.5 19.5t9.5 43.5q0 17 -2.5 32t-6.5 24h70zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDE",
    unicode: "\u1EDE",
    horizAdvX: 769,
    d: "M15 0zM752 702q10 -11 15.5 -32.5t5.5 -45.5q0 -57 -25.5 -82t-66.5 -25q-35 0 -74 15q44 -85 44 -209q0 -172 -81.5 -259t-235.5 -87t-236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q126 0 206 -68q24 -20 50 -27.5t53 -7.5q29 0 38.5 19.5t9.5 43.5 q0 17 -2.5 32t-6.5 24h70zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM308 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6 q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDF",
    unicode: "\u1EDF",
    horizAdvX: 651,
    d: "M15 0zM634 543q10 -11 15.5 -32.5t5.5 -45.5q0 -20 -4 -39t-13.5 -34t-25 -24.5t-37.5 -9.5q-49 0 -83 14q26 -55 26 -126q0 -59 -17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5 q91 0 154 -46q30 -22 54.5 -28.5t48.5 -6.5q29 0 38.5 19.5t9.5 43.5q0 17 -2.5 32t-6.5 24h70zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM248 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19 t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE0",
    unicode: "\u1EE0",
    horizAdvX: 769,
    d: "M15 0zM752 702q10 -11 15.5 -32.5t5.5 -45.5q0 -57 -25.5 -82t-66.5 -25q-35 0 -74 15q44 -85 44 -209q0 -172 -81.5 -259t-235.5 -87t-236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q126 0 206 -68q24 -20 50 -27.5t53 -7.5q29 0 38.5 19.5t9.5 43.5 q0 17 -2.5 32t-6.5 24h70zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM510 846q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5 t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE1",
    unicode: "\u1EE1",
    horizAdvX: 651,
    d: "M15 0zM634 543q10 -11 15.5 -32.5t5.5 -45.5q0 -20 -4 -39t-13.5 -34t-25 -24.5t-37.5 -9.5q-49 0 -83 14q26 -55 26 -126q0 -59 -17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5 q91 0 154 -46q30 -22 54.5 -28.5t48.5 -6.5q29 0 38.5 19.5t9.5 43.5q0 17 -2.5 32t-6.5 24h70zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM443 674q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37 q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE2",
    unicode: "\u1EE2",
    horizAdvX: 769,
    d: "M15 0zM752 702q10 -11 15.5 -32.5t5.5 -45.5q0 -57 -25.5 -82t-66.5 -25q-35 0 -74 15q44 -85 44 -209q0 -172 -81.5 -259t-235.5 -87t-236.5 90t-82.5 259q0 84 21 151t62 113.5t100 71t136 24.5q126 0 206 -68q24 -20 50 -27.5t53 -7.5q29 0 38.5 19.5t9.5 43.5 q0 17 -2.5 32t-6.5 24h70zM334 96q37 0 70 13.5t57.5 41t38.5 70.5t14 102q0 118 -46 179t-134 61t-135 -61t-47 -179t47.5 -172.5t134.5 -54.5zM271 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE3",
    unicode: "\u1EE3",
    horizAdvX: 651,
    d: "M15 0zM634 543q10 -11 15.5 -32.5t5.5 -45.5q0 -20 -4 -39t-13.5 -34t-25 -24.5t-37.5 -9.5q-49 0 -83 14q26 -55 26 -126q0 -59 -17.5 -106.5t-50 -81.5t-79 -52.5t-103.5 -18.5q-60 0 -107 19t-79.5 53t-49.5 82t-17 105q0 58 17.5 106t50.5 82t79.5 52.5t105.5 18.5 q91 0 154 -46q30 -22 54.5 -28.5t48.5 -6.5q29 0 38.5 19.5t9.5 43.5q0 17 -2.5 32t-6.5 24h70zM268 96q119 0 119 150q0 149 -119 149t-119 -149q0 -150 119 -150zM210 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE4",
    unicode: "\u1EE4",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM233 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE5",
    unicode: "\u1EE5",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM198 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE6",
    unicode: "\u1EE6",
    horizAdvX: 586,
    d: "M23 0zM416 664h142v-443q0 -121 -71 -182.5t-202 -61.5q-121 0 -191.5 58t-70.5 178v451h141v-438q0 -62 31 -98t88 -36q133 0 133 129v443zM264 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5 t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE7",
    unicode: "\u1EE7",
    horizAdvX: 500,
    d: "M26 0zM346 0v69q-50 -82 -153 -82q-37 0 -67.5 13t-52.5 37t-34.5 57t-12.5 74v324h130v-304q0 -92 83 -92q50 0 75.5 31.5t25.5 80.5v284h129v-492h-123zM223 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6 q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE8",
    unicode: "\u1EE8",
    horizAdvX: 748,
    d: "M23 0zM416 664h142v-73q14 -5 27.5 -6.5t22.5 -1.5q27 0 40 14t13 49q0 17 -2.5 32t-6.5 24h70q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26.5 -81.5t-67.5 -25.5q-44 0 -91 26v-321q0 -121 -71 -182.5t-200 -61.5q-123 0 -193.5 58t-70.5 178v451h141v-438q0 -62 30.5 -98 t95.5 -36q59 0 92.5 31.5t33.5 97.5v443zM232 726l-31 55l207 121l47 -82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE9",
    unicode: "\u1EE9",
    horizAdvX: 638,
    d: "M26 0zM187 554l-31 55l207 121l47 -82zM346 0v69q-26 -43 -65 -62.5t-85 -19.5q-39 0 -70 13t-53.5 37t-34.5 57t-12 74v324h130v-304q0 -92 82 -92q51 0 76.5 31t25.5 81v284h129v-64q11 -2 21.5 -3t16.5 -1q32 0 42 18t10 44q0 17 -2.5 32.5t-6.5 24.5h70 q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26 -81t-67 -25q-37 0 -79 18v-376h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEA",
    unicode: "\u1EEA",
    horizAdvX: 748,
    d: "M23 0zM416 664h142v-73q14 -5 27.5 -6.5t22.5 -1.5q27 0 40 14t13 49q0 17 -2.5 32t-6.5 24h70q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26.5 -81.5t-67.5 -25.5q-44 0 -91 26v-321q0 -121 -71 -182.5t-200 -61.5q-123 0 -193.5 58t-70.5 178v451h141v-438q0 -62 30.5 -98 t95.5 -36q59 0 92.5 31.5t33.5 97.5v443zM142 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEB",
    unicode: "\u1EEB",
    horizAdvX: 638,
    d: "M26 0zM95 648l47 82l207 -121l-31 -55zM346 0v69q-26 -43 -65 -62.5t-85 -19.5q-39 0 -70 13t-53.5 37t-34.5 57t-12 74v324h130v-304q0 -92 82 -92q51 0 76.5 31t25.5 81v284h129v-64q11 -2 21.5 -3t16.5 -1q32 0 42 18t10 44q0 17 -2.5 32.5t-6.5 24.5h70 q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26 -81t-67 -25q-37 0 -79 18v-376h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEC",
    unicode: "\u1EEC",
    horizAdvX: 748,
    d: "M23 0zM416 664h142v-73q14 -5 27.5 -6.5t22.5 -1.5q27 0 40 14t13 49q0 17 -2.5 32t-6.5 24h70q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26.5 -81.5t-67.5 -25.5q-44 0 -91 26v-321q0 -121 -71 -182.5t-200 -61.5q-123 0 -193.5 58t-70.5 178v451h141v-438q0 -62 30.5 -98 t95.5 -36q59 0 92.5 31.5t33.5 97.5v443zM276 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EED",
    unicode: "\u1EED",
    horizAdvX: 638,
    d: "M26 0zM346 0v69q-26 -43 -65 -62.5t-85 -19.5q-39 0 -70 13t-53.5 37t-34.5 57t-12 74v324h130v-304q0 -92 82 -92q51 0 76.5 31t25.5 81v284h129v-64q11 -2 21.5 -3t16.5 -1q32 0 42 18t10 44q0 17 -2.5 32.5t-6.5 24.5h70q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26 -81 t-67 -25q-37 0 -79 18v-376h-123zM224 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEE",
    unicode: "\u1EEE",
    horizAdvX: 748,
    d: "M23 0zM416 664h142v-73q14 -5 27.5 -6.5t22.5 -1.5q27 0 40 14t13 49q0 17 -2.5 32t-6.5 24h70q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26.5 -81.5t-67.5 -25.5q-44 0 -91 26v-321q0 -121 -71 -182.5t-200 -61.5q-123 0 -193.5 58t-70.5 178v451h141v-438q0 -62 30.5 -98 t95.5 -36q59 0 92.5 31.5t33.5 97.5v443zM467 846q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEF",
    unicode: "\u1EEF",
    horizAdvX: 638,
    d: "M26 0zM426 674q-17 -54 -47 -76t-62 -22q-19 0 -35.5 7t-31.5 15.5t-30 15.5t-31 7q-6 0 -18 -8t-21 -36l-69 37q16 49 41 68.5t56 19.5q23 0 41 -7.5t34 -16.5t30 -16.5t28 -7.5q9 0 22 10.5t18 36.5zM346 0v69q-26 -43 -65 -62.5t-85 -19.5q-39 0 -70 13t-53.5 37 t-34.5 57t-12 74v324h130v-304q0 -92 82 -92q51 0 76.5 31t25.5 81v284h129v-64q11 -2 21.5 -3t16.5 -1q32 0 42 18t10 44q0 17 -2.5 32.5t-6.5 24.5h70q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26 -81t-67 -25q-37 0 -79 18v-376h-123z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF0",
    unicode: "\u1EF0",
    horizAdvX: 748,
    d: "M23 0zM416 664h142v-73q14 -5 27.5 -6.5t22.5 -1.5q27 0 40 14t13 49q0 17 -2.5 32t-6.5 24h70q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26.5 -81.5t-67.5 -25.5q-44 0 -91 26v-321q0 -121 -71 -182.5t-200 -61.5q-123 0 -193.5 58t-70.5 178v451h141v-438q0 -62 30.5 -98 t95.5 -36q59 0 92.5 31.5t33.5 97.5v443zM235 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF1",
    unicode: "\u1EF1",
    horizAdvX: 638,
    d: "M26 0zM346 0v69q-26 -43 -65 -62.5t-85 -19.5q-39 0 -70 13t-53.5 37t-34.5 57t-12 74v324h130v-304q0 -92 82 -92q51 0 76.5 31t25.5 81v284h129v-64q11 -2 21.5 -3t16.5 -1q32 0 42 18t10 44q0 17 -2.5 32.5t-6.5 24.5h70q10 -11 15.5 -32.5t5.5 -46.5q0 -56 -26 -81 t-67 -25q-37 0 -79 18v-376h-123zM188 -206v124h130v-124h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 602,
    d: "M3 0zM233 0v251l-230 413h162l140 -270l129 270h160l-222 -415v-249h-139zM152 820l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 502,
    d: "M26 0zM339 65q-14 -33 -50.5 -51.5t-82.5 -18.5q-39 0 -72 12.5t-57 36t-37.5 56t-13.5 73.5v319h130v-300q0 -92 83 -92q45 0 72.5 26t27.5 66v300h130v-505q0 -52 -17.5 -93t-48 -69t-72 -43t-88.5 -15q-109 0 -163 55t-54 151h121q0 -44 25.5 -69t76.5 -25 q18 0 34 7.5t28.5 21t20 33.5t7.5 44v80zM95 648l47 82l207 -121l-31 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF6",
    unicode: "\u1EF6",
    horizAdvX: 602,
    d: "M3 0zM233 0v251l-230 413h162l140 -270l129 270h160l-222 -415v-249h-139zM274 753q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF7",
    unicode: "\u1EF7",
    horizAdvX: 502,
    d: "M26 0zM339 65q-14 -33 -50.5 -51.5t-82.5 -18.5q-39 0 -72 12.5t-57 36t-37.5 56t-13.5 73.5v319h130v-300q0 -92 83 -92q45 0 72.5 26t27.5 66v300h130v-505q0 -52 -17.5 -93t-48 -69t-72 -43t-88.5 -15q-109 0 -163 55t-54 151h121q0 -44 25.5 -69t76.5 -25 q18 0 34 7.5t28.5 21t20 33.5t7.5 44v80zM224 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 436,
    d: "M13 257v101h405v-101h-405z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 617,
    d: "M16 259v98h584v-98h-584z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 193,
    d: "M161 681q-38 -10 -57 -34t-20 -72h77v-135h-138v102q0 42 7 74t23 54.5t42.5 37.5t65.5 23v-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 193,
    d: "M24 450q38 10 57 34t20 72h-77v135h138v-102q0 -42 -7 -74t-23 -54.5t-42.5 -37.5t-65.5 -23v50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 204,
    d: "M40 -101q35 9 52.5 32.5t18.5 68.5h-71v129h127v-98q0 -40 -6.5 -70t-21 -51.5t-39 -35.5t-60.5 -22v47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 386,
    d: "M23 440zM354 681q-38 -10 -57 -34t-20 -72h77v-135h-138v102q0 42 7 74t23 54.5t42.5 37.5t65.5 23v-50zM161 681q-38 -10 -57 -34t-20 -72h77v-135h-138v102q0 42 7 74t23 54.5t42.5 37.5t65.5 23v-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 386,
    d: "M24 400zM24 450q38 10 57 34t20 72h-77v135h138v-102q0 -42 -7 -74t-23 -54.5t-42.5 -37.5t-65.5 -23v50zM219 450q38 10 57 34t20 72h-77v135h138v-102q0 -42 -7 -74t-23 -54.5t-42.5 -37.5t-65.5 -23v50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 408,
    d: "M40 0zM244 -101q35 9 52.5 32.5t18.5 68.5h-71v129h127v-98q0 -40 -6.5 -70t-21 -51.5t-39 -35.5t-60.5 -22v47zM40 -101q35 9 52.5 32.5t18.5 68.5h-71v129h127v-98q0 -40 -6.5 -70t-21 -51.5t-39 -35.5t-60.5 -22v47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 533,
    d: "M218 0v435h-183v80h183v149h102v-149h175v-80h-175v-435h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 533,
    d: "M320 149v-149h-100v149h-182v79h182v209h-182v78h182v149h100v-149h175v-78h-175v-209h175v-79h-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 422,
    d: "M371 343q0 -30 -12.5 -56t-34.5 -45t-51.5 -30t-63.5 -11q-35 0 -65 11t-52 30t-34.5 45t-12.5 56q0 31 12.5 57.5t34.5 45.5t52 29.5t65 10.5q34 0 63.5 -10.5t51.5 -29.5t34.5 -45.5t12.5 -57.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 936,
    d: "M23 0zM397 0v135h139v-135h-139zM772 0v135h139v-135h-139zM23 0v135h139v-135h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 857,
    d: "M19 0zM26 -20l461 704h68l-462 -704h-67zM450 31q24 0 35.5 28t11.5 96q0 69 -11.5 97.5t-35.5 28.5q-23 0 -35 -28t-12 -97t12 -97t35 -28zM448 -22q-54 0 -83.5 42.5t-29.5 136.5t29.5 135t83.5 41t84.5 -41t30.5 -134t-30.5 -136.5t-84.5 -43.5zM728 31q24 0 35.5 28 t11.5 96q0 69 -11.5 97.5t-35.5 28.5q-23 0 -35 -28t-12 -97t12 -97t35 -28zM726 -22q-54 0 -83.5 42.5t-29.5 136.5t29.5 135t83.5 41t84.5 -41t30.5 -134t-30.5 -136.5t-84.5 -43.5zM134 384q24 0 35.5 28t11.5 96q0 69 -11.5 97.5t-35.5 28.5q-23 0 -35 -28t-12 -97 t12 -97t35 -28zM132 331q-54 0 -83.5 42.5t-29.5 136.5t29.5 135t83.5 41t84.5 -41t30.5 -134t-30.5 -136.5t-84.5 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 232,
    d: "M13 317l143 174l63 -68l-94 -106l94 -105l-63 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 232,
    d: "M13 212l94 105l-94 106l63 68l143 -174l-143 -172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 133,
    d: "M-199 -20l461 704h68l-462 -704h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 275,
    d: "M23 331zM138 384q24 0 35.5 28t11.5 96q0 69 -11.5 97.5t-35.5 28.5q-23 0 -35 -28t-12 -97t12 -97t35 -28zM136 331q-54 0 -83.5 42.5t-29.5 136.5t29.5 135t83.5 41t84.5 -41t30.5 -134t-30.5 -136.5t-84.5 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 268,
    d: "M17 343zM147 583l-68 -117h68v117zM146 343v72h-129v57l121 203h73v-209h37v-51h-37v-72h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 275,
    d: "M28 331zM29 473l7 202h204v-55h-146l-3 -89q13 14 30 18.5t36 4.5q41 0 68.5 -27t27.5 -77q0 -54 -32 -86.5t-83 -32.5q-23 0 -42.5 7t-34.5 20t-23.5 31t-9.5 39h65q2 -20 13.5 -32t31.5 -12q27 0 38.5 17t11.5 46q0 26 -11.5 40.5t-34.5 14.5q-32 0 -46 -29h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 273,
    d: "M22 331zM138 384q23 0 34.5 18t11.5 45q0 29 -13 45.5t-34 16.5q-22 0 -36 -17t-14 -44q0 -29 13.5 -46.5t37.5 -17.5zM178 603q-3 31 -35 31q-27 0 -40.5 -25.5t-16.5 -79.5q12 14 27.5 22.5t40.5 8.5q40 0 67 -29t27 -81q0 -51 -30 -85t-79 -34q-117 0 -117 167 q0 100 30.5 144t93.5 44q40 0 65.5 -21.5t30.5 -61.5h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 269,
    d: "M17 343zM62 343q6 72 35 143t82 131h-162v58h232v-50q-56 -63 -86 -135t-34 -147h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 277,
    d: "M22 331zM137 385q26 0 37 14.5t11 40.5q0 23 -11.5 37.5t-36.5 14.5t-36 -14.5t-11 -37.5q0 -55 47 -55zM137 543q20 0 30.5 12.5t10.5 32.5t-10.5 32.5t-30.5 12.5t-30 -12.5t-10 -32.5t10 -32.5t30 -12.5zM203 524q23 -10 36 -33t13 -51q0 -48 -28 -78.5t-86 -30.5 t-87 30.5t-29 75.5q0 29 13 50.5t39 33.5q-20 11 -28.5 31.5t-8.5 41.5q0 40 28.5 66t72.5 26q49 0 74 -26t25 -64q0 -22 -7.5 -42t-26.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 273,
    d: "M22 331zM134 508q22 0 35.5 17t13.5 44q0 29 -13 46.5t-37 17.5q-23 0 -35 -18t-12 -45q0 -29 13 -45.5t35 -16.5zM93 414q2 -31 35 -31q50 0 56 105q-11 -14 -27 -22.5t-41 -8.5q-39 0 -66.5 29t-27.5 81q0 51 30 85t80 34q116 0 116 -167q0 -100 -30.5 -144t-92.5 -44 q-41 0 -66.5 21.5t-30.5 61.5h65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 275,
    d: "M138 31q24 0 35.5 28t11.5 96q0 69 -11.5 97.5t-35.5 28.5q-23 0 -35 -28t-12 -97t12 -97t35 -28zM136 -22q-54 0 -83.5 42.5t-29.5 136.5t29.5 135t83.5 41t84.5 -41t30.5 -134t-30.5 -136.5t-84.5 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 178,
    d: "M85 -10v229h-68v45q43 0 60 14.5t20 43.5h53v-332h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 262,
    d: "M17 -10q0 23 3.5 43t14.5 39.5t30.5 39.5t51.5 43q35 26 48 42t13 37q0 25 -13 34t-33 9q-22 0 -35 -12.5t-13 -46.5h-63q0 54 28.5 84.5t79.5 30.5t82 -24t31 -73q0 -19 -5 -34.5t-16.5 -30.5t-29.5 -30.5t-45 -34.5q-20 -14 -32.5 -30.5t-13.5 -29.5h143v-56h-226z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 269,
    d: "M107 184q42 0 54.5 13.5t12.5 32.5q0 51 -43 51q-19 0 -31.5 -14.5t-12.5 -40.5h-60q0 48 29.5 77.5t77.5 29.5q43 0 73 -25t30 -66q0 -23 -9.5 -43t-29.5 -31q23 -10 36 -30t13 -52q0 -51 -32 -79.5t-85 -28.5q-52 0 -80.5 29t-28.5 80h63q0 -55 49 -55q20 0 34 14.5 t14 40.5q0 29 -16.5 40.5t-57.5 11.5v45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 268,
    d: "M147 230l-68 -117h68v117zM146 -10v72h-129v57l121 203h73v-209h37v-51h-37v-72h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 275,
    d: "M29 120l7 202h204v-55h-146l-3 -89q13 14 30 18.5t36 4.5q41 0 68.5 -27t27.5 -77q0 -54 -32 -86.5t-83 -32.5q-23 0 -42.5 7t-34.5 20t-23.5 31t-9.5 39h65q2 -20 13.5 -32t31.5 -12q27 0 38.5 17t11.5 46q0 26 -11.5 40.5t-34.5 14.5q-32 0 -46 -29h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 273,
    d: "M138 31q23 0 34.5 18t11.5 45q0 29 -13 45.5t-34 16.5q-22 0 -36 -17t-14 -44q0 -29 13.5 -46.5t37.5 -17.5zM178 250q-3 31 -35 31q-27 0 -40.5 -25.5t-16.5 -79.5q12 14 27.5 22.5t40.5 8.5q40 0 67 -29t27 -81q0 -51 -30 -85t-79 -34q-117 0 -117 167q0 100 30.5 144 t93.5 44q40 0 65.5 -21.5t30.5 -61.5h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 269,
    d: "M62 -10q6 72 35 143t82 131h-162v58h232v-50q-56 -63 -86 -135t-34 -147h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 277,
    d: "M137 32q26 0 37 14.5t11 40.5q0 23 -11.5 37.5t-36.5 14.5t-36 -14.5t-11 -37.5q0 -55 47 -55zM137 190q20 0 30.5 12.5t10.5 32.5t-10.5 32.5t-30.5 12.5t-30 -12.5t-10 -32.5t10 -32.5t30 -12.5zM203 171q23 -10 36 -33t13 -51q0 -48 -28 -78.5t-86 -30.5t-87 30.5 t-29 75.5q0 29 13 50.5t39 33.5q-20 11 -28.5 31.5t-8.5 41.5q0 40 28.5 66t72.5 26q49 0 74 -26t25 -64q0 -22 -7.5 -42t-26.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 273,
    d: "M134 155q22 0 35.5 17t13.5 44q0 29 -13 46.5t-37 17.5q-23 0 -35 -18t-12 -45q0 -29 13 -45.5t35 -16.5zM93 61q2 -31 35 -31q50 0 56 105q-11 -14 -27 -22.5t-41 -8.5q-39 0 -66.5 29t-27.5 81q0 51 30 85t80 34q116 0 116 -167q0 -100 -30.5 -144t-92.5 -44 q-41 0 -66.5 21.5t-30.5 61.5h65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 724,
    d: "M441 0l-71 381h-19l-71 -381h-101l-84 381h-85v56h73l-17 76h-56v56h44l-21 95h115l18 -95h122l16 95h113l17 -95h126l19 95h110l-21 -95h46v-56h-58l-17 -76h75v-56h-87l-82 -381h-104zM458 437h76l15 76h-105zM192 437h74l12 76h-101zM495 234l28 147h-55zM232 234 l24 147h-53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AA",
    unicode: "\u20AA",
    horizAdvX: 624,
    d: "M125 551v-551h-99v664h173q63 0 110 -4.5t78 -24.5t46 -61t15 -114v-289h-98v291q0 50 -25 69.5t-65 19.5h-135zM511 112v552h99v-664h-173q-64 0 -111 4t-78 24t-46 60.5t-15 114.5v289h99v-291q0 -50 24 -69.5t65 -19.5h136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dong",
    unicode: "\u20AB",
    horizAdvX: 540,
    d: "M313 110v50q-19 -32 -47 -46.5t-64 -14.5q-38 0 -69.5 15t-54.5 43.5t-36 69.5t-13 93q0 46 11 85t32 67.5t51.5 44t69.5 15.5q73 0 118 -64v101h-121v59h121v44h104v-44h94v-59h-94v-459h-102zM226 187q38 0 63.5 33t25.5 85q0 134 -88 134q-91 0 -91 -127q0 -55 25 -90 t65 -35zM31 0v59h448v-59h-448z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 616,
    d: "M602 101q-38 -58 -100.5 -91t-140.5 -33q-52 0 -99.5 14.5t-86 43.5t-66.5 72t-42 100h-58l18 76h28q-1 10 -1 20v21v17t1 15h-46l18 78h37q32 119 105 185.5t194 66.5q50 0 92 -13t81 -37l-64 -117q-20 24 -49.5 35.5t-58.5 11.5q-57 0 -97 -34.5t-59 -97.5h219l-41 -78 h-192q0 -20 0.5 -41t2.5 -32h149l-41 -76h-89q21 -52 56.5 -80.5t83.5 -28.5q92 0 130 68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AD",
    unicode: "\u20AD",
    horizAdvX: 596,
    d: "M345 297l245 -297h-166l-206 273v-273h-133v297h-79v98h79v269h133v-246l198 246h161l-220 -269h208v-98h-220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AE",
    unicode: "\u20AE",
    horizAdvX: 554,
    d: "M343 355v-86l106 47v-83l-106 -46v-187h-135v130l-114 -49v82l114 49v85l-114 -48v82l114 49v171h-201v113h538v-113h-202v-114l106 47v-83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B1",
    unicode: "\u20B1",
    horizAdvX: 576,
    d: "M512 345q-20 -73 -73 -110.5t-132 -37.5h-127v-197h-131v345h-44v53h44v54h-44v53h44v159h258q81 0 135 -41t72 -118h54v-53h-47q1 -6 1 -11.5v-11.5q0 -8 -0.5 -15.5t-1.5 -15.5h48v-53h-56zM407 427q0 6 -0.5 12.5t-1.5 12.5h-225v-54h225q1 7 1.5 14t0.5 15zM180 505 h209q-14 25 -36 39t-51 14h-122v-53zM302 294q29 0 50.5 13.5t35.5 37.5h-208v-51h122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B2",
    unicode: "\u20B2",
    horizAdvX: 658,
    d: "M72 -78l65 121q-59 51 -90.5 127.5t-31.5 162.5q0 73 21 137.5t62 112.5t102 75.5t142 27.5q34 0 65 -5.5t60 -16.5l37 70h108l-201 -377h222v-357h-115l-3 66q-24 -42 -77 -65.5t-122 -23.5q-53 0 -98 18l-38 -73h-108zM157 327q0 -42 11 -84.5t34 -76.5l208 391 q-33 14 -68 14q-84 0 -134.5 -62.5t-50.5 -181.5zM352 246l-75 -141q30 -11 64 -11t63.5 12t51.5 33t34.5 48.5t12.5 58.5h-151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 563,
    d: "M163 215q-5 -17 -5 -35q0 -42 27.5 -69t87.5 -27q91 0 120 71h110q-11 -87 -70.5 -132.5t-158.5 -45.5q-108 0 -164 52.5t-56 146.5q0 21 3 39h-42v80h78q18 19 42 31.5t50.5 21t53.5 15t52 14.5h-276v80h369q2 8 3.5 16t1.5 19q0 42 -22 67t-75 25q-48 0 -75 -21 t-36 -55h-104q16 84 72.5 131t146.5 47q50 0 87.5 -15t62 -41t37 -61.5t12.5 -76.5q0 -11 -0.5 -19.5t-1.5 -15.5h54v-80h-86q-29 -38 -72.5 -54.5t-93.5 -27.5h252v-80h-384z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 488,
    d: "M181 0v357h-169v104h464v-104h-168v-357h-127zM12 566v98h464v-98h-464z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 534,
    d: "M439 381q-9 -90 -63 -140.5t-142 -55.5l123 -185h-164l-125 194v106h144q35 0 56.5 23.5t29.5 57.5h-286v105h282q-10 30 -29.5 51.5t-48.5 21.5h-204v105h512v-105h-128q24 -27 37 -73h91v-105h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BA",
    unicode: "\u20BA",
    horizAdvX: 584,
    d: "M299 110q54 0 90.5 32t47.5 86h136q-23 -105 -92 -166.5t-178 -61.5h-236v195l-62 -26v82l62 26v86l-62 -26v82l62 26v219h132v-162l161 70v-83l-161 -69v-86l161 70v-83l-161 -69v-142h100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BC",
    unicode: "\u20BC",
    horizAdvX: 658,
    d: "M394 664v-165q69 -5 115.5 -21.5t75 -44.5t41 -68t12.5 -91v-274h-134v261q0 54 -25 86t-85 43v-390h-129v390q-60 -11 -84.5 -43.5t-24.5 -86.5v-260h-136v272q0 51 13 91t42 68.5t75.5 45.5t114.5 22v165h129z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BD",
    unicode: "\u20BD",
    horizAdvX: 534,
    d: "M203 92v-92h-136v92h-57v99h57v53h-57v99h57v321h248q100 0 157.5 -55t57.5 -156q0 -106 -60.5 -157.5t-165.5 -51.5h-101v-53h145v-99h-145zM306 343q49 0 77 28.5t28 76.5q0 46 -28 75.5t-77 29.5h-103v-210h103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BE",
    unicode: "\u20BE",
    horizAdvX: 652,
    d: "M437 679q51 -8 86.5 -26.5t59 -47.5t36.5 -68.5t20 -90.5h-125q-4 53 -22 82t-55 42v-182h-69v193q-5 1 -11 1h-11q-28 0 -50 -3v-191h-68v174q-40 -19 -56 -55.5t-16 -96.5q0 -56 13 -101t40 -82.5t68 -69t98 -59.5v-98h-348v107h185q-92 50 -144.5 127t-52.5 193 q0 104 49 167t164 83v59h68v-51q11 0 21.5 0.5t21.5 0.5h14.5t14.5 -1v51h69v-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "litre",
    unicode: "\u2113",
    horizAdvX: 362,
    d: "M267 -12q-8 -2 -16 -3.5t-19 -1.5q-51 0 -83.5 28.5t-50.5 76.5q-44 -23 -96 -39v73q42 16 79 36q-4 23 -5.5 48.5t-1.5 52.5q0 44 5 91.5t15 93t25.5 86t37 71t49 48.5t61.5 18q45 0 66.5 -33.5t21.5 -108.5q0 -47 -9.5 -99.5t-31.5 -104.5t-58.5 -101.5t-91.5 -89.5 q10 -31 27 -51t46 -20q5 0 13.5 1t16.5 3v-75zM148 273q0 -32 3 -68q40 34 64.5 72t38 77t18.5 77t5 73t-5.5 52.5t-25.5 17.5q-26 0 -44.5 -27.5t-30.5 -71t-17.5 -97t-5.5 -105.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2116",
    unicode: "\u2116",
    horizAdvX: 977,
    d: "M23 0zM436 0l-284 446v-446h-129v664h147l264 -427v427h130v-664h-128zM781.176 364.048q90.3027 0 90.3027 112.21q0 112.209 -90.3027 112.209q-88.9346 0 -88.9346 -112.209q0 -112.21 88.9346 -112.21zM781.176 281.943q-90.3027 0 -140.243 54.0527 q-49.9404 54.0518 -49.9404 140.262q0 88.9463 51.3086 142.314q51.3086 53.3672 138.875 53.3672t138.19 -52.6836q50.625 -52.6836 50.625 -142.998q0 -87.5781 -50.625 -140.946q-50.624 -53.3682 -138.19 -53.3682z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2117",
    unicode: "\u2117",
    horizAdvX: 673,
    d: "M333 -9q-66 0 -123.5 27t-101 73.5t-68.5 108.5t-25 133q0 70 25 132.5t68.5 108.5t101 73t123.5 27t124 -27t101 -73t68 -108.5t25 -132.5q0 -71 -25 -133t-68 -108.5t-101 -73.5t-124 -27zM335 44q55 0 104 22.5t85.5 61.5t58 91.5t21.5 112.5q0 59 -21.5 111.5t-58 92 t-85.5 62.5t-104 23q-56 0 -105 -23t-85 -62.5t-57 -92t-21 -111.5q0 -60 21 -112.5t57 -91.5t85 -61.5t105 -22.5zM355 342q29 0 41.5 14t12.5 35q0 20 -12.5 32.5t-41.5 12.5h-64v-94h64zM224 172v320h141q47 0 75 -30t28 -74t-28 -72t-75 -28h-74v-116h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 466,
    d: "M81 407v206h-66v51h184v-51h-64v-206h-54zM389 407v142l-55 -142l-61 148v-147h-51v256h62l49 -132l48 132h60v-257h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 628,
    d: "M19 0zM26 -20l461 704h68l-462 -704h-67zM87 343v229h-68v45q43 0 60 14.5t20 43.5h53v-332h-65zM471 184q42 0 54.5 13.5t12.5 32.5q0 51 -43 51q-19 0 -31.5 -14.5t-12.5 -40.5h-60q0 48 29.5 77.5t77.5 29.5q43 0 73 -25t30 -66q0 -23 -9.5 -43t-29.5 -31 q23 -10 36 -30t13 -52q0 -51 -32 -79.5t-85 -28.5q-52 0 -80.5 29t-28.5 80h63q0 -55 49 -55q20 0 34 14.5t14 40.5q0 29 -16.5 40.5t-57.5 11.5v45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 645,
    d: "M19 0zM57 -20l461 704h68l-462 -704h-67zM19 343q0 23 3.5 43t14.5 39.5t30.5 39.5t51.5 43q35 26 48 42t13 37q0 25 -13 34t-33 9q-22 0 -35 -12.5t-13 -46.5h-63q0 54 28.5 84.5t79.5 30.5t82 -24t31 -73q0 -19 -5 -34.5t-16.5 -30.5t-29.5 -30.5t-45 -34.5 q-20 -14 -32.5 -30.5t-13.5 -29.5h143v-56h-226zM488 184q42 0 54.5 13.5t12.5 32.5q0 51 -43 51q-19 0 -31.5 -14.5t-12.5 -40.5h-60q0 48 29.5 77.5t77.5 29.5q43 0 73 -25t30 -66q0 -23 -9.5 -43t-29.5 -31q23 -10 36 -30t13 -52q0 -51 -32 -79.5t-85 -28.5 q-52 0 -80.5 29t-28.5 80h63q0 -55 49 -55q20 0 34 14.5t14 40.5q0 29 -16.5 40.5t-57.5 11.5v45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 633,
    d: "M19 0zM24 -20l461 704h68l-462 -704h-67zM87 343v229h-68v45q43 0 60 14.5t20 43.5h53v-332h-65zM501 32q26 0 37 14.5t11 40.5q0 23 -11.5 37.5t-36.5 14.5t-36 -14.5t-11 -37.5q0 -55 47 -55zM501 190q20 0 30.5 12.5t10.5 32.5t-10.5 32.5t-30.5 12.5t-30 -12.5 t-10 -32.5t10 -32.5t30 -12.5zM567 171q23 -10 36 -33t13 -51q0 -48 -28 -78.5t-86 -30.5t-87 30.5t-29 75.5q0 29 13 50.5t39 33.5q-20 11 -28.5 31.5t-8.5 41.5q0 40 28.5 66t72.5 26q49 0 74 -26t25 -64q0 -22 -7.5 -42t-26.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 644,
    d: "M19 0zM60 -20l461 704h68l-462 -704h-67zM513 32q26 0 37 14.5t11 40.5q0 23 -11.5 37.5t-36.5 14.5t-36 -14.5t-11 -37.5q0 -55 47 -55zM513 190q20 0 30.5 12.5t10.5 32.5t-10.5 32.5t-30.5 12.5t-30 -12.5t-10 -32.5t10 -32.5t30 -12.5zM579 171q23 -10 36 -33t13 -51 q0 -48 -28 -78.5t-86 -30.5t-87 30.5t-29 75.5q0 29 13 50.5t39 33.5q-20 11 -28.5 31.5t-8.5 41.5q0 40 28.5 66t72.5 26q49 0 74 -26t25 -64q0 -22 -7.5 -42t-26.5 -30zM105 537q42 0 54.5 13.5t12.5 32.5q0 51 -43 51q-19 0 -31.5 -14.5t-12.5 -40.5h-60q0 48 29.5 77.5 t77.5 29.5q43 0 73 -25t30 -66q0 -23 -9.5 -43t-29.5 -31q23 -10 36 -30t13 -52q0 -51 -32 -79.5t-85 -28.5q-52 0 -80.5 29t-28.5 80h63q0 -55 49 -55q20 0 34 14.5t14 40.5q0 29 -16.5 40.5t-57.5 11.5v45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 631,
    d: "M19 0zM49 -20l461 704h68l-462 -704h-67zM20 473l7 202h204v-55h-146l-3 -89q13 14 30 18.5t36 4.5q41 0 68.5 -27t27.5 -77q0 -54 -32 -86.5t-83 -32.5q-23 0 -42.5 7t-34.5 20t-23.5 31t-9.5 39h65q2 -20 13.5 -32t31.5 -12q27 0 38.5 17t11.5 46q0 26 -11.5 40.5 t-34.5 14.5q-32 0 -46 -29h-67zM500 32q26 0 37 14.5t11 40.5q0 23 -11.5 37.5t-36.5 14.5t-36 -14.5t-11 -37.5q0 -55 47 -55zM500 190q20 0 30.5 12.5t10.5 32.5t-10.5 32.5t-30.5 12.5t-30 -12.5t-10 -32.5t10 -32.5t30 -12.5zM566 171q23 -10 36 -33t13 -51 q0 -48 -28 -78.5t-86 -30.5t-87 30.5t-29 75.5q0 29 13 50.5t39 33.5q-20 11 -28.5 31.5t-8.5 41.5q0 40 28.5 66t72.5 26q49 0 74 -26t25 -64q0 -22 -7.5 -42t-26.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 637,
    d: "M19 0zM40 -20l461 704h68l-462 -704h-67zM506 32q26 0 37 14.5t11 40.5q0 23 -11.5 37.5t-36.5 14.5t-36 -14.5t-11 -37.5q0 -55 47 -55zM506 190q20 0 30.5 12.5t10.5 32.5t-10.5 32.5t-30.5 12.5t-30 -12.5t-10 -32.5t10 -32.5t30 -12.5zM572 171q23 -10 36 -33t13 -51 q0 -48 -28 -78.5t-86 -30.5t-87 30.5t-29 75.5q0 29 13 50.5t39 33.5q-20 11 -28.5 31.5t-8.5 41.5q0 40 28.5 66t72.5 26q49 0 74 -26t25 -64q0 -22 -7.5 -42t-26.5 -30zM64 343q6 72 35 143t82 131h-162v58h232v-50q-56 -63 -86 -135t-34 -147h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 572,
    d: "M408 273q-7 10 -21 20t-32 17.5t-39.5 12t-43.5 4.5q-112 0 -112 -113q0 -65 35 -93.5t90 -28.5q24 0 46 10.5t39 32.5t27.5 56.5t10.5 81.5zM57 636q24 21 75.5 35.5t123.5 14.5q59 0 111 -16.5t91 -58.5t62 -114.5t23 -185.5q0 -66 -13 -126.5t-44.5 -106.5t-85 -73.5 t-134.5 -27.5q-58 0 -103 17.5t-76 49t-47 75.5t-16 98q0 109 63.5 166t174.5 57q17 0 36.5 -3t38 -8.5t35.5 -14.5t29 -21q0 46 -11.5 79.5t-31.5 56t-46.5 33.5t-55.5 11q-54 0 -89.5 -9t-65.5 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 598,
    d: "M435 -233v805h-279v-805h-113v897h506v-897h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 526,
    d: "M29 -182v79l174 344l-174 344v79h463v-108h-303l150 -315l-150 -316h303v-107h-463z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 523,
    d: "M23 296v94h471v-94h-471z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 584,
    d: "M214 0l-109 287h-87v79h201l57 -201l145 499h139l-221 -664h-125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 669,
    d: "M332 260q-21 -39 -57.5 -62t-92.5 -23q-30 0 -56 10.5t-45.5 31t-30.5 51.5t-11 72q0 42 11.5 73.5t31 52t45.5 31t55 10.5q57 0 91 -23t59 -63q25 40 59 63t91 23q29 0 55 -10.5t45.5 -31t31 -52t11.5 -73.5q0 -41 -11 -72t-30.5 -51.5t-45.5 -31t-56 -10.5 q-56 0 -92.5 23t-57.5 62zM292 337q-17 32 -38.5 52.5t-54.5 20.5q-37 0 -55.5 -19.5t-18.5 -50.5q0 -72 74 -72q36 0 58.5 21t34.5 48zM372 337q12 -27 34.5 -48t58.5 -21q74 0 74 72q0 31 -18.5 50.5t-55.5 19.5q-33 0 -54.5 -20.5t-38.5 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 461,
    d: "M43 -233v112h57q26 0 40 19t14 61v530q0 51 16 86t43 56.5t63.5 31t77.5 9.5h57v-112h-57q-26 0 -40 -19t-14 -61v-530q0 -51 -16 -86t-43 -56.5t-63.5 -31t-77.5 -9.5h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 555,
    d: "M25 94zM525 431q-32 -35 -67 -51t-81 -16q-30 0 -57.5 9t-54 20t-52.5 20t-52 9q-42 0 -74 -19t-62 -57v101q22 26 54 46.5t78 20.5q36 0 66.5 -9t57.5 -19.5t52 -19.5t50 -9q42 0 76.5 16.5t65.5 58.5v-101zM525 179q-32 -35 -67 -51t-81 -16q-30 0 -57.5 9t-54 20 t-52.5 20t-52 9q-42 0 -74 -19t-62 -57v101q22 26 54 46.5t78 20.5q36 0 66.5 -9t57.5 -19.5t52 -19.5t50 -9q42 0 76.5 16.5t65.5 58.5v-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 523,
    d: "M-6 -20l141 216h-112v94h174l69 106h-243v94h305l127 194h68l-128 -194h99v-94h-160l-70 -106h230v-94h-291l-142 -216h-67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 523,
    d: "M23 0zM23 296v94l471 200v-104l-365 -143l365 -143v-104zM23 -29v94h471v-94h-471z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 523,
    d: "M23 0zM23 -29v94h471v-94h-471zM23 96v104l365 143l-365 143v104l471 -200v-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotmath",
    unicode: "\u22C5",
    horizAdvX: 187,
    d: "M23 265zM23 265v135h139v-135h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 555,
    d: "M213 0l-171 332l171 332h137l162 -332l-162 -332h-137zM385 332l-105 213l-106 -213l106 -212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE000",
    unicode: "\uE000",
    horizAdvX: 664,
    d: "M894 -14q0 -55 -15 -96t-41.5 -68.5t-62 -41t-76.5 -13.5q-44 0 -80 14.5t-62 41t-40 63t-14 81.5v81q-29 -38 -76 -54.5t-101 -16.5q-74 0 -131.5 27.5t-97.5 75t-61 112t-21 139.5q0 74 21 139t62 113t101.5 75.5t139.5 27.5q60 0 111.5 -16.5t90.5 -46t63 -71.5 t28 -93h-140q-3 24 -16 44.5t-33.5 35.5t-47 23.5t-56.5 8.5q-41 0 -74.5 -16.5t-57.5 -47t-37 -75t-13 -100.5q0 -57 13.5 -101t37.5 -74.5t57 -46.5t73 -16q36 0 66 12t52 33t34.5 48.5t12.5 58.5h-147v111h277v-384q0 -51 21 -71t49 -20q32 0 51 25t19 79h121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE001",
    unicode: "\uE001",
    horizAdvX: 523,
    d: "M258 98q56 0 83.5 39.5t27.5 108.5q0 42 -9.5 71t-25 47.5t-35.5 26.5t-40 8q-48 0 -79.5 -40.5t-31.5 -116.5q0 -66 27 -105t83 -39zM364 -233v297q-55 -77 -146 -77q-48 0 -85.5 18.5t-63.5 52.5t-39.5 81t-13.5 103q0 61 16 110t44 83t67 52t86 18q92 0 137 -73l1 60 h125v-725h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE002",
    unicode: "\uE002",
    horizAdvX: 464,
    d: "M247 280l82 -83l-82 -84l-225 228l225 227l82 -83l-82 -82h189v-123h-189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE003",
    unicode: "\uE003",
    horizAdvX: 465,
    d: "M127 197l83 83h-187v123h187l-83 82l83 83l227 -227l-227 -228z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE004",
    unicode: "\uE004",
    horizAdvX: 1111,
    d: "M763 0v548h-140v116h480v-116h-201v-548h-139zM894 -14q0 -55 -15 -96t-41.5 -68.5t-62 -41t-76.5 -13.5q-44 0 -80 14.5t-62 41t-40 63t-14 81.5v81q-29 -38 -76 -54.5t-101 -16.5q-74 0 -131.5 27.5t-97.5 75t-61 112t-21 139.5q0 74 21 139t62 113t101.5 75.5 t139.5 27.5q60 0 111.5 -16.5t90.5 -46t63 -71.5t28 -93h-140q-3 24 -16 44.5t-33.5 35.5t-47 23.5t-56.5 8.5q-41 0 -74.5 -16.5t-57.5 -47t-37 -75t-13 -100.5q0 -57 13.5 -101t37.5 -74.5t57 -46.5t73 -16q36 0 66 12t52 33t34.5 48.5t12.5 58.5h-147v111h277v-384 q0 -51 21 -71t49 -20q32 0 51 25t19 79h121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE005",
    unicode: "\uE005",
    horizAdvX: 574,
    d: "M310 153q-21 -42 -43.5 -71.5t-51.5 -47.5t-67 -26t-90 -8h-34v118h34q30 0 51.5 4.5t38 15.5t29.5 29t26 45l19 38l-216 414h147l135 -279l137 279h143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE006",
    unicode: "\uE006",
    horizAdvX: 295,
    d: "M65 492v131h124v-131h102v-90h-102v-237q0 -31 16 -47t45 -16h33v-102h-67q-77 0 -114 38.5t-37 110.5v253h-58v90h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "\uFB01",
    horizAdvX: 472,
    d: "M77 0v400h-73v92h73q0 85 50 132.5t149 47.5h169v-121h-150q-24 0 -41 -1t-28 -7t-16 -18t-5 -33h84v-92h-84v-400h-128zM315 0v492h130v-492h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "\uFB02",
    horizAdvX: 474,
    d: "M315 0v400h-110v-400h-128v400h-73v92h73q0 180 209 180v-105q-25 0 -40.5 -3.5t-24.5 -12.5t-12.5 -23.5t-3.5 -35.5h110v180h130v-672h-130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflexhook",
    horizAdvX: 537,
    d: "M382 581q0 17 5 30.5t20 22.5q11 6 17 12t6 18q0 17 -24 17q-8 0 -18 -3t-23 -12l-18 55q15 13 35.5 19t34.5 6q35 0 54.5 -16.5t19.5 -44.5q0 -21 -9 -33.5t-20.5 -22t-20.5 -20t-9 -28.5h-50zM206 672l-116 -101l-40 44l110 115h91l110 -115l-39 -44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breveacute",
    horizAdvX: 321,
    d: "M273 668q0 -29 -9.5 -50t-25 -35.5t-36 -21.5t-41.5 -7t-41 7t-35.5 21.5t-25 35.5t-9.5 50h57q0 -29 14.5 -44.5t39.5 -15.5q26 0 40 15.5t15 44.5h57zM133 644l-18 33l119 69l27 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevetilde",
    horizAdvX: 322,
    d: "M253 736q-6 -28 -21 -41t-32 -13q-10 0 -18.5 3.5t-16.5 7.5t-16.5 7.5t-17.5 3.5q-5 0 -8.5 -4.5t-8.5 -18.5l-37 18q8 25 21 35t30 10q10 0 18.5 -3.5t17 -8t17 -8t18.5 -3.5q12 0 15 25zM273 668q0 -29 -9.5 -50t-25 -35.5t-35.5 -21.5t-41 -7t-41.5 7t-36 21.5 t-25 35.5t-9.5 50h57q1 -29 15 -44.5t40 -15.5q25 0 39.5 15.5t14.5 44.5h57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevehook",
    horizAdvX: 321,
    d: "M273 668q0 -29 -9.5 -50t-25 -35.5t-35.5 -21.5t-41 -7t-41.5 7t-36 21.5t-25 35.5t-9.5 50h57q1 -29 15 -44.5t40 -15.5q25 0 39.5 15.5t14.5 44.5h57zM136 623q0 13 4 23t15 17q8 5 12.5 9t4.5 13q0 13 -18 13q-13 0 -31 -11l-13 40q11 10 26 14.5t26 4.5 q26 0 40.5 -12.5t14.5 -32.5q0 -16 -7 -25t-15 -16.5t-15 -15.5t-7 -21h-37z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflexacute",
    horizAdvX: 640,
    d: "M205 672l-116 -101l-39 44l110 115h91l110 -115l-40 -44zM389 584l-25 46l171 100l39 -68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecircumflex",
    horizAdvX: 639,
    d: "M444 672l-116 -101l-40 44l110 115h91l110 -115l-39 -44zM579 662l39 68l171 -100l-25 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevegrave",
    horizAdvX: 321,
    d: "M273 668q0 -29 -9.5 -50t-25 -35.5t-35.5 -21.5t-41 -7t-41.5 7t-36 21.5t-25 35.5t-9.5 50h57q1 -29 15 -44.5t40 -15.5q25 0 39.5 15.5t14.5 44.5h57zM62 699l27 47l119 -69l-18 -33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".ttfautohint",
    horizAdvX: 321,
    d: "M0 0z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "J",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF6",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF2",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAE",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAA",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E85",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E84",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E83",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E82",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E81",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E80",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E6C",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04B3",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04B2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04A0",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0497",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0436",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u042A",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u040B",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0402",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u03B3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u039B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0394",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0237",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0178",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0176",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0175",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0174",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0164",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0162",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0104",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0102",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0100",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xDD",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "x",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "w",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "j",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Y",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "W",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "T",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "J",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0237",
    k: -224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "j",
    k: -224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0427",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "f",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "V",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "1",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\uE005",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u042F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "f",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "V",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "7",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "3",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "1",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0427",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "f",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "1",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE004",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE001",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE000",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2026",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u201E",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u201A",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2014",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2013",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EEF",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EED",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EEB",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE3",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE0",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDF",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDE",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDD",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDC",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDB",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDA",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED9",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED8",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED7",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED5",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED4",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED3",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED0",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECF",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECE",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECD",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECC",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC7",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC5",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC3",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBF",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBD",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBB",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB9",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB7",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB6",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB4",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB2",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB0",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAF",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAE",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAD",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAC",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAB",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAA",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA9",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA8",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA7",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA6",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA4",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA2",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA0",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E93",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E85",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E83",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E81",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E63",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E62",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E5B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E4B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E45",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E13",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E0D",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0512",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04EF",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04E9",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04E8",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04C8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04C4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04AB",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04AA",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04A3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04A1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u049B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0498",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0497",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0491",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045E",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0454",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0453",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044A",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0449",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0448",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0446",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0442",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0439",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0438",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0433",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0432",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042D",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u041B",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0409",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0404",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03CD",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03CC",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C6",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C4",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C3",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C2",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B5",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B3",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AD",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AC",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u039B",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0398",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0272",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0237",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F5",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F4",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01E7",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01E6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01DD",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01B0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01A1",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01A0",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017C",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0177",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0175",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0173",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0171",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016F",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016D",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016B",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0169",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0161",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0160",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015F",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015E",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015A",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0159",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0157",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0155",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0153",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0152",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0151",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0150",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014F",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014E",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014D",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014C",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0148",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0146",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0144",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0123",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0122",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0121",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0120",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011F",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011E",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011B",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0119",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0117",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0115",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0113",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0111",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010F",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010D",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010C",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010B",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010A",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0107",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0106",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0105",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0104",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0103",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0102",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0101",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0100",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFD",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFB",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF8",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF6",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF5",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF4",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF3",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF2",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEB",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEA",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE9",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE8",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE7",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE6",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE5",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE4",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE3",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE2",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE1",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE0",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD8",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD6",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD5",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD4",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC6",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC5",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC4",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC2",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC1",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "z",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "y",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "x",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "w",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "u",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "s",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "r",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "q",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "p",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "o",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "n",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "m",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "j",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "g",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "e",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "d",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "c",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "a",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "S",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "Q",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "O",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "G",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "C",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "A",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: ".",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "-",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: ",",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "f",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "J",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "&",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u2026",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ".",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ",",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2014",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2013",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "-",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201C",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u2019",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u2018",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ".",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ",",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "'",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\"",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201D",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201C",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2019",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2018",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "'",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\"",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2026",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201A",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ".",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ",",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2026",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201E",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201D",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201C",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201A",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2019",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2018",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ".",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ",",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "'",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\"",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\uE002",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2039",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2026",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201E",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201A",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2014",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2013",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB6",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB4",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB2",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB0",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EAE",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EAC",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EAA",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA8",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA6",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA4",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA2",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA0",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u039B",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0394",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0104",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0102",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0100",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC6",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC5",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC4",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC2",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC1",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xAB",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "A",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "-",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "7",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2026",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201D",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201C",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2019",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2018",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2014",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2013",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ".",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "-",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "'",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\"",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u2026",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ".",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ",",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0237",
    k: -164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u01F5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u01E7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0123",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0121",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u011F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "j",
    k: -164
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "g",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0427",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0417",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "J",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\uE005",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "/",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE004",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE001",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE000",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201E",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201A",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EEF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EED",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB6",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB5",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB4",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB2",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB1",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB0",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAF",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAE",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAD",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAC",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAB",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAA",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA9",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA8",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA6",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA5",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA4",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA2",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA1",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA0",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E93",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E6C",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E63",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E5B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E4B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E45",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E13",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E0D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04EF",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04E9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04E8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04C8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04C4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04AB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04A3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04A0",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u049B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0499",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0491",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045E",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0454",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0453",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0449",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0446",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0439",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0438",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0437",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0433",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u042A",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u040B",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0404",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0402",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03CD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03CC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03BA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u039B",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0398",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0394",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0272",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0237",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01E7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01E6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01DD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01B0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01A1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01A0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017E",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017C",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0177",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0173",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0171",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0169",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0164",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0162",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0161",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015F",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015B",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0159",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0157",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0155",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0152",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0150",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0148",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0146",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0144",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0123",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0122",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0121",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0120",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0111",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010F",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0106",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "z",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "y",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "j",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "T",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "Q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "O",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "G",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 181
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u2026",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u201E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u201A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EB6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EB4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EB2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EB0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EAE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EAC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EAA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EA8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EA6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EA4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EA0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u039B",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0394",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0104",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0102",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0100",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: ".",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "B",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\uE006",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "?",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "&",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\uE006",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "?",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201E",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2014",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2013",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EF6",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EF2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB6",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB4",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB2",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB0",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAE",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAD",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAC",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAA",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA8",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA6",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA4",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA2",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA0",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E92",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E84",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E82",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E80",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E63",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04B2",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0496",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0416",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u039B",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0394",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01F5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01E7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u017D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u017B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0179",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0178",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0176",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0174",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0161",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0123",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0121",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0105",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0103",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0101",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xDD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Z",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Y",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "W",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "-",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uE005",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03BB",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B6",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\uE006",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 171
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "/",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE004",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE003",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE002",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE001",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE000",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2014",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2013",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF7",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF3",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EEF",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EED",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EEB",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE9",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE7",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDF",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDD",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDC",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDA",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED6",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED5",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECF",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECE",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECD",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECC",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC5",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBF",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBD",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB7",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB6",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB5",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB4",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB3",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB2",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB1",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB0",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAF",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAE",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAD",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAC",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAB",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAA",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA9",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA8",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA7",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA6",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA5",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA4",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA3",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA2",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA1",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA0",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E93",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E85",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E83",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E81",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E63",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E62",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E5B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E4B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E45",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E13",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E0D",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04EF",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04E9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04E8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04C8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04C4",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04B3",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04AB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04AA",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04A3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u049B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0499",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0497",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0491",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045F",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045E",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045C",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045A",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0454",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0453",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044E",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044D",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044C",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0449",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0448",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0446",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043F",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043C",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0439",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0438",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0437",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0436",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0433",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0432",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0404",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03CD",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03CC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C8",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C6",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C2",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03BA",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B7",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B5",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AE",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AD",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u039B",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0398",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0394",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0272",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F9",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F5",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01E7",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01E6",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01DD",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01B0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01A1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01A0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017E",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017C",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017A",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0177",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0175",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0173",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0171",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016F",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016D",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0161",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0160",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015F",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015B",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0157",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0155",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0152",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0151",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0150",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014F",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014D",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0148",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0146",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0144",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0123",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0122",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0121",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0120",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011F",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011E",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011B",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0117",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0115",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0113",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0111",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010F",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010D",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010B",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010A",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0107",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0103",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0102",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0101",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0100",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "z",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "w",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "s",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "n",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "d",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "S",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 176
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "f",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\uE006",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "?",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "/",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "&",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\uE006",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0427",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0417",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03C7",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03B8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03A8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03A6",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "J",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "?",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "&",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03C7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03C1",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03BB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03B8",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03B6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03A9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 179
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "/",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "&",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0237",
    k: -228
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "j",
    k: -228
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\uE006",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\uE006",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "]",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ";",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ":",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u0237",
    k: -221
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -221
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0237",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "j",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "\u0237",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "j",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u2026",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u201E",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u201A",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u1EF7",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u1EF3",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u1E5B",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u1E4B",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u1E45",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u04EF",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u04C8",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u04C4",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u04A3",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u049B",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0491",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u045F",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u045E",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u045D",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u045C",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u045A",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0453",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u044E",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u044C",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u044B",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0449",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0448",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0446",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u043F",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u043D",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u043C",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0439",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0438",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0433",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0432",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u03BA",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u03B7",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u03AE",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0272",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0237",
    k: -330
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u01F9",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u01F5",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u01E7",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0177",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0159",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0157",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0155",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u014B",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0148",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0146",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0144",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0123",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0121",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u011F",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\xFD",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\xF1",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "y",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "r",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "p",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "n",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "m",
    k: -75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -330
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "g",
    k: -83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: ".",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: ",",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "l",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "f",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u03BB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "f",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "?",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03B6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03B6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0431",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0237",
    k: -214
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "j",
    k: -214
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0237",
    k: -230
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "j",
    k: -230
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u042F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "V",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\uE005",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "/",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03C7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03C1",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03BB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03B8",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03B6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03A9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "J",
    k: 179
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "/",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "&",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\uE006",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\uE005",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "/",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "\uE006",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\uE005",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "/",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "\uE006",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\uE005",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "/",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\uE006",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\uE006",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "?",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "&",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\uE006",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "V",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "?",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\uE006",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "V",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "?",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "\u03BB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "\u03BB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u03BB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\uE006",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "f",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "?",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\uE006",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "f",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "?",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\uE006",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "f",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "?",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "J",
    k: 171
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "/",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "J",
    k: 171
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "/",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\uE006",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "?",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "/",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "&",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03B6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03C7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03C1",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03BB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03B8",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03B6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03A9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "J",
    k: 179
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "/",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "&",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03C7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03C1",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03BB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03B8",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03B6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03A9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "J",
    k: 179
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "/",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "&",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01E6",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01E6",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F9",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F9",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u024C",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u024C",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0272",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0272",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03C7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03C1",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03BB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03B8",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03B6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03A9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "J",
    k: 179
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "/",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "&",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038F",
    u2: "\u03B6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0512",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u041B",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0414",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0409",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03A6",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1E6C",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0512",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u04B2",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u04A0",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0496",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u042A",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u041B",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0416",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0414",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u040B",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0409",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0402",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0164",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0162",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "X",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "T",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0427",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0417",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB6",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB4",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB2",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB0",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAE",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAC",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAA",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA6",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA4",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA2",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA0",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04B2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0496",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0416",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u039B",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0394",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0104",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0102",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0100",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC6",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC5",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC4",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC2",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC1",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "X",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "A",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03BB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03B6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A9",
    u2: "\u03B6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AC",
    u2: "\u03C7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "\uE006",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AF",
    u2: "\u03C7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B1",
    u2: "\u03C7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03B6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "\uE006",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EF1",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EEF",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EED",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EEB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE7",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE5",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E85",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E83",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E81",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E5B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E4B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E45",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04C8",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04C4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04A3",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u049B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0491",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045F",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045C",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0453",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044E",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044C",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0449",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0448",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0446",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043F",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043D",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043C",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0439",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0438",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0433",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0432",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CE",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CD",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CA",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C9",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C8",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C5",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03BA",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B9",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B7",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B3",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AF",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AE",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0272",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01F9",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01B0",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0175",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0173",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0171",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016F",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016D",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016B",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0169",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0159",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0157",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0155",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0148",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0146",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0144",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFC",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFB",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFA",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF9",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "w",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "v",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "u",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "r",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "p",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "n",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "m",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03BB",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B8",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B9",
    u2: "\u03C7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BA",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\uE001",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ECF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ECD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EB9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E85",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E83",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E81",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E13",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E0D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04E9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04AB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04A1",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0454",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u044A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0442",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B3",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01DD",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01A1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0175",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0153",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0151",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u014F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u014D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u011B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0119",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0117",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0115",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0113",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0111",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0107",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF6",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF2",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xEB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xEA",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "w",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "v",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "q",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "o",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "e",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "d",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "c",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C7",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\uE002",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u2039",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xAB",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E85",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E83",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E81",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0175",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "w",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03BB",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u04A1",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u044A",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0442",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C4",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\uE001",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EE3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EE1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDF",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDD",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDB",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED9",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ECF",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ECD",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBF",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBD",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBB",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EB9",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1E13",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1E0D",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u04E9",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u04AB",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0454",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03CC",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03B5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03B1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03AD",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03AC",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u01DD",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u01A1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0153",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0151",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u014F",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u014D",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u011B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0119",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0117",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0115",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0113",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0111",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010F",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010D",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0107",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF8",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF6",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xEB",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xEA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE9",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE8",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE7",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "q",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "o",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "e",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "d",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "c",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\uE001",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EE3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EE1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDF",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ECF",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ECD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBF",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EB9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1E13",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1E0D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u04E9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u04AB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0454",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CA",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AF",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u01DD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u01A1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0153",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0151",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u014F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u014D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u011B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0119",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0117",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0115",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0113",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0111",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010D",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0107",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xEB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xEA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "q",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "o",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "e",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "d",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "c",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03BB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B6",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C9",
    u2: "\u03C7",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C9",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CA",
    u2: "\u03C7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CE",
    u2: "\u03C7",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CE",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\uE005",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "/",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0427",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0417",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "?",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0427",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0417",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "?",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\uE006",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "?",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "&",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1E6C",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B2",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04A0",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0498",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0496",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042D",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0164",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0162",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "X",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "T",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0417",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0427",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u03A6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "?",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\uE006",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0427",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0417",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03C7",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03B8",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03B6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03A8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03A6",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "J",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "?",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "&",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0427",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0417",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u03BB",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "J",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0427",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u03A6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "?",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0427",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u03A6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "?",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0417",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "?",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0417",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "?",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0513",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B3",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04A1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0497",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0459",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u043B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0436",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u03C4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "x",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0447",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0513",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B3",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04A1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0497",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0459",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u044A",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u043B",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0436",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0434",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u03C4",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "x",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u03BB",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "/",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0447",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0431",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u03BB",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0447",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0447",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0447",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0447",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u03BB",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "/",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\uE006",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0447",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0447",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u03BB",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "/",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0427",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u03A6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "?",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0447",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0427",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u03A6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "?",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0447",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "\uE006",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "?",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "&",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A1",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u0427",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u03A6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "?",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0447",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\uE005",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "/",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\uE006",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0427",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u03A6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "?",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0447",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u0427",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u03A6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "?",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0447",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0431",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E25",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E25",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "\uE006",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "V",
    k: 162
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "?",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E45",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E45",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E4B",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E4B",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "\u03BB",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\uE006",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "V",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "f",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "?",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "J",
    k: 171
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "/",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\uE006",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "?",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "/",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "&",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03B6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\uE006",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "?",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "/",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "&",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03B6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\uE006",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "?",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "/",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "&",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03C1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03B6",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u201D",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u201C",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2019",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2018",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EF6",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EF2",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E84",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E82",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E80",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E6C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u04B2",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u04A0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0496",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u042A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0416",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u040B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0402",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u039B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0394",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0178",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0176",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0174",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0164",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0162",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0104",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0102",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0100",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xDD",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "Y",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "W",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "T",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "'",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\"",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "J",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA1",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA1",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA3",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA3",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA5",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA5",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA7",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA7",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA9",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA9",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAB",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAB",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAD",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAD",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAF",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAF",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB1",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB1",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB3",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB3",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB5",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB5",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\uE006",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u0427",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03A8",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "V",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "J",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "?",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB7",
    u2: "f",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB7",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\uE005",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u042F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "/",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\uE006",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03C7",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "?",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "/",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03C7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03C1",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03BB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03B8",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03B6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03A9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "J",
    k: 179
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "/",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "&",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03C7",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03C1",
    k: 157
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03BB",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03B8",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03B6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03A9",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "J",
    k: 179
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "/",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "&",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\uE005",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u042F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "f",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "V",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "7",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "3",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "1",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\uE005",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u042F",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "f",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "V",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "7",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "3",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "1",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "J",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0427",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "f",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "1",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "J",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0427",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "f",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "1",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u0427",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "f",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "V",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "J",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "6",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "4",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "3",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "1",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u042F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "V",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1EF7",
    k: -200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1EF6",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1EF3",
    k: -200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1EF2",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E92",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E84",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E82",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E80",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E6C",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E5B",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E4B",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E45",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u04EF",
    k: -200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u04C8",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u04C4",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u04A3",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u04A0",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u049B",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0491",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u045F",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u045E",
    k: -200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u045D",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u045C",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u045A",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0453",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u044E",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u044C",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u044B",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0449",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0448",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0446",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u043F",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u043D",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u043C",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0439",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0438",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0433",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0432",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u042A",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u040B",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0402",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u03BA",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u03B7",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u03AE",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0272",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0237",
    k: -340
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u01F9",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u01F5",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u01E7",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u017D",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u017B",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0179",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0178",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0177",
    k: -200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0176",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0174",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0164",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0162",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0159",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0157",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0155",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u014B",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0148",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0146",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0144",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0123",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0121",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u011F",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\xFD",
    k: -200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\xF1",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\xDD",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "y",
    k: -200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "r",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "p",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "n",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "m",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "j",
    k: -340
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "g",
    k: -92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "Z",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "Y",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "W",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "T",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "V",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "\u042F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "V",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "J",
    k: 171
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "/",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE004",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE001",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE000",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2026",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u201E",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u201A",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2014",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2013",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF7",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF3",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EEF",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EED",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EEB",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE9",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE7",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE5",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE3",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE1",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE0",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDF",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDE",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDD",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDC",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDB",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDA",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED9",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED8",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED7",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED6",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED5",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED4",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED3",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED1",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED0",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECF",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECE",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECD",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECC",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC7",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC5",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC3",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC1",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBF",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBD",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBB",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB9",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB7",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB6",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB4",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB2",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB1",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB0",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAF",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAE",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAD",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAC",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAB",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAA",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA9",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA8",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA7",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA6",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA4",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA2",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA1",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA0",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E93",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E85",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E83",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E81",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E63",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E62",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E5B",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E4B",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E45",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E13",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E0D",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0512",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04EF",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04E9",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04E8",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04C8",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04C4",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04B3",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04AB",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04AA",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04A3",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04A1",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u049B",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0498",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0497",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0491",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045F",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045E",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045D",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045C",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045A",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0454",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0453",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044E",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044C",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044B",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044A",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0449",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0448",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0446",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0442",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043F",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043D",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043C",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0439",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0438",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0436",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0433",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0432",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u042D",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u041B",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0414",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0409",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0404",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03CD",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03CC",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C8",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C6",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C5",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C4",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C3",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C2",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03BA",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B7",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B5",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B3",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B1",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AE",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AD",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AC",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u039B",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0398",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0394",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0272",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F9",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F4",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01E6",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01DD",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01B0",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01A1",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01A0",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u018F",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017E",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017C",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0177",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0175",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0173",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0171",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016F",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016D",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016B",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0169",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0161",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0160",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015F",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015B",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0159",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0157",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0155",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0153",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0152",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0151",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0150",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014F",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014D",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014B",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0148",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0146",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0144",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0122",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0120",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011E",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011B",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0119",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0117",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0115",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0113",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0111",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010F",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010D",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010B",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010A",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0107",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0106",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0105",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0104",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0103",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0102",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0101",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0100",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFD",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFC",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFB",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFA",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF9",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF8",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF6",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF5",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF4",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF3",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF2",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF1",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF0",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xEB",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xEA",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE9",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE8",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE7",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE6",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE5",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE4",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE3",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE2",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE1",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE0",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD8",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD6",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD5",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD4",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD3",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD2",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC7",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC6",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC5",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC4",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC2",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC1",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "z",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "y",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "x",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "w",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "v",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "u",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "s",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "r",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "q",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "p",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "o",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "n",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "m",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "e",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "d",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "c",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "a",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "S",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "Q",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "O",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "G",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "C",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "A",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: ".",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "-",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: ",",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u042F",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "J",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE006",
    u2: "\u0237",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE006",
    u2: "j",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE006",
    u2: "f",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB01",
    u2: "\uE006",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB01",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB01",
    u2: "]",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB01",
    u2: ";",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB01",
    u2: ":",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB02",
    u2: "\uE006",
    k: -16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB02",
    u2: "}",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB02",
    u2: "]",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB02",
    u2: ";",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB02",
    u2: ":",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 169
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "hyphen,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 153
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "j,dotlessj",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "uni042D,uni0498",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "iotatonos,iota,iotadieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "uni0437,uni044D,uni0499",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "j,dotlessj",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "uni042D,uni0498",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "hyphen,endash,emdash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "j,dotlessj",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "uni042D,uni0498",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "j,dotlessj",
    k: -62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "hyphen,endash,emdash",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "uni042D,uni0498",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "uni0437,uni044D,uni0499",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 182
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "hyphen,endash,emdash",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 182
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "j,dotlessj",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "hyphen,endash,emdash",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "j,dotlessj",
    k: -70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "j,dotlessj",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "hyphen,endash,emdash",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "j,dotlessj",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni0437,uni044D,uni0499",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 173
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 139
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "j,dotlessj",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,endash,emdash",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "hyphen,endash,emdash",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "uni042D,uni0498",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "iotatonos,iota,iotadieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "uni0437,uni044D,uni0499",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "omega,omegatonos",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "hyphen,endash,emdash",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni042D,uni0498",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "iotatonos,iota,iotadieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni0437,uni044D,uni0499",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 134
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "omega,omegatonos",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "hyphen,endash,emdash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "j,dotlessj",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "hyphen,endash,emdash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "j,dotlessj",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j,ij,dotlessj",
    g2: "j,dotlessj",
    k: -209
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "hyphen,endash,emdash",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "j,dotlessj",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "j,dotlessj",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "hyphen,endash,emdash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "j,dotlessj",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "guillemotright,guilsinglright,uniE003",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "hyphen,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "hyphen,endash,emdash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "omega,omegatonos",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "hyphen,endash,emdash",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "j,dotlessj",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "omega,omegatonos",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "j,dotlessj",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "hyphen,endash,emdash",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "j,dotlessj",
    k: -233
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "uni042D,uni0498",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 168
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "j,dotlessj",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni042D,uni0498",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "hyphen,endash,emdash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "j,dotlessj",
    k: -73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "uni042D,uni0498",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "j,dotlessj",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 26
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolveticaRgRegular);
export default __webpack_public_path__ + "static/media/CoolveticaRg-Regular.8ea508494b8a54d316c8535af0b7f68e.svg";
export { ForwardRef as ReactComponent };